var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444, _path1445, _path1446, _path1447, _path1448, _path1449, _path1450, _path1451, _path1452, _path1453, _path1454, _path1455, _path1456, _path1457, _path1458, _path1459, _path1460, _path1461, _path1462, _path1463, _path1464, _path1465, _path1466, _path1467, _path1468, _path1469, _path1470, _path1471, _path1472, _path1473, _path1474, _path1475, _path1476, _path1477, _path1478, _path1479, _path1480, _path1481, _path1482, _path1483, _path1484, _path1485, _path1486, _path1487, _path1488, _path1489, _path1490, _path1491, _path1492, _path1493, _path1494, _path1495, _path1496, _path1497, _path1498, _path1499, _path1500, _path1501, _path1502, _path1503, _path1504, _path1505, _path1506, _path1507, _path1508, _path1509, _path1510, _path1511, _path1512, _path1513, _path1514, _path1515, _path1516, _path1517, _path1518, _path1519, _path1520, _path1521, _path1522, _path1523, _path1524, _path1525, _path1526, _path1527, _path1528, _path1529, _path1530, _path1531, _path1532, _path1533, _path1534, _path1535, _path1536, _path1537, _path1538, _path1539, _path1540, _path1541, _path1542, _path1543, _path1544, _path1545, _path1546, _path1547, _path1548, _path1549, _path1550, _path1551, _path1552, _path1553, _path1554, _path1555, _path1556, _path1557, _path1558, _path1559, _path1560, _path1561, _path1562, _path1563, _path1564, _path1565, _path1566, _path1567, _path1568, _path1569, _path1570, _path1571, _path1572, _path1573, _path1574, _path1575, _path1576, _path1577, _path1578, _path1579, _path1580, _path1581, _path1582, _path1583, _path1584, _path1585, _path1586, _path1587, _path1588, _path1589, _path1590, _path1591, _path1592, _path1593, _path1594, _path1595, _path1596, _path1597, _path1598, _path1599, _path1600, _path1601, _path1602, _path1603, _path1604, _path1605, _path1606, _path1607, _path1608, _path1609, _path1610, _path1611, _path1612, _path1613, _path1614, _path1615, _path1616, _path1617, _path1618, _path1619, _path1620, _path1621, _path1622, _path1623, _path1624, _path1625, _path1626, _path1627, _path1628, _path1629, _path1630, _path1631, _path1632, _path1633, _path1634, _path1635, _path1636, _path1637, _path1638, _path1639, _path1640, _path1641, _path1642, _path1643, _path1644, _path1645, _path1646, _path1647, _path1648, _path1649, _path1650, _path1651, _path1652, _path1653, _path1654, _path1655, _path1656, _path1657, _path1658, _path1659, _path1660, _path1661, _path1662, _path1663, _path1664, _path1665, _path1666, _path1667, _path1668, _path1669, _path1670, _path1671, _path1672, _path1673, _path1674, _path1675, _path1676, _path1677, _path1678, _path1679, _path1680, _path1681, _path1682, _path1683, _path1684, _path1685, _path1686, _path1687, _path1688, _path1689, _path1690, _path1691, _path1692, _path1693, _path1694, _path1695, _path1696, _path1697, _path1698, _path1699, _path1700, _path1701, _path1702, _path1703, _path1704, _path1705, _path1706, _path1707, _path1708, _path1709, _path1710, _path1711, _path1712, _path1713, _path1714, _path1715, _path1716, _path1717, _path1718, _path1719, _path1720, _path1721, _path1722, _path1723, _path1724, _path1725, _path1726, _path1727, _path1728, _path1729, _path1730, _path1731, _path1732, _path1733, _path1734, _path1735, _path1736, _path1737, _path1738, _path1739, _path1740, _path1741, _path1742, _path1743, _path1744, _path1745, _path1746, _path1747, _path1748, _path1749, _path1750, _path1751, _path1752, _path1753, _path1754, _path1755, _path1756, _path1757, _path1758, _path1759, _path1760, _path1761, _path1762, _path1763, _path1764, _path1765, _path1766, _path1767, _path1768, _path1769, _path1770, _path1771, _path1772, _path1773, _path1774, _path1775, _path1776, _path1777, _path1778, _path1779, _path1780, _path1781, _path1782, _path1783, _path1784, _path1785, _path1786, _path1787, _path1788, _path1789, _path1790, _path1791, _path1792, _path1793, _path1794, _path1795, _path1796, _path1797, _path1798, _path1799, _path1800, _path1801, _path1802, _path1803, _path1804, _path1805, _path1806, _path1807, _path1808, _path1809, _path1810, _path1811, _path1812, _path1813, _path1814, _path1815, _path1816, _path1817, _path1818, _path1819, _path1820, _path1821, _path1822, _path1823, _path1824, _path1825, _path1826, _path1827, _path1828, _path1829, _path1830, _path1831, _path1832, _path1833, _path1834, _path1835, _path1836, _path1837, _path1838, _path1839, _path1840, _path1841, _path1842, _path1843, _path1844, _path1845, _path1846, _path1847, _path1848, _path1849, _path1850, _path1851, _path1852, _path1853, _path1854, _path1855, _path1856, _path1857, _path1858, _path1859, _path1860, _path1861, _path1862, _path1863, _path1864, _path1865, _path1866, _path1867, _path1868, _path1869, _path1870, _path1871, _path1872, _path1873, _path1874, _path1875, _path1876, _path1877, _path1878, _path1879, _path1880, _path1881, _path1882, _path1883, _path1884, _path1885, _path1886, _path1887, _path1888, _path1889, _path1890, _path1891, _path1892, _path1893, _path1894, _path1895, _path1896, _path1897, _path1898, _path1899, _path1900, _path1901, _path1902, _path1903, _path1904, _path1905, _path1906, _path1907, _path1908, _path1909, _path1910, _path1911, _path1912, _path1913, _path1914, _path1915, _path1916, _path1917, _path1918, _path1919, _path1920, _path1921, _path1922, _path1923, _path1924, _path1925, _path1926, _path1927, _path1928, _path1929, _path1930, _path1931, _path1932, _path1933, _path1934, _path1935, _path1936, _path1937, _path1938, _path1939, _path1940, _path1941, _path1942, _path1943, _path1944, _path1945, _path1946, _path1947, _path1948, _path1949, _path1950, _path1951, _path1952, _path1953, _path1954, _path1955, _path1956, _path1957, _path1958, _path1959, _path1960, _path1961, _path1962, _path1963, _path1964, _path1965, _path1966, _path1967, _path1968, _path1969, _path1970, _path1971, _path1972, _path1973, _path1974, _path1975, _path1976, _path1977, _path1978, _path1979, _path1980, _path1981, _path1982, _path1983, _path1984, _path1985, _path1986, _path1987, _path1988, _path1989, _path1990, _path1991, _path1992, _path1993, _path1994, _path1995, _path1996, _path1997, _path1998, _path1999, _path2000, _path2001, _path2002, _path2003, _path2004, _path2005, _path2006, _path2007, _path2008, _path2009, _path2010, _path2011, _path2012, _path2013, _path2014, _path2015, _path2016, _path2017, _path2018, _path2019, _path2020, _path2021, _path2022, _path2023, _path2024, _path2025, _path2026, _path2027, _path2028, _path2029, _path2030, _path2031, _path2032, _path2033, _path2034, _path2035, _path2036, _path2037, _path2038, _path2039, _path2040, _path2041, _path2042, _path2043, _path2044, _path2045, _path2046, _path2047, _path2048, _path2049, _path2050, _path2051, _path2052, _path2053, _path2054, _path2055, _path2056, _path2057, _path2058, _path2059, _path2060, _path2061, _path2062, _path2063, _path2064, _path2065, _path2066, _path2067, _path2068, _path2069, _path2070, _path2071, _path2072, _path2073, _path2074, _path2075, _path2076, _path2077, _path2078, _path2079, _path2080, _path2081, _path2082, _path2083, _path2084, _path2085, _path2086, _path2087, _path2088, _path2089, _path2090, _path2091, _path2092, _path2093, _path2094, _path2095, _path2096, _path2097, _path2098, _path2099, _path2100, _path2101, _path2102, _path2103, _path2104, _path2105, _path2106, _path2107, _path2108, _path2109, _path2110, _path2111, _path2112, _path2113, _path2114, _path2115, _path2116, _path2117, _path2118, _path2119, _path2120, _path2121, _path2122, _path2123, _path2124, _path2125, _path2126, _path2127, _path2128, _path2129, _path2130, _path2131, _path2132, _path2133, _path2134, _path2135, _path2136, _path2137, _path2138, _path2139, _path2140, _path2141, _path2142, _path2143, _path2144, _path2145, _path2146, _path2147, _path2148, _path2149, _path2150, _path2151, _path2152, _path2153, _path2154, _path2155, _path2156, _path2157, _path2158, _path2159, _path2160, _path2161, _path2162, _path2163, _path2164, _path2165, _path2166, _path2167, _path2168, _path2169, _path2170, _path2171, _path2172, _path2173, _path2174, _path2175, _path2176, _path2177, _path2178, _path2179, _path2180, _path2181, _path2182, _path2183, _path2184, _path2185, _path2186, _path2187, _path2188, _path2189, _path2190, _path2191, _path2192, _path2193, _path2194, _path2195, _path2196, _path2197, _path2198, _path2199, _path2200, _path2201, _path2202, _path2203, _path2204, _path2205, _path2206, _path2207, _path2208, _path2209, _path2210, _path2211, _path2212, _path2213, _path2214, _path2215, _path2216, _path2217, _path2218, _path2219, _path2220, _path2221, _path2222, _path2223, _path2224, _path2225, _path2226, _path2227, _path2228, _path2229, _path2230, _path2231, _path2232, _path2233, _path2234, _path2235, _path2236, _path2237, _path2238, _path2239, _path2240, _path2241, _path2242, _path2243, _path2244, _path2245, _path2246, _path2247, _path2248, _path2249, _path2250, _path2251, _path2252, _path2253, _path2254, _path2255, _path2256, _path2257, _path2258, _path2259, _path2260, _path2261, _path2262, _path2263, _path2264, _path2265, _path2266, _path2267, _path2268, _path2269, _path2270, _path2271, _path2272, _path2273, _path2274, _path2275, _path2276, _path2277, _path2278, _path2279, _path2280, _path2281, _path2282, _path2283, _path2284, _path2285, _path2286, _path2287, _path2288, _path2289, _path2290, _path2291, _path2292, _path2293, _path2294, _path2295, _path2296, _path2297, _path2298, _path2299, _path2300, _path2301, _path2302, _path2303, _path2304, _path2305, _path2306, _path2307, _path2308, _path2309, _path2310, _path2311, _path2312, _path2313, _path2314, _path2315, _path2316, _path2317, _path2318, _path2319, _path2320, _path2321, _path2322, _path2323, _path2324, _path2325, _path2326, _path2327, _path2328, _path2329, _path2330, _path2331, _path2332, _path2333, _path2334, _path2335, _path2336, _path2337, _path2338, _path2339, _path2340, _path2341, _path2342, _path2343, _path2344, _path2345;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWineBottle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    baseProfile: "full",
    height: 128,
    width: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58 32h1v1h2v-1h2v-1h1v2h2v-2h1v2h1v-1h3v3h1v1h-1v2h-2v1h-4v-2h-3v1h-1v2h-1v1h-3v-7h1zm14 78v1h-3v-1zm-3-80v1h-2v-1h1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61 31v1h-2v-1h1zm-6 30v-1h2v1h-1zm1 49h1v1h-2v-1zm11-80h-1v-1h1zM57 43v-1h1v1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70 111h1v8h-1v-2h-1v1h-1v-3h2v-1zm-13 8h1v3h1v2h-2zm7-81v3h-2v-3zm-8 73h1v3h-1zm-1-56h1v2h-1v-1zm13-13v-1h1v1zM56 54h-1v-1h1z",
    fill: "#040404"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64 33v-2h2v2zm8 0v1h1v1h-2v-2zm-4 28v-1h3v1zm-9-30v-1h2v1h-1zm7 9v-1h2v1h-1zm-7 2h-2v-1h2zm3-12h-1v-1h1zm0 0h1v1h-1zm-4 14h-1v-1h1zm-2 2h1v1h-1zm2 15h-1v-1h1zm-4 50v-1h1v1z",
    fill: "#010000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54 113h1v7h-1v-4zm4-58h1v5h-1v-2zm7 67v1h-3v-1zM54 60v-2h1v2zm13 55h-1v-2h1v1zM56 40v-1h1v1zm10 78v-1h1v1zm-1 3v-1h1v1z",
    fill: "#090806"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62 119h2v-7h1v8h-1v1h-2zm-2-8h1v3h-1v-1zm-3-69h-1v-2h1v1zm14-11h-1v-1h1z",
    fill: "#0c0b09"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64 60h-3v-5h2v-1h-1v-1h2z",
    fill: "#110d0c"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56 120v-6h1v8h-1v-1h-1v-1zm-1-67v-1h1v-2h1v3zm10-14v1h-1v-2h1zm-3 1v1h-1v-1z",
    fill: "#030303"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63 118h-1v-7h1v1zm-3-64h1v6h-1v-1zm4-1h-2v-1h2zm1 1h-1v-1h1z",
    fill: "#0f0b0a"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M79 51h1v7h-1v-2zm0 64h-1v-4h1v1zm-5-74h1v1h-1zm2 13h1v1h-1z",
    fill: "#75716e"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M70 115h-1v-4h1v1zm2-4v4h-1v-4zm0 7h-1v-2h1v1zm-8-77v-1h1v1zm-8 13v1h-1v-1z",
    fill: "#030404"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M61 48h-1v-2h1v-1h1v2h-1zm2-2v-1h-1v-1h2v2zm6 8v3h-1v-3zm-2-1v-1h1v1zm-6 8h-1v-1h1z",
    fill: "#090504"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M68 60h-1v-7h1v4zm-8-12h1v1h-1zm-1 2h1v1h-1zm8 2h-1v-1h1zm-3 9v-1h1v1zm2 58h1v1h-1z",
    fill: "#0a0605"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M64 50v1h1v2h-1v-1h-3v-2zm1 3h1v4h-1v-1z",
    fill: "#0e0a09"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M75 96v-1h1v-1h2v1h-1v1h-1zm4-4v-1h1v2h-1zm-3 1v-1h1v1zm-1 0h1v1h-1zm1 5v-1h1v1zm3 2h1v1h-1zm1 3v1h-1v-1zm-9 6v-1h1v1z",
    fill: "#efeeec"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M57 36h-1v-3h1v1zm-1 15h-1v-2h2v1h-1zm7-13h-1v-1h2v1zm8-7v1h-1v-1zm-10 9v-1h1v1zm4 0h1v1h-1z",
    fill: "#020202"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M56 53h1v7h-1v-3zm2 66h-1v-2h1v1zm7-77h-1v-1h1zm-4 3h-1v-1h1z",
    fill: "#050304"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M76 55h1v5h-1zm4 63v1h-1v-5h1zm0-59v1h-1v-1z",
    fill: "#74706d"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M78 101v-3h1v3zm-2-38h1v1h-2v-1zm0 7v1h-2v-1h1zm-4-8v1h-1v-1zm3 3h-1v-1h1zm3 29v-1h1v1zm1 10v1h-1v-1z",
    fill: "#f2f2f0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M78 95v-1h1v4h-1zm-5-33v1h-1v-1zm5 1v1h-1v-1zm-3 2v-1h1v1zm4 4h-1v-1h1zm-3 1h1v1h-1zm3 1v-1h1v1zm0 33h-1v-1h1z",
    fill: "#f3f3f1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M63 63v2h-2v-1h-1v1h-2v-1h1v-1zm-9 1v-1h2v1h-1zm-1 6v1h-1v-1z",
    fill: "#e6e7e2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M48 65v-1h1v4h-1zm5 31v2h-2v-1h1v-1zm-2-1h1v1h-1zm0 3v1h-1v-1zm6 11h-1v-1h1zm6-1v1h-1v-1z",
    fill: "#dfdeda"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M57 117v-5h1v5zm-1-80h1v1h-1zm6 6h-1v-1h1zm7 69v1h-1v-1zm0 7h-1v-1h1zm-14 2h1v1h-1z",
    fill: "#050404"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M59 44v1h-1v-3h1v-1h1v3zm7-3v-1h2v1h-1zm2-2h1v1h-1zm-11 6v1h-1v-1z",
    fill: "#020001"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M64 46v-2h1v1h1v2h-1v-1zm3 2h1v4h-1v-1zm-1-1h1v1h-1zm2 74v-1h1v1z",
    fill: "#080403"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M78 60h-1v-5h1zm0-11h1v4h-1v-2zm0 70v1h-1v-1z",
    fill: "#777370"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M70 63h1v1h-2v-1zm-3 0v-1h1v1zm9 9v1h-1v-1zm-3 2v-1h1v1zm2 1v-1h1v1zm2-1h1v1h-1zm3 2v1h-1v-1zm-1 12h-1v-1h1zm-4 6h-1v-1h1z",
    fill: "#ececea"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M45 68h1v5h-1v-1zm0 7h1v3h-1zm0 4h1v2h-1v-1z",
    fill: "#666",
    fillOpacity: 0.078
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M65 112h-1v-1h2v6h-1zm-2 10h-1v-1h2v1zm2-1h-1v-1h1z",
    fill: "#0b0a08"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M56 60h-1v-3h1v1zm-1 54v-3h1v3zm5 11h-2v-1h2zm-1-93h-1v-1h1z",
    fill: "#040403"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M48 107h-1v-6h1zm7-65v-1h1v1zm-3 9h1v1h-1zm-4 48v1h-1v-1z",
    fill: "#24231f"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M68 64v-1h1v2h-2v-1zm9 8h1v1h-2v-1zM66 62h1v1h-1zm6 3h1v1h-1zm8 11h-1v-1h1zm-1 1h-1v-1h1z",
    fill: "#ebebe9"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M51 95v1h1v1h-1v1h-1v-3zm11 14h-2v-1h2zM48 63h1v1h-1zm4 37v1h-1v-1zm3 8h1v1h-1z",
    fill: "#e0dfdb"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M75 73h-1v-2h3v1h-2zm-4-9v-1h1v1zm6 2h1v1h-1zm0 8v1h-1v-1zm2 1v-1h1v1zm0 31h1v1h-1z",
    fill: "#ededeb"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M52 76v1h-1v1h-1v-2zm8-11v1h-1v-1zM50 75v-1h1v1zm-1 5v-1h1v1zm1 9h1v1h-1zm-1 2v-1h1v1zm7 1v-1h1v1z",
    fill: "#d6d7d2"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M50 86h2v2h-2zm5-16v-1h1v1zm-3 13h1v1h-1zm-3 6h1v1h-1zm1 2v-1h1v1zm0 1v1h-1v-1z",
    fill: "#d1d2cd"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M55 98h-1v-1h2v1zm4 11h-2v-1h2zm-1-34v-1h1v1zm-1 21v1h-1v-1zm-2 3v1h-1v-1zm-4 8v-1h1v1zm13 1v-1h1v1z",
    fill: "#dcdbd7"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M46 104h-1v-9h1z",
    fill: "#626262",
    fillOpacity: 0.051
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M56 120h-1v-6h1zm15-88h1v1h-1zM56 52h-1v-1h1z",
    fill: "#030302"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M55 113h-1v-2h1v1zm18-79h-1v-1h1zm-17 9v-1h1v1zm14 9v1h-1v-1zm-5 67v-1h1v1zm-11 2v-1h1v1zm10 1v-1h1v1z",
    fill: "#0a0907"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M59 119h-1v-7h1v1zm-3-73v1h-1v-1z",
    fill: "#070506"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M78 60v-6h1v6zm1 59h-1v-2h1v1z",
    fill: "#76726f"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M73 63h1v1h-1v1h-3v-1h2v-1zm-3-1v1h-1v-1zm10 11v1h-1v-1zm-1 18h-1v-1h1z",
    fill: "#efefed"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M52 64v-1h2v1h-1zm12 0h-1v-1h2v1zm-9 1v-1h1v1zm3-1v1h-1v-1zm2 0h1v1h-1zm-6 7v-1h1v1z",
    fill: "#e7e8e3"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M50 80v-1h1v2h-1zm6 13h1v2h-1v-1zm-3-27h-1v-1h1zm-1 11v1h-1v-1zm-3 6h1v1h-1zm3 10h-1v-1h1z",
    fill: "#d5d6d1"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M58 69h-1v-1h1zm-6 6h-1v-1h1zm-1 4h-1v-1h1zm-1 3v1h-1v-1zm0 5h-1v-1h1zm-1 2v-1h1v1zm4 0v1h-1v-1zm3 5h-1v-1h1z",
    fill: "#d4d5d0"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M46 95h1v4h-1v-2zm1 9h-1v-4h1v1z",
    fill: "#1d1c1a",
    fillOpacity: 0.878
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M57 45h2v1h-1v1h-1zm9-16v1h-1v-1zm0 13v-1h1v1zm-8 18h1v1h-1zm8 51v-1h1v1z",
    fill: "#020100"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M66 30h1v1h-2v-1zm2 2h-1v-1h1zm-10 2h-1v-1h1zm6 3h1v1h-1zm-2 1v1h-1v-1zm-2 3v-1h1v1z",
    fill: "#010101"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M62 126h-1v-1h4v1zm9-88h1v1h-1zm-5 80h-1v-1h1zm-7 8v-1h1v1z",
    fill: "#0a0a08"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M54 115h-1v-3h1zm18-3h1v3h-1zM54 47v-1h1v1z",
    fill: "#161513"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M62 124v-1h3v1h-1zm5-7h-1v-2h1v1zm1-65v-1h1v1zm-2 66h1v1h-1z",
    fill: "#080705"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M64 60v-6h1v6zm-2-7v1h-1v-1z",
    fill: "#100c0b"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M57 54h1v6h-1v-1zm14 66v-1h1v1z",
    fill: "#070605"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M48 63v6h-1v-6zm24 59v-1h1v1z",
    fill: "#2c2b27"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M59 64h-2v2h-1v-3h3zm-5 7h-1v-1h1zm2 0h-1v-1h1z",
    fill: "#e5e6e1"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M66 64v-1h1v1zm8 1v1h-1v-1zm3 9h-1v-1h1zm-2 2v-1h1v1zm3-1v1h-1v-1zm-1 11h1v1h-1zm-5 10h1v1h-1z",
    fill: "#e9e9e7"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M53 81v1h-1v1h-1v-1h-1v-1h1zm7-15v-1h1v1zm4-1v1h-1v-1zM49 76h-1v-1h1z",
    fill: "#cfd0cb"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M74 95v-1h1v2h-1zm1-28v1h-1v-1zm3 0v1h-1v-1zm-3 24v1h-1v-1zm1 2h1v1h-1zm-5 15v1h-1v-1z",
    fill: "#edecea"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M53 96h1v2h-1v-1zm-4-28v1h-1v-1zm12 6h-1v-1h1zm-8 22h-1v-1h1zm13 11h1v1h-1zm-3 2v-1h1v1z",
    fill: "#deddd9"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M79 96v-2h1v2zm-1-3h-1v-1h1zm-1 3v1h-1v-1zm3 2h-1v-1h1zm-3 10h-1v-1h1zm-5 1v-1h1v1z",
    fill: "#f0efed"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M65 10h-1V7h1zm-1 5v-1h1v2h-1zm1-2h-1v-1h1z",
    fill: "#56181c"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M62 44v-1h3v1zm-3 3h1v1h-1zm9 1h-1v-1h1zm-9 3h-1v-1h1z",
    fill: "#070503"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M78 111v2h-1v-2zm0 6h-1v-2h1v1zm0-72v1h-1v-1zm-1 75v1h-1v-1z",
    fill: "#74726e"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M61 115v5h-1v-5zm7-68h1v1h-1z",
    fill: "#0b090a"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M61 61v-1h3v1zm0-12v1h-1v-1zm-1 2v1h-1v-1zm6 1h1v1h-1z",
    fill: "#0b0706"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M63 49h1v1h-2v-1zm3 6h1v2h-1v-1zm-2-4v-1h1v1zm-4 1v1h-1v-1z",
    fill: "#0d0908"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M70 57v3h-1v-2h-1v-1zm-12-5v-1h1v1zm8 69v-1h1v1z",
    fill: "#080604"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M53 60h-1v-3h1zm-1 53v-2h1v2zm1-61v1h-1v-1z",
    fill: "#23221e"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M68 59v-1h1v2h-1zm1-7v1h-1v-1zm-4 59v-1h1v1zm2 11h-1v-1h1zm-4 2v1h-1v-1z",
    fill: "#070604"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M74 54h1v6h-1z",
    fill: "#64605d"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M75 54h1v6h-1z",
    fill: "#6d6966"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M45 60h1v4h-1v-1zm38 47v1h-1v-1zm-1 3h1v1h-1z",
    fill: "#636363",
    fillOpacity: 0.09
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M60 63h-2v-1h2zm5 1v1h-2v-1h1zm-2-2v1h-1v-1zm-12 2v-1h1v1z",
    fill: "#e8e9e4"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M79 92v1h-1v-2h1zm-8-29h-1v-1h1zm3 2h-1v-1h1zm5 7v-1h1v1zm-2 26h1v1h-1z",
    fill: "#f0f0ee"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M74 90v-1h2v2h-1v-1zm-6-27v1h-1v-1zm6 12v-1h1v1zm5 2h1v1h-1z",
    fill: "#eaeae8"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M58 66h-1v-1h1zm-8 16h-1v-1h1zm0 1v-1h1v1zm1 0h1v1h-1zm2 4v1h-1v-1zm2 7v1h-1v-1z",
    fill: "#d2d3ce"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M77 76v2h-2v-2zm1-10h-1v-1h1zm0 15v1h-1v-1z",
    fill: "#e6e6e4"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M54 72v-1h1v2h-1zm2 1v-2h1v2zm-3 1h-1v-1h1zm-3 28v1h-1v-1z",
    fill: "#e2e3de"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M75 75v1h-2v-1h1zm0-2h1v1h-1zm-7 1v1h-1v-1zm8 2v-1h1v1zm3 12h1v1h-1z",
    fill: "#e8e8e6"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M50 77v2h-1v-2zm1 9h-1v-1h1zm1 4h-1v-1h1zm0 3h1v1h-1zm6 1v1h-1v-1z",
    fill: "#d8d9d4"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M82 102v-4h1v4zm0 3v-1h1v2h-1z",
    fill: "#5b5b5b",
    fillOpacity: 0.098
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M75 115h-1v-4h1v1zm0 2v2h-1v-2z",
    fill: "#615d5a"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M63 115h1v4h-2v-1h1zm1-2h-1v-1h1z",
    fill: "#0e0b0a"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M76 113h1v6h-1z",
    fill: "#706f6b"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M60 119v1h-1v-5h1zm0 2h1v1h-1z",
    fill: "#090708"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M67 115h1v2h-1v-1zM57 38v1h-1v-1zm6 4v1h-1v-1zm-5 12h-1v-1h1z",
    fill: "#060504"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M71 39v1h-1v-1zm-2 4h-1v-1h1zm1 77v-1h1v1zm-12 2v-1h1v1zm2 1v1h-1v-1z",
    fill: "#050505"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M61 42v1h-1v-2h1zm7-2h1v1h-1zm-9 5v-1h1v1zm-4 3h1v1h-1z",
    fill: "#030102"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M72 60h-1v-2h1v1zm-2-19v-1h1v1zm-2 4h1v1h-1zm4 11h-1v-1h1z",
    fill: "#090909"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M62 41h2v1h-2zm7 73v1h-1v-2h1zm-12 8v1h-1v-1z",
    fill: "#050405"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M69 41h1v1h-1zm0 4h-1v-1h1zM55 56h-1v-1h1zm17 2h-1v-1h1zm-4 65v1h-1v-1z",
    fill: "#080808"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M50 118h-1v-3h1v1zm3-75v-1h1v1zm-4 68v-1h1v1z",
    fill: "#37342f"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M48 85h-1v-4h1v1zm5-34h-1v-1h1z",
    fill: "#262521"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M66 112v-1h1v2h-1zm2-62h1v1h-1zm-10 2h1v1h-1zm12 1v1h-1v-1z",
    fill: "#090705"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M82 67h1v4h-1v-1zM46 52h-1v-1h1z",
    fill: "#4a4a4a",
    fillOpacity: 0.122
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M52 53h1v4h-1v-2zm0 60h1v1h-1z",
    fill: "#22211d"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M52 117h-1v-2h1v1zm0-62h-1v-1h1zm0 2h-1v-1h1zm0 3h-1v-1h1z",
    fill: "#2b2724"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M70 55v-1h1v2h-1zm-15 3h-1v-1h1zm6 65v-1h1v1zm-5 1v-1h1v1z",
    fill: "#090807"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M80 101v-1h1v2h-1zm0-46v-1h1v1zm0 32h1v1h-1zm1 17v1h-1v-1z",
    fill: "#403f3b"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M51 114v-1h1v2h-1zm0-58v-1h1v1zm1 2h-1v-1h1zm0 54h-1v-1h1z",
    fill: "#2b2824"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M50 111h1v2h-1v-1zm1 7v1h-1v-2h1zm0-62v1h-1v-1z",
    fill: "#312e29"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M60 60h-1v-4h1v2zm3 52v-1h1v1z",
    fill: "#0d0a09"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M52 65v-1h3v1zm12-3h1v1h-2v-1z",
    fill: "#e9eae5"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M69 63h-1v-1h1zm0 2v-1h1v1zm10 8v-1h1v1zm-1 20v1h-1v-1zm-2 8h-1v-1h1z",
    fill: "#eeeeec"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M79 63v2h-1v-2zm-4-1v1h-1v-1zm2 3h-1v-1h1zm3 1v1h-1v-1z",
    fill: "#f5f5f3"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M62 65v1h-1v-1zm-6 9h-1v-1h1zm-6 10h1v1h-1zm0 10h-1v-1h1zm0 10v1h-1v-1z",
    fill: "#dedfda"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M63 65v1h-1v-1zm1 1v-1h1v1zm-10 1h1v1h-1zm3 3h-1v-1h1zm3 29v-1h1v1z",
    fill: "#dbdcd7"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M52 69h2v1h-2zm3 5h-1v-1h1zm1 18h1v1h-1zm-4 1v1h-1v-1z",
    fill: "#dfe0db"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M59 69v1h-1v-1zm-8 19h1v1h-1zm-2 2v1h-1v-1zm2 1h1v1h-1zm5 2h-1v-1h1z",
    fill: "#cdcec9"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M49 95h1v3h-1zm2-22h-1v-1h1zm17 29h-1v-1h1z",
    fill: "#e3e2de"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M83 73v5h-1v-5z",
    fill: "#52524a",
    fillOpacity: 0.122
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M51 76v-1h1v1zm-2 1v-1h1v1zm1 4h-1v-1h1zm0 2h1v1h-1zm2 9h1v1h-1z",
    fill: "#d7d8d3"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M48 76h1v3h-1zm2 16h-1v-1h1zm4 2h-1v-1h1z",
    fill: "#cccdc8"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M73 98v2h-1v-2zm0-7v-1h1v1zm5-1v1h-1v-1zm-1 18v1h-1v-1z",
    fill: "#e9e8e6"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M75 96h1v2h-1v-1zm3-4h-1v-1h1zm-2 2v1h-1v-1zm-1 13h1v1h-1z",
    fill: "#eeedeb"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M48 99h-1v-3h1zm0-4h-1v-1h1zm-1 6v-1h1v1z",
    fill: "#242320"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M81 100h-1v-3h1zm-1-4v-2h1v2z",
    fill: "#41403c"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M82 102h-1v-4h1v2zm0 4v1h-1v-1z",
    fill: "#1a1814",
    fillOpacity: 0.922
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M74 116h-1v-5h1v2z",
    fill: "#524f4b"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M48 113h1v5h-1v-1z",
    fill: "#413e39"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M53 120v-5h1v5z",
    fill: "#161412"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M59 53h1v3h-1zm8-25v1h-1v-1z",
    fill: "#0d0a08"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M64 43h-1v-1h2v1zm-4-13v-1h1v1zm2 13v1h-1v-1z",
    fill: "#060404"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M65 125h-2v-1h2zm2-96h1v1h-1zm-1 94h-1v-1h1z",
    fill: "#070705"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M55 35v1h-1v-1zm17 0h1v1h-1zm-6 8v1h-1v-1zm1 2h1v1h-1z",
    fill: "#050402"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M73 40v1h-1v-1zm3 1v-1h1v1zm4 48v-1h1v1zm1 18v1h-1v-1z",
    fill: "#403f3c"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M66 45v-3h1v3zm-8 2v1h-1v-1z",
    fill: "#030200"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M55 44h1v1h-1zm15 4h-1v-1h1zm1 4v-1h1v1zm1 70h-1v-1h1z",
    fill: "#100f0e"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M67 120h1v2h-1v-1zm-6-74h-1v-1h1zm-2 1v-1h1v1z",
    fill: "#070403"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M59 49v1h-1v-2h1zm9-3v1h-1v-1zm-1 74v-1h1v1z",
    fill: "#060503"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M62 48h-1v-1h4v1z",
    fill: "#0b0505"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M60 49h-1v-1h1zm9 4v1h-1v-1zm0 3h1v1h-1zm-1 57v1h-1v-1z",
    fill: "#080504"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M80 111v3h-1v-3zm0-60h-1v-1h1z",
    fill: "#736f6c"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M55 53h-1v-2h1v1zm16 4h-1v-1h1zm-6 64h1v1h-1z",
    fill: "#080806"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M66 123v-1h2v1h-1zm-9-72h1v1h-1zm11 68h1v1h-1z",
    fill: "#050503"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M51 115v2h-1v-2zm0-60v1h-1v-1zm-1 55v-1h1v1z",
    fill: "#312d29"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M53 60v-3h1v3zm0 52v-1h1v1z",
    fill: "#161512"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M70 58v-1h1v1zm-13 52h1v1h-1zm12 12v1h-1v-1zm-3 2h-1v-1h1z",
    fill: "#080706"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M65 62h-2v-1h2zm16 14h-1v-1h1zm0 1v1h-1v-1z",
    fill: "#43423f"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M80 68v2h-1v-2zm-7-6h1v1h-1zm4 2h1v1h-1z",
    fill: "#f4f4f2"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M54 65v1h-1v-1zm-2 16v-1h1v1zm-2 12v-1h1v1zm4 0h-1v-1h1z",
    fill: "#d3d4cf"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M55 66h-1v-1h1zm-7 8h1v1h-1zm5 15h-1v-1h1zm0 2v1h-1v-1z",
    fill: "#cecfca"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M56 66h-1v-1h1zm3-1v1h-1v-1zm-10 9h1v1h-1zm2 10h1v1h-1z",
    fill: "#ddded9"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M66 65v1h-1v-1zM50 85h-1v-1h1zm0 20v-1h1v1zm16 3h-1v-1h1z",
    fill: "#ddddd9"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M69 65v1h-1v-1zm5 23v-1h1v1zm2 0h1v1h-1zm-9 10v-1h1v1z",
    fill: "#e0e0de"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M47 71h-1v-3h1v1zm0-5v1h-1v-1z",
    fill: "#1c1b19",
    fillOpacity: 0.91
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M50 69v-1h1v1zm-2 0h1v1h-1zm7 27v1h-1v-1zm4 13v-1h1v1z",
    fill: "#dddcd8"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M81 75h1v3h-1v-1zm1-6v1h-1v-1z",
    fill: "#181714",
    fillOpacity: 0.941
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M78 98h-1v-3h1zm-4-28v1h-1v-1z",
    fill: "#f1f0ee"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M54 71v1h-3v-1h1zm2 1h-1v-1h1z",
    fill: "#e3e4df"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M53 72v1h-2v-1h1zm2 0h1v1h-1zm-1 1v1h-1v-1z",
    fill: "#e1e2dd"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M45 73h1v2h-1v-1zm0 10v-2h1v2z",
    fill: "#6b6b6b",
    fillOpacity: 0.075
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M48 95h1v3h-1zm1-22v1h-1v-1z",
    fill: "#d3d2ce"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M73 75v-1h1v1zm6 13v-1h1v1zm-2 1v1h-1v-1zm2 1v-1h1v1z",
    fill: "#e7e7e5"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M51 86v-1h2v1h-1zm-1-11v1h-1v-1zm11 26h1v1h-1z",
    fill: "#dadbd6"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M49 79v2h-1v-2zm6 12v1h-1v-2h1z",
    fill: "#cbccc7"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M80 91h1v2h-1v-1zm1-12v1h-1v-1zm0 4h-1v-1h1z",
    fill: "#41403e"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M83 81v4h-1v-4z",
    fill: "#57574f",
    fillOpacity: 0.114
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M48 89h-1v-2h1v1zm0 2h-1v-1h1zm0 3h-1v-1h1z",
    fill: "#262320"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M46 89v3h-1v-3zm37 30v1h-1v-1z",
    fill: "#666",
    fillOpacity: 0.059
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M75 96v2h-1v-2zm0-5h-1v-1h1zm2 1h-1v-1h1z",
    fill: "#ecebe9"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M77 91h-1v-1h1zm-2 2v-1h1v1zm-1 14v1h-1v-1zm-5 1h1v1h-1z",
    fill: "#eae9e7"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M76 92h-1v-1h1zm-4 1h1v1h-1zm8 0v1h-1v-1zm-6 14h1v1h-1z",
    fill: "#ebeae8"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M57 95v1h-3v-1h1zm-6-2v1h-1v-1z",
    fill: "#dcddd8"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M65 96h-1v-1h1zm1 1v1h-1v-1zm-17 9v-1h1v1zm15 2h1v1h-1z",
    fill: "#e0deda"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M57 97v1h-1v-1zm-1 8h-1v-1h1zm2 0v-1h1v1zm-4 2v1h-1v-1z",
    fill: "#dbdad6"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M79 99v-1h1v2h-1zm1 4h-1v-2h1v1z",
    fill: "#efefec"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M68 118v1h-1v-2h1zm-9-7v-1h1v1zm8 4v-1h1v1z",
    fill: "#070504"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M61 112v-1h1v4h-1z",
    fill: "#0d0b09"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M76 111v2h-1v-2zm0 6v2h-1v-2z",
    fill: "#696663"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M75 113h1v4h-1v-1z",
    fill: "#6a6764"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M58 119h1v1h-1zm13 1v1h-1v-1zm-11 3h1v1h-1zm6 0h1v1h-1z",
    fill: "#060606"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M62 8h1v3h-1z",
    fill: "#70292c"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M68 12h-1v-2h1v1zm0-3h-1V8h1z",
    fill: "#b34f55"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M64 13h-1v-3h1z",
    fill: "#602123"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M65 10v2h-1v-2zm-1 9v-1h1v1z",
    fill: "#55171c"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M62 13h1v3h-1v-1z",
    fill: "#6f2a2c"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M61 17v-3h1v3z",
    fill: "#813438"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M57 26v-1h1v1zm15 5v-1h1v1zM48 42v1h-1v-1z",
    fill: "#fff",
    fillOpacity: 0.004
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M62 31h1v1h-2v-2h1z",
    fill: "#000100"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M68 32v1h-1v-1zm4 4v1h-1v-1zM55 60v1h-1v-1z",
    fill: "#010100"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M46 93v2h-1v-2zm5-55h-1v-1h1z",
    fill: "#6d6d5b",
    fillOpacity: 0.055
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M54 38h1v1h-1zm-2 9v1h-1v-1zm-2 4v-1h1v1z",
    fill: "#373430"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M71 40h1v1h-1zm0 83v-1h1v1zm-17 1v-1h1v1z",
    fill: "#1c1b1a"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M62 42h-1v-1h1zm-4 70h-1v-1h1zm10-1h1v1h-1z",
    fill: "#040303"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M76 41v1h-1v-1zm0 20v-1h1v1zm4-1v1h-1v-1z",
    fill: "#6f6b68"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M79 42v1h-1v-1zm-7 68h1v1h-1zm-17 12h-1v-1h1z",
    fill: "#0d0c0a"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M49 112h-1v-2h1v1zm4-68h-1v-1h1z",
    fill: "#403d38"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M69 43h1v1h-1zm1 8h1v1h-1zm-1 73v1h-1v-1z",
    fill: "#0e0e0e"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M70 124v2h-1v-2zm0-81h1v1h-1z",
    fill: "#161615"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M48 45v-1h1v1zm-1 2h1v1h-1zm24 2h1v1h-1z",
    fill: "#151412"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M61 44h1v1h-1zm7 67v1h-1v-1zm2 10h-1v-1h1z",
    fill: "#070404"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M70 45v2h-1v-2zm1 6h-1v-1h1z",
    fill: "#101010"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M59 48h-1v-1h1zm-2 1v-1h1v1zm3 61h1v1h-1z",
    fill: "#040301"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M70 49v-1h1v1zm3 10h-1v-1h1zm0 57v1h-1v-1z",
    fill: "#131311"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M79 116v1h-1v-2h1zm-1-67v-1h1v1z",
    fill: "#76726e"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M55 49v1h-1v-1zm3 76h1v1h-1zm8 1h-1v-1h1z",
    fill: "#0b0b09"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M65 49v1h-1v-1zm0 2h1v1h-1zm2 2v1h-1v-1z",
    fill: "#0c0807"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M70 49h1v1h-1zm1 73v1h-1v-1zm-3 4v-1h1v1z",
    fill: "#111"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M69 51v-1h1v1zm3 3h-1v-1h1zm-3 68h1v1h-1z",
    fill: "#0c0c0b"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M47 54v-2h1v2zm0 54v-1h1v1z",
    fill: "#25231f"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M62 53h-1v1h-1v-2h2z",
    fill: "#0f0a0a"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M73 53h1v3h-1z",
    fill: "#524e4b"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M47 54h1v1h-1zm1 35v1h-1v-1zm0 2v1h-1v-1z",
    fill: "#25221f"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M50 54h1v1h-1zm0 3h1v1h-1zm0 2h1v1h-1z",
    fill: "#312e2a"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M72 54v1h-1v-1zm-1 68h-1v-1h1zm-3 3h-1v-1h1z",
    fill: "#0a0a0a"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M50 59v1h-1v-2h1zm0-3h-1v-1h1z",
    fill: "#393531"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M66 60h-1v-3h1z",
    fill: "#0f0a09"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M67 60h-1v-3h1v1z",
    fill: "#0d0807"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M70 58h1v2h-1v-1zm-10 53v1h-1v-1z",
    fill: "#090706"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M46 60h-1v-1h1zm36 47v-1h1v1zm1 5h-1v-1h1z",
    fill: "#5f5f5f",
    fillOpacity: 0.094
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M61 62v-1h2v1h-1zm20 12v1h-1v-1z",
    fill: "#444340"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M69 61v1h-1v-1zm11 18v-1h1v1zm1 3h-1v-1h1z",
    fill: "#42413f"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M74 63h1v1h-1zm4 9v-1h1v1zm1 35h1v1h-1z",
    fill: "#f1f1ef"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M82 67v-3h1v3z",
    fill: "#4a4a41",
    fillOpacity: 0.122
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M66 65h1v1h-1zM53 88v-1h1v1zm3 1h-1v-1h1z",
    fill: "#d0d0cd"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M78 65h1v3h-1z",
    fill: "#f6f6f4"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M46 66v2h-1v-2zm-1 49v-1h1v1z",
    fill: "#616161",
    fillOpacity: 0.082
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M80 67v-1h1v2h-1zm-1 54h1v1h-1z",
    fill: "#484745"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M54 69h-1v-1h1zm4-1h1v1h-1zm4 0v1h-1v-1z",
    fill: "#9b9c97"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M73 69v1h-1v-1zm4 0h1v1h-1zm-1 19v1h-1v-1z",
    fill: "#e1e1df"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M74 72h-1v-1h1zm5 4h-1v-1h1zm0 13v1h-1v-1z",
    fill: "#ebebea"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M79 72v1h-1v-1zm-9 4h-1v-1h1zm9 1v1h-1v-1z",
    fill: "#eaeae9"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M57 73v1h-1v-1zm-7 27v-1h1v1zm17 7h1v1h-1z",
    fill: "#dfdedb"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M70 73h1v1h-1zm7 3h1v1h-1zm2 5v-1h1v1z",
    fill: "#e7e7e6"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M46 74h1v2h-1v-1zm1 7h-1v-1h1z",
    fill: "#1d1b1a",
    fillOpacity: 0.906
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M57 74h1v1h-1zm-4 25v1h-1v-1zm0 5v1h-1v-1z",
    fill: "#ddddd8"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M66 108h2v1h-2zm1-33h-1v-1h1z",
    fill: "#e5e4e1"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M51 75v1h-1v-1zm1 0h1v1h-1zm3 19h1v1h-1z",
    fill: "#d9dad5"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M58 76h-1v-1h1zm0 28v1h-1v-1zm4 3h1v1h-1z",
    fill: "#d9d9d5"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M77 77h1v1h-1zm2 8v-1h1v1zm-8 20h-1v-1h1z",
    fill: "#e6e6e5"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M83 78v3h-1v-3z",
    fill: "#55554c",
    fillOpacity: 0.118
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M82 83h-1v-3h1v1z",
    fill: "#181715",
    fillOpacity: 0.937
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M78 83h-1v-1h1zm-10 18h1v1h-1zm2 6h1v1h-1z",
    fill: "#e5e4e2"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M81 85h-1v-1h1zm-1 6v-1h1v1zm0 3v-1h1v1z",
    fill: "#403f3d"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M45 85h1v3h-1v-1z",
    fill: "#696969",
    fillOpacity: 0.067
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M82 87h1v2h-1v-1zm-37 28h1v1h-1z",
    fill: "#555",
    fillOpacity: 0.106
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M51 95v-1h1v1zm3 0v1h-1v-1zm-1 4h-1v-1h1z",
    fill: "#deded9"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M53 94v1h-1v-1zm6 14h-1v-1h1zm1-1h1v1h-1z",
    fill: "#d8d7d3"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M74 96h-1v-1h1zm0 1v1h-1v-1zm0 2v1h-1v-1z",
    fill: "#ebeae7"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M55 97v-1h1v1zm-2 3v-1h1v1zm-3 5h1v1h-1z",
    fill: "#dcdcd8"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M56 99v-1h1v1zm0 2v-1h1v1zm7 4h-1v-1h1z",
    fill: "#dadad6"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M45 106h1v3h-1v-1z",
    fill: "#5c5c5c",
    fillOpacity: 0.043
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M46 109v3h-1v-3z",
    fill: "#666",
    fillOpacity: 0.039
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M46 112v-3h1v3z",
    fill: "#1f1e1c",
    fillOpacity: 0.863
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M60 122h-1v-2h1v1zm9-11h-1v-1h1z",
    fill: "#080607"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M50 114h-1v-3h1v1z",
    fill: "#383430"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M53 118h-1v-3h1z",
    fill: "#24201d"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M62 118h-1v-3h1z",
    fill: "#0e0a0a"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M70 119v1h-1v-2h1zm2-4v1h-1v-1z",
    fill: "#040504"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M51 117h1v3h-1z",
    fill: "#2c2825"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M62 4h1v1h-1zm1 19h-1v-1h1z",
    fill: "#6f292c"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M66 5V4h1v1zm1 18v1h-1v-1z",
    fill: "#762a2d"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M64 6V5h1v1zm1 7v1h-1v-1z",
    fill: "#55181c"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M61 9v1h-1V8h1z",
    fill: "#973e40"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M61 10V8h1v2z",
    fill: "#843439"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M64 9v1h-1V8h1z",
    fill: "#5f2022"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M66 9v1h-1V8h1z",
    fill: "#5a181f"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M67 9h-1V8h1zm-1 1h1v1h-1z",
    fill: "#853134"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M66 10V9h1v1zm0 1h1v1h-1z",
    fill: "#853033"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M60 10h1v2h-1v-1z",
    fill: "#963e40"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M62 10v2h-1v-2z",
    fill: "#833439"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M65 10h1v2h-1v-1z",
    fill: "#5a191f"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M59 13h1v2h-1v-1z",
    fill: "#8c363a",
    fillOpacity: 0.988
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M64 13v1h-1v-1zm0 3v1h-1v-1z",
    fill: "#602023"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M67 14v-1h1v1zm0 2v-1h1v1z",
    fill: "#b15052"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M60 16v-2h1v2z",
    fill: "#943e3f"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M63 14h1v2h-1v-1z",
    fill: "#602022"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M65 15v-1h1v1zm1 2h-1v-1h1z",
    fill: "#5a181c"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M61 27h-1v-1h1zm17 15h-1v-1h1z",
    fill: "#1f1c1a"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M68 27h-1v-1h1zm9 22v1h-1v-1z",
    fill: "#80817c"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M60 27v1h-1v-1zm-9 21h-1v-1h1z",
    fill: "#43423d"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M60 28v-1h1v1zm-7 33h-1v-1h1z",
    fill: "#1b1a16"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M58 28h1v1h-1zm-6 97v-1h1v1z",
    fill: "#393833"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M59 28h1v1h-1zm-9 21v-1h1v1z",
    fill: "#3d3c37"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M61 28h1v1h-1zm-5 19h1v1h-1z",
    fill: "#020000"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M67 29v-1h1v1zm13 34v-1h1v1z",
    fill: "#4a4945"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M59 30v-1h1v1zm-3 10h-1v-1h1z",
    fill: "#1e1d19"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M58 31h-1v-1h1zm-7 8h1v1h-1z",
    fill: "#0e0e0b"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M63 31v-1h2v1h-1z",
    fill: "#030001"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M69 31v1h-1v-1zm-9 1v1h-1v-1z",
    fill: "#000002"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M74 32v1h-1v-1zm9 26h-1v-1h1z",
    fill: "#484842",
    fillOpacity: 0.18
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M53 33h1v1h-1zm28 90v-1h1v1z",
    fill: "#7f7f7f",
    fillOpacity: 0.047
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M56 34h-1v-1h1zm15 20h-1v-1h1z",
    fill: "#0a0a09"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M55 34v1h-1v-1zm18 20v1h-1v-1z",
    fill: "#141211"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M73 35v-1h1v1zm-24 7h1v1h-1z",
    fill: "#12110e"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M55 36v-1h1v1zm14 15h1v1h-1z",
    fill: "#0b0b0a"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M74 35v1h-1v-1zm-7 10v1h-1v-1z",
    fill: "#050302"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M54 37h-1v-1h1zm14 13v-1h1v1z",
    fill: "#0a0806"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M73 36v1h-1v-1zm-23 5v-1h1v1z",
    fill: "#11100e"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M72 37v1h-1v-1zM57 49h1v1h-1z",
    fill: "#040402"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M73 37v1h-1v-1zm-1 10v1h-1v-1z",
    fill: "#1a1917"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M74 37h1v1h-1zm6 12h1v1h-1z",
    fill: "#211d1a"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M72 39v-1h1v1zm0 11h1v1h-1z",
    fill: "#252422"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M73 38h1v1h-1zm7 51h1v1h-1z",
    fill: "#3e3d3a"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M76 38v1h-1v-1zm-23 73h-1v-1h1z",
    fill: "#1e1c19"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M77 39h-1v-1h1zm-23 9v-1h1v1z",
    fill: "#12110f"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M54 40v-1h1v1zm25 84h-1v-1h1z",
    fill: "#36332e"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M70 40h-1v-1h1zm-15 8v-1h1v1z",
    fill: "#040203"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M72 40v-1h1v1zm-1 3v-1h1v1z",
    fill: "#31302e"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M75 40v-1h1v1zm-2 83v-1h1v1z",
    fill: "#585753"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M55 41h-1v-1h1zm-4 10v1h-1v-1z",
    fill: "#35322d"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M69 41v-1h1v1zm-10 79v1h-1v-1z",
    fill: "#060505"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M76 40v1h-1v-1zm-1 80h1v1h-1z",
    fill: "#6c6a66"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M80 40v1h-1v-1zm-33 83h-1v-1h1z",
    fill: "#aaa",
    fillOpacity: 0.024
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M54 42h-1v-1h1zm-4 7h1v1h-1z",
    fill: "#3b3833"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M54 42v-1h1v1zm-3 72h-1v-1h1z",
    fill: "#322f2a"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M66 42h-1v-1h1zm2 0v1h-1v-1z",
    fill: "#030201"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M77 41v1h-1v-1zm-1 19v1h-1v-1z",
    fill: "#686461"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M54 42h1v1h-1zm-1 81h-1v-1h1z",
    fill: "#2e2b27"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M65 43v-1h1v1zm2 0h1v1h-1z",
    fill: "#040201"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M70 43v-1h1v1zm0 3v-1h1v1z",
    fill: "#141413"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M72 43v-1h1v1zm1 7h1v1h-1z",
    fill: "#5e5d5a"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M50 44v-1h1v1zm0 2v1h-1v-1z",
    fill: "#55544f"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M55 43h1v1h-1zm17 9h1v1h-1z",
    fill: "#181715"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M69 43v1h-1v-1zm-2 81v1h-1v-1z",
    fill: "#070707"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M76 43v1h-1v-1zm1 8h-1v-1h1z",
    fill: "#7c7c78"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M78 44v-1h1v1zM48 55v1h-1v-1z",
    fill: "#23201d"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M53 45h-1v-1h1zm-5 64h1v1h-1z",
    fill: "#3a3732"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M53 45v-1h1v1zm-1 77h-1v-1h1z",
    fill: "#302c29"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M55 44v1h-1v-1zm-2 75h-1v-1h1z",
    fill: "#24201e"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M68 44v1h-1v-1zm-6 67h-1v-1h1z",
    fill: "#040302"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M76 44h1v1h-1zm1 65h1v1h-1z",
    fill: "#7a7874"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M49 46h-1v-1h1zm5 6h-1v-1h1z",
    fill: "#161613"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M52 45v1h-1v-1zm-1 77v1h-1v-1z",
    fill: "#43403c"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M54 45h1v1h-1zm-1 76h1v1h-1z",
    fill: "#1c1a18"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M56 45v1h-1v-1zm5 75v1h-1v-1z",
    fill: "#0a0809"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M62 46v-1h1v1zm-3 4v-1h1v1z",
    fill: "#090605"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M76 46v-1h1v1zm-1 1v1h-1v-1z",
    fill: "#82817d"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M48 46h1v1h-1zm0 40h-1v-1h1z",
    fill: "#252421"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M51 46v1h-1v-1zm-2 3v-1h1v1z",
    fill: "#4b4a45"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M64 46h1v1h-1zm1 3v-1h1v1z",
    fill: "#0a0404"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M78 46v1h-1v-1zm-3 5v-1h1v1z",
    fill: "#777672"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M50 48h-1v-1h1zm24 73h-1v-1h1z",
    fill: "#51504b"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M70 48v-1h1v1zm2 11h1v1h-1z",
    fill: "#141412"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M48 48h1v1h-1zm3 75h1v1h-1z",
    fill: "#42413d"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M62 49v-1h2v1h-1z",
    fill: "#0d0707"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M71 49v-1h1v1zm-17 72h-1v-1h1z",
    fill: "#171614"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M73 48v1h-1v-1zm7 7h1v1h-1z",
    fill: "#3d3c38"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M74 48h1v1h-1zm2 3h1v1h-1z",
    fill: "#797874"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M52 50h-1v-1h1zm-1 3v1h-1v-1z",
    fill: "#322f2b"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M53 49v1h-1v-1zm-5 27v1h-1v-1z",
    fill: "#292723"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M62 50h-1v-1h1zm-1 1h-1v-1h1z",
    fill: "#0d0808"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M66 49v1h-1v-1zm0 1h1v1h-1z",
    fill: "#0a0505"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M74 49h1v1h-1zm1 61v-1h1v1z",
    fill: "#72716d"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M80 50h-1v-1h1zm-4 3v1h-1v-1z",
    fill: "#6e6a67"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M48 50v1h-1v-1zm-1 9v-1h1v1z",
    fill: "#1e1c18"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M72 50v1h-1v-1zm0 67h1v1h-1z",
    fill: "#121210"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M60 52v-1h1v1zm6 1h-1v-1h1z",
    fill: "#0e0908"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M73 52h-1v-1h1zm7 69h1v1h-1z",
    fill: "#1d1c1a"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M76 52h-1v-1h1zm2 59h-1v-1h1z",
    fill: "#73716d"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M50 52h1v1h-1zm30 59v-1h1v1z",
    fill: "#33302c"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M57 52h1v1h-1zm4 73h-1v-1h1z",
    fill: "#050504"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M70 53v-1h1v1zm-4 73v-1h1v1z",
    fill: "#0c0c0c"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M75 53v-1h1v1zm4 7v1h-1v-1z",
    fill: "#716d6a"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M53 55v-2h1v2z",
    fill: "#151313"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M59 54v1h-1v-2h1z",
    fill: "#080805"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M78 55h-1v-2h1v1z",
    fill: "#787471"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M55 54v1h-1v-1zm0 3h-1v-1h1z",
    fill: "#080708"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M70 55v1h-1v-2h1z",
    fill: "#090604"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M48 55h1v1h-1zm1 64v1h-1v-1z",
    fill: "#433f3b"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M73 56v1h-1v-2h1z",
    fill: "#141210"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M50 58h-1v-2h1v1z",
    fill: "#393530"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M45 58v-1h1v1zm1 58v1h-1v-1z",
    fill: "#4d4d4d",
    fillOpacity: 0.129
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M49 58v1h-1v-2h1z",
    fill: "#423e3b"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M51 58v1h-1v-1zm-1 57v-1h1v1z",
    fill: "#322e2a"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M81 61v-2h1v2z",
    fill: "#191815",
    fillOpacity: 0.949
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M72 60h1v1h-1zm-15 65h1v1h-1z",
    fill: "#0d0d0b"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M61 61v1h-1v-1zm19 16v-1h1v1z",
    fill: "#44433f"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M68 61v1h-2v-1h1z",
    fill: "#42403f"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M48 62h1v1h-1zm2 9h1v1h-1z",
    fill: "#e6e5e1"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M53 62h1v1h-2v-1z",
    fill: "#edeee9"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M56 62v1h-2v-1h1z",
    fill: "#ebece7"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M57 62h1v1h-2v-1z",
    fill: "#eaebe6"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M83 63v1h-1v-2h1z",
    fill: "#47473f",
    fillOpacity: 0.125
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M50 64v1h-1v-2h1z",
    fill: "#eae9e5"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M51 63v1h-1v-1zm-1 7v1h-1v-1z",
    fill: "#e8e7e3"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M66 64h-1v-1h1zm7 36v1h-1v-1z",
    fill: "#e8e8e5"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M47 66h-1v-2h1v1z",
    fill: "#1c1b19",
    fillOpacity: 0.914
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M51 65h-1v-1h1zm-1 3v1h-1v-1z",
    fill: "#ebeae6"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M67 65h1v1h-1zm9 5v-1h1v1z",
    fill: "#d8d8d6"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M71 66h-1v-1h1zm4 4h-1v-1h1z",
    fill: "#d0d0ce"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M81 65v1h-1v-1zm0 5h-1v-1h1z",
    fill: "#474643"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M53 67v-1h1v1zm13 2h-1v-1h1z",
    fill: "#8c8d88"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M55 66v1h-1v-1zm5 2h1v1h-1z",
    fill: "#c0c1bc"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M57 66h1v1h-1zm-6 26h-1v-1h1z",
    fill: "#c8c9c4"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M59 66v1h-1v-1zm2 1h1v1h-1z",
    fill: "#a6a7a2"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M60 67v-1h1v1zm-5 26h-1v-1h1z",
    fill: "#b5b6b1"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M62 67h-1v-1h1zm-10 1h1v1h-1z",
    fill: "#9d9e99"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M64 67v-1h1v1zm2 2v-1h1v1z",
    fill: "#979893"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M75 67h-1v-1h1zM54 99h-1v-1h1z",
    fill: "#dddcda"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M81 67v-1h1v2h-1z",
    fill: "#161513",
    fillOpacity: 0.941
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M53 67h1v1h-1zm6 0h1v1h-1z",
    fill: "#787974"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M58 67h1v1h-1zm6 1h-1v-1h1z",
    fill: "#999a95"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M61 67v1h-1v-1zM49 86v1h-1v-1z",
    fill: "#c9cac5"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M72 67v1h-1v-1zm3 21v-1h1v1z",
    fill: "#dfdfdd"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M55 69h-1v-1h1zm3 0v1h-1v-1z",
    fill: "#c5c6c1"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M78 68v1h-1v-1zm-9 40v-1h1v1z",
    fill: "#e4e3e1"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M48 69v2h-1v-2z",
    fill: "#2b2a26"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M50 69h1v2h-1v-1z",
    fill: "#e7e6e2"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M51 69h1v1h-1zm0 26h-1v-1h1z",
    fill: "#e1e1dd"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M79 71h-2v-1h2z",
    fill: "#f3f3f2"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M47 72v1h-1v-2h1z",
    fill: "#1c1b19",
    fillOpacity: 0.906
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M48 71h1v1h-1zm14 36v1h-1v-1z",
    fill: "#d9d8d4"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M80 72v-1h1v2h-1z",
    fill: "#454441"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M81 71h1v1h-1zm0 3h1v1h-1z",
    fill: "#171713",
    fillOpacity: 0.941
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M50 72v1h-1v-1zm14 1v1h-1v-1z",
    fill: "#e4e3df"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M54 72v1h-1v-1zm-2 3v-1h1v1z",
    fill: "#e0e1dc"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M64 72v1h-1v-1zm1 30v-1h1v1z",
    fill: "#e1e1d9"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M71 73h-1v-1h1zm6 12v1h-1v-1z",
    fill: "#ebe8e4"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M82 72v2h-1v-2z",
    fill: "#181713",
    fillOpacity: 0.941
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M51 73v1h-1v-1zm-1 29h-1v-1h1z",
    fill: "#e2e2dd"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M65 74h-1v-1h1zm1 27h1v1h-1z",
    fill: "#e3e3dd"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M68 74h-1v-1h1zm2 26v-1h1v1z",
    fill: "#e8e5e4"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M69 73h1v1h-1zm3 35v-1h1v1z",
    fill: "#e8e7e6"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M75 74h-1v-1h1zm-1 14h1v1h-1z",
    fill: "#e4e4e2"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M55 74v1h-1v-1zm12 24h1v1h-1z",
    fill: "#e4e1e1"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M72 74v1h-1v-1zm-3 33v1h-1v-1z",
    fill: "#e3e2e0"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M60 76h-1v-1h1zm-7 3v1h-1v-1z",
    fill: "#d4d6d1"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M61 75h1v1h-1zm3 0v1h-1v-1z",
    fill: "#e4e7e3"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M68 76v-1h1v1zm3 32v-1h1v1z",
    fill: "#e7e6e4"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M47 79v1h-1v-2h1z",
    fill: "#1e1c1a",
    fillOpacity: 0.906
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M63 78h1v1h-1zm0 3h-1v-1h1z",
    fill: "#8e323a"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M75 78h1v1h-1zm2 2h1v1h-1z",
    fill: "#e3e4e2"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M78 78v1h-1v-1zm1 2v1h-1v-1z",
    fill: "#e7e7e7"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M82 80h-1v-2h1v1z",
    fill: "#181815",
    fillOpacity: 0.937
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M47 81v-2h1v2z",
    fill: "#272522"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M51 80v-1h1v2h-1z",
    fill: "#d4d4cf"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M79 79v1h-1v-1zm0 3v1h-1v-1z",
    fill: "#e6e5e6"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M80 81v1h-1v-1zm-1 2h1v1h-1z",
    fill: "#e6e5e4"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M48 82h1v2h-1v-1z",
    fill: "#cbcac6"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M79 82h1v1h-1zm-1 6h-1v-1h1z",
    fill: "#e3e3e2"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M46 84v-1h1v2h-1z",
    fill: "#1e1c1a",
    fillOpacity: 0.898
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M81 83h1v1h-1zm0 3v-1h1v1z",
    fill: "#191816",
    fillOpacity: 0.933
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M75 84v1h-1v-1zm1 21v-1h1v1z",
    fill: "#eef0ee"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M79 86h1v1h-1zm-30 18v-1h1v1z",
    fill: "#e0dfdd"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M81 88v-2h1v2z",
    fill: "#191814",
    fillOpacity: 0.929
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M76 87h1v1h-1zm4 3v1h-1v-1z",
    fill: "#e5e5e3"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M48 89v-1h1v1zm6 1v1h-1v-1z",
    fill: "#c7c7c3"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M51 88v1h-1v-1zm0 3v-1h1v1z",
    fill: "#d0d1cc"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M48 90v-1h1v1zm1 1v1h-1v-1z",
    fill: "#c1c2bd"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M83 90v1h-1v-1zm0 13h-1v-1h1z",
    fill: "#585858",
    fillOpacity: 0.102
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M82 92v-1h1v2h-1z",
    fill: "#5b5b51",
    fillOpacity: 0.098
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M73 92h1v1h-1zm1 12v1h-1v-1z",
    fill: "#eaece8"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M74 92h1v1h-1zm-5 9h1v1h-1z",
    fill: "#e6e5e3"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M46 95v-2h1v2z",
    fill: "#1d1b1a",
    fillOpacity: 0.878
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M59 93v1h-1v-1zm-2 2h1v1h-1z",
    fill: "#dadcd8"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M83 94v1h-1v-2h1z",
    fill: "#555",
    fillOpacity: 0.094
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M81 94h1v1h-1zm0 2h1v1h-1z",
    fill: "#181714",
    fillOpacity: 0.922
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M83 95v2h-1v-2z",
    fill: "#5f5555",
    fillOpacity: 0.094
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M58 96v1h-1v-1zm6 11v1h-1v-1z",
    fill: "#dbdbd7"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M58 97v-1h1v1zm-1 7v1h-1v-1z",
    fill: "#d9dcd7"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M79 97v-1h1v1zm-2 3v1h-1v-1z",
    fill: "#f0f0ed"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M58 98h-1v-1h1zm-5 10h-1v-1h1z",
    fill: "#dbdbd6"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M58 99v1h-1v-2h1z",
    fill: "#d9dbd6"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M68 99v-1h2v1h-1z",
    fill: "#e6e4e3"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M47 100h-1v-1h1zm-1 4h1v1h-1z",
    fill: "#1c1c1a",
    fillOpacity: 0.878
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M48 100v-1h1v1zm0 2v-1h1v1z",
    fill: "#d1d0cc"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M55 100v-1h1v1zm-2 8v1h-1v-1z",
    fill: "#dcdad6"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M49 101v-1h1v1zm6 8h-1v-1h1z",
    fill: "#e1e0dc"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M59 101h1v1h-1zm4 0v1h-1v-1z",
    fill: "#dbdcd5"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M60 102v-1h1v1zm-7 2h1v1h-1z",
    fill: "#dcdcd5"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M77 102v-1h1v1zm-2 5v-1h1v1z",
    fill: "#edebe8"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M45 104h1v1h-1zm1 9h-1v-1h1z",
    fill: "#6a6a6a",
    fillOpacity: 0.047
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M75 105v-1h1v1zm2 1h-1v-1h1z",
    fill: "#efeeeb"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M56 106h-1v-1h2v1z",
    fill: "#d4cec4"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M61 106v-1h1v1zm-1 1v-1h1v1z",
    fill: "#d0ccbf"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M56 108h-1v-1h2v1z",
    fill: "#d8d7d4"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M83 110h-1v-2h1v1z",
    fill: "#635858",
    fillOpacity: 0.09
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M47 110v-1h1v2h-1z",
    fill: "#1b1815"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M51 111v-1h1v1zm2 10v1h-1v-1z",
    fill: "#292522"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M48 113h-1v-2h1v1z",
    fill: "#1c1815"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M59 111v1h-1v-1zm1 11v1h-1v-1z",
    fill: "#060405"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M73 111v1h-1v-1zm-1 5v-1h1v1z",
    fill: "#151513"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M77 113h-1v-2h1v1z",
    fill: "#6f6f6b"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M81 112v1h-1v-2h1z",
    fill: "#332f2c"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M60 114v1h-1v-2h1z",
    fill: "#0a0808"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M63 114v-1h1v2h-1z",
    fill: "#0d0b0a"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M77 113h1v2h-1v-1z",
    fill: "#74726f"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M61 115h-1v-1h1zm1 6h-1v-1h1z",
    fill: "#0c0a09"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M75 117h-1v-1h1zm-1 2h1v1h-1z",
    fill: "#625e5b"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M82 116v2h-1v-2z",
    fill: "#1a1716",
    fillOpacity: 0.976
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M47 118v-1h1v2h-1z",
    fill: "#221f1b"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M73 118v-1h1v2h-1z",
    fill: "#4f4d48"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M49 120v1h-1v-1zm1 2h-1v-1h1z",
    fill: "#403c38"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M72 120h1v1h-1zm-18 4h1v1h-1z",
    fill: "#1e1d1a"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M62 124h-1v-1h1zm4 0v1h-1v-1z",
    fill: "#070706"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M68 124v-1h1v1zm0 1v1h-1v-1z",
    fill: "#0d0d0d"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M71 124h-1v-1h1zm-1 1h1v1h-1z",
    fill: "#1d1d1b"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M57 125v-1h1v1zm4-1h1v1h-1z",
    fill: "#060604"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M58 1h1v1h-1z",
    fill: "#966",
    fillOpacity: 0.02
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M60 2h-1V1h1z",
    fill: "#89565a",
    fillOpacity: 0.255
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M61 1v1h-1V1z",
    fill: "#89444e",
    fillOpacity: 0.435
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M61 1h1v1h-1z",
    fill: "#75353d",
    fillOpacity: 0.537
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M63 1v1h-1V1z",
    fill: "#662e32",
    fillOpacity: 0.596
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M63 2V1h1v1z",
    fill: "#5a252a",
    fillOpacity: 0.639
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M64 2V1h1v1z",
    fill: "#552125",
    fillOpacity: 0.635
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M65 2V1h1v1z",
    fill: "#582327",
    fillOpacity: 0.588
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M67 1v1h-1V1z",
    fill: "#73343b",
    fillOpacity: 0.537
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M67 1h1v1h-1z",
    fill: "#9d4f58",
    fillOpacity: 0.439
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M69 1v1h-1V1z",
    fill: "#a36269",
    fillOpacity: 0.275
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M70 1v1h-1V1z",
    fill: "#9f7f7f",
    fillOpacity: 0.031
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M59 3h-1V2h1z",
    fill: "#813d43",
    fillOpacity: 0.325
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M59 3V2h1v1z",
    fill: "#8f3d41",
    fillOpacity: 0.996
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M60 3V2h1v1z",
    fill: "#983f41"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M62 3h-1V2h1z",
    fill: "#823537"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M62 2h1v1h-1z",
    fill: "#712a2e"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M64 2v1h-1V2z",
    fill: "#632024"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M65 2v1h-1V2z",
    fill: "#59171c"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M65 2h1v1h-1z",
    fill: "#5e181c"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M66 3V2h1v1z",
    fill: "#7f2c2f"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M68 3h-1V2h1z",
    fill: "#b34d53"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M69 3h-1V2h1z",
    fill: "#b25059"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M69 2h1v1h-1z",
    fill: "#974950",
    fillOpacity: 0.424
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M58 3h1v1h-1z",
    fill: "#883e47",
    fillOpacity: 0.431
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M60 3v1h-1V3z",
    fill: "#953d40"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M60 4V3h1v1z",
    fill: "#943d3e"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M62 4h-1V3h1z",
    fill: "#7f3336"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M63 3v1h-1V3z",
    fill: "#70282d"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M63 3h1v1h-1z",
    fill: "#601f24"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M65 4h-1V3h1z",
    fill: "#57171d"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M65 4V3h1v1z",
    fill: "#5b171e"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M66 3h1v1h-1z",
    fill: "#79292d"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M67 4V3h1v1z",
    fill: "#ad4b4d"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M68 3h1v1h-1z",
    fill: "#b95056"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M69 3h1v1h-1z",
    fill: "#9c484e",
    fillOpacity: 0.525
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M59 4v1h-1V4z",
    fill: "#874247",
    fillOpacity: 0.435
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M59 5V4h1v1z",
    fill: "#953d3e"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M61 4v1h-1V4z",
    fill: "#963c40"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M61 5V4h1v1z",
    fill: "#7f3337"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M63 4h1v1h-1z",
    fill: "#5f2023"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M65 5h-1V4h1z",
    fill: "#56171c"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M66 5h-1V4h1z",
    fill: "#5a171d"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M68 4v1h-1V4z",
    fill: "#ac4a4f"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M69 4v1h-1V4z",
    fill: "#b85057"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M70 5h-1V4h1z",
    fill: "#9b454c",
    fillOpacity: 0.522
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M59 5v1h-1V5z",
    fill: "#894047",
    fillOpacity: 0.478
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M59 6V5h1v1z",
    fill: "#963d3f"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M60 6V5h1v1z",
    fill: "#8e3c3f"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M61 5h1v1h-1z",
    fill: "#7c3035"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M62 6V5h1v1z",
    fill: "#6c2829"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M64 6h-1V5h1z",
    fill: "#5c1f20"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M65 5h1v1h-1z",
    fill: "#58181d"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M67 6h-1V5h1z",
    fill: "#7b272e"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M67 6V5h1v1z",
    fill: "#a8494d"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M69 6h-1V5h1z",
    fill: "#b65156"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M70 5v1h-1V5z",
    fill: "#9c414a",
    fillOpacity: 0.537
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M58 6h1v1h-1z",
    fill: "#854249",
    fillOpacity: 0.42
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M59 6h1v1h-1z",
    fill: "#883136"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M61 6v1h-1V6z",
    fill: "#833235"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M62 6v1h-1V6z",
    fill: "#77292e"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M63 6v1h-1V6z",
    fill: "#662224"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M64 6v1h-1V6z",
    fill: "#5a1c1e"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M65 7h-1V6h1z",
    fill: "#53171a"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M66 7h-1V6h1z",
    fill: "#58191f"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M67 7h-1V6h1z",
    fill: "#7f2931"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M67 6h1v1h-1z",
    fill: "#a04144"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M69 6v1h-1V6z",
    fill: "#a54148"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M70 7h-1V6h1z",
    fill: "#94414a",
    fillOpacity: 0.471
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M59 7v1h-1V7z",
    fill: "#8d464d",
    fillOpacity: 0.141
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M59 8V7h1v1z",
    fill: "#8d383d",
    fillOpacity: 0.961
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M61 7v1h-1V7z",
    fill: "#963f41"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M61 8V7h1v1z",
    fill: "#843539"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M62 7h1v1h-1z",
    fill: "#702b2d"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M63 7h1v1h-1z",
    fill: "#602224"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M65 8V7h1v1z",
    fill: "#5b181e"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M67 8h-1V7h1z",
    fill: "#843135"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M68 8h-1V7h1z",
    fill: "#b35155"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M69 8h-1V7h1z",
    fill: "#a8454f",
    fillOpacity: 0.988
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M70 8h-1V7h1z",
    fill: "#8d414b",
    fillOpacity: 0.184
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M58 9V8h1v1z",
    fill: "#833d45",
    fillOpacity: 0.129
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M60 9h-1V8h1z",
    fill: "#8f373c",
    fillOpacity: 0.957
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M68 8h1v1h-1z",
    fill: "#a8474d",
    fillOpacity: 0.988
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M70 9h-1V8h1z",
    fill: "#884449",
    fillOpacity: 0.176
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M59 10h-1V9h1z",
    fill: "#833a41",
    fillOpacity: 0.137
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M59 10V9h1v1z",
    fill: "#8e373b",
    fillOpacity: 0.961
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M67 9h1v1h-1z",
    fill: "#b44f55"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M69 10h-1V9h1z",
    fill: "#a8484c",
    fillOpacity: 0.992
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M69 10V9h1v1z",
    fill: "#89474c",
    fillOpacity: 0.196
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M59 10v1h-1v-1z",
    fill: "#7f383f",
    fillOpacity: 0.141
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M60 10v1h-1v-1z",
    fill: "#8d363a",
    fillOpacity: 0.969
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M68 11v-1h1v1z",
    fill: "#a8484d",
    fillOpacity: 0.996
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M69 11v-1h1v1z",
    fill: "#8d4b50",
    fillOpacity: 0.212
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M58 11h1v1h-1z",
    fill: "#823441",
    fillOpacity: 0.153
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M60 12h-1v-1h1z",
    fill: "#8d363a",
    fillOpacity: 0.973
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M62 12v-1h1v1z",
    fill: "#71292c"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M69 11v1h-1v-1z",
    fill: "#a9494d"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M69 11h1v1h-1z",
    fill: "#8f5055",
    fillOpacity: 0.224
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M58 13v-1h1v1z",
    fill: "#823b47",
    fillOpacity: 0.169
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M59 13v-1h1v1z",
    fill: "#8d363a",
    fillOpacity: 0.984
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M60 13v-1h1v1z",
    fill: "#953e40"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M62 13h-1v-1h1z",
    fill: "#823439"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M63 13h-1v-1h1z",
    fill: "#702a2d"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M66 12v1h-1v-1z",
    fill: "#5c191e"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M67 13h-1v-1h1z",
    fill: "#842e33"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M68 12v1h-1v-1z",
    fill: "#b25053"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M69 13h-1v-1h1z",
    fill: "#ab4a50"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M70 12v1h-1v-1z",
    fill: "#924f57",
    fillOpacity: 0.239
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M58 13h1v1h-1z",
    fill: "#7f3c48",
    fillOpacity: 0.18
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M60 14v-1h1v1z",
    fill: "#943e40"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M62 13v1h-1v-1z",
    fill: "#823539"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M65 14v-1h1v1z",
    fill: "#5c181c"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M67 13v1h-1v-1z",
    fill: "#842f35"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M69 13v1h-1v-1z",
    fill: "#ac4a51"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M69 14v-1h1v1z",
    fill: "#934f57",
    fillOpacity: 0.251
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M59 14v1h-1v-1z",
    fill: "#7f3f45",
    fillOpacity: 0.188
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M66 15v-1h1v1z",
    fill: "#832f34"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M68 15h-1v-1h1z",
    fill: "#b25052"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M69 14v1h-1v-1z",
    fill: "#ae4a51"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M70 15h-1v-1h1z",
    fill: "#924d55",
    fillOpacity: 0.259
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M58 15h1v1h-1z",
    fill: "#84424c",
    fillOpacity: 0.196
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M60 15v1h-1v-1z",
    fill: "#8d363b",
    fillOpacity: 0.992
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M65 16v-1h1v1z",
    fill: "#59181c"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M66 16v-1h1v1z",
    fill: "#812f33"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M69 16h-1v-1h1z",
    fill: "#af4a52"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M70 16h-1v-1h1z",
    fill: "#954c53",
    fillOpacity: 0.275
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M58 17v-1h1v1z",
    fill: "#87464b",
    fillOpacity: 0.2
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M60 17h-1v-1h1z",
    fill: "#8c373b",
    fillOpacity: 0.992
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M61 17h-1v-1h1z",
    fill: "#943d3f"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M62 17v-1h1v1z",
    fill: "#70292d"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M64 17v-1h1v1z",
    fill: "#57181c"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M67 16v1h-1v-1z",
    fill: "#7f2d31"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M67 16h1v1h-1z",
    fill: "#b34d51"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M68 16h1v1h-1z",
    fill: "#af4b55"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M69 16h1v1h-1z",
    fill: "#924a55",
    fillOpacity: 0.294
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M58 18v-1h1v1z",
    fill: "#88484d",
    fillOpacity: 0.22
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M59 17h1v1h-1z",
    fill: "#8c373a"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M60 18v-1h1v1z",
    fill: "#963d3e"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M62 18h-1v-1h1z",
    fill: "#803437"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M63 17v1h-1v-1z",
    fill: "#6e2a2c"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M63 18v-1h1v1z",
    fill: "#5e2022"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M64 17h1v1h-1z",
    fill: "#55181b"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M65 18v-1h1v1z",
    fill: "#5a191c"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M67 18h-1v-1h1z",
    fill: "#7e2c2f"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M68 17v1h-1v-1z",
    fill: "#b24c4f"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M69 18h-1v-1h1z",
    fill: "#ae4c54"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M70 17v1h-1v-1z",
    fill: "#914a50",
    fillOpacity: 0.31
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M59 19h-1v-1h1z",
    fill: "#8b4a56",
    fillOpacity: 0.243
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M60 18v1h-1v-1z",
    fill: "#8d383c"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M60 19v-1h1v1z",
    fill: "#973c3f"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M61 18h1v1h-1z",
    fill: "#813338"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M63 19h-1v-1h1z",
    fill: "#6e282c"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M63 18h1v1h-1z",
    fill: "#5e1f22"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M66 18v1h-1v-1z",
    fill: "#5b161e"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M67 18v1h-1v-1z",
    fill: "#7d2a30"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M67 18h1v1h-1z",
    fill: "#b14c51"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M69 18v1h-1v-1z",
    fill: "#b14a54"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M69 18h1v1h-1z",
    fill: "#93494f",
    fillOpacity: 0.325
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M59 20h-1v-1h1z",
    fill: "#82484f",
    fillOpacity: 0.29
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M60 20h-1v-1h1z",
    fill: "#8e3b3c"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M61 19v1h-1v-1z",
    fill: "#933f3a"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M61 19h1v1h-1z",
    fill: "#803635"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M62 19h1v1h-1z",
    fill: "#722f2d"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M64 19v1h-1v-1z",
    fill: "#612523"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M64 19h1v1h-1z",
    fill: "#571c1c"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M66 20h-1v-1h1z",
    fill: "#5d1c1d"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M67 20h-1v-1h1z",
    fill: "#7f322f"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M67 19h1v1h-1z",
    fill: "#af524f"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M68 20v-1h1v1z",
    fill: "#b04d52"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M70 19v1h-1v-1z",
    fill: "#92474a",
    fillOpacity: 0.349
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M59 21h-1v-1h1z",
    fill: "#925f59",
    fillOpacity: 0.314
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M60 20v1h-1v-1z",
    fill: "#9f5748"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M60 20h1v1h-1z",
    fill: "#a25a47"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M62 21h-1v-1h1z",
    fill: "#955443"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M63 20v1h-1v-1z",
    fill: "#824935"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M63 21v-1h1v1z",
    fill: "#7c4634"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M65 21h-1v-1h1z",
    fill: "#683524"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M65 21v-1h1v1z",
    fill: "#713a2a"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M67 20v1h-1v-1z",
    fill: "#975642"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M67 21v-1h1v1z",
    fill: "#c0745e"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M68 20h1v1h-1z",
    fill: "#c27166"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M70 21h-1v-1h1z",
    fill: "#a4625d",
    fillOpacity: 0.396
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M58 21h1v1h-1z",
    fill: "#965d5d",
    fillOpacity: 0.365
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M59 22v-1h1v1z",
    fill: "#a3584b"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M61 22h-1v-1h1z",
    fill: "#9e5a49"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M62 22h-1v-1h1z",
    fill: "#8f4e42"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M62 22v-1h1v1z",
    fill: "#7b4435"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M63 21h1v1h-1z",
    fill: "#6f3c30"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M65 22h-1v-1h1z",
    fill: "#603025"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M65 21h1v1h-1z",
    fill: "#693428"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M67 21v1h-1v-1z",
    fill: "#914f3d"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M67 22v-1h1v1z",
    fill: "#bd715b"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M69 21v1h-1v-1z",
    fill: "#c67a6b"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M69 22v-1h1v1z",
    fill: "#b2706a",
    fillOpacity: 0.443
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M58 23v-1h1v1z",
    fill: "#874447",
    fillOpacity: 0.435
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M59 23v-1h1v1z",
    fill: "#963c3b"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M60 22h1v1h-1z",
    fill: "#903e3b"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M61 23v-1h1v1z",
    fill: "#803134"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M63 23v-1h1v1z",
    fill: "#5e2021"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M65 22v1h-1v-1z",
    fill: "#55171b"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M65 23v-1h1v1z",
    fill: "#5a161c"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M67 23h-1v-1h1z",
    fill: "#7c2b30"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M68 22v1h-1v-1z",
    fill: "#ad4b4f"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M69 23h-1v-1h1z",
    fill: "#b55458"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M70 22v1h-1v-1z",
    fill: "#9c4e52",
    fillOpacity: 0.51
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M59 24h-1v-1h1z",
    fill: "#8c3e42",
    fillOpacity: 0.525
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M59 23h1v1h-1z",
    fill: "#973d41"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M61 23v1h-1v-1z",
    fill: "#903d43"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M62 23v1h-1v-1z",
    fill: "#7a3337"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M62 24v-1h1v1z",
    fill: "#6b292c"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M63 24v-1h1v1z",
    fill: "#5f1f21"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M64 23h1v1h-1z",
    fill: "#54171b"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M65 23h1v1h-1z",
    fill: "#57171c"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M67 24v-1h1v1z",
    fill: "#a74a4e"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M69 24h-1v-1h1z",
    fill: "#b65054"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M70 23v1h-1v-1z",
    fill: "#9d464b",
    fillOpacity: 0.608
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M59 25h-1v-1h1z",
    fill: "#553634",
    fillOpacity: 0.624
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M59 25v-1h1v1z",
    fill: "#634241"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M61 24v1h-1v-1z",
    fill: "#422728"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M62 24v1h-1v-1z",
    fill: "#260c0d"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M63 24v1h-1v-1z",
    fill: "#30090a"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M64 25h-1v-1h1z",
    fill: "#3b0a0a"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M64 24h1v1h-1z",
    fill: "#330808"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M65 25v-1h1v1z",
    fill: "#270a09"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M66 25v-1h1v1z",
    fill: "#412b2a"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M68 25h-1v-1h1z",
    fill: "#907574"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M69 24v1h-1v-1z",
    fill: "#916b6d"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M69 24h1v1h-1z",
    fill: "#5f3c3f",
    fillOpacity: 0.698
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M59 26h-1v-1h1z",
    fill: "#2f312d",
    fillOpacity: 0.741
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M59 25h1v1h-1z",
    fill: "#464743"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M60 26v-1h1v1z",
    fill: "#201e1c"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M62 25v1h-1v-1z",
    fill: "#090000"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M62 26v-1h1v1z",
    fill: "#1c0203"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M64 25v1h-1v-1z",
    fill: "#2d0505"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M65 25v1h-1v-1z",
    fill: "#270303"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M65 26v-1h1v1z",
    fill: "#190605"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M66 25h1v1h-1z",
    fill: "#2d2a26"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M67 25h1v1h-1z",
    fill: "#838782"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M68 25h1v1h-1z",
    fill: "#7f817d"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M70 26h-1v-1h1z",
    fill: "#383633",
    fillOpacity: 0.808
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M71 26h-1v-1h1z",
    fill: "#6d6d6d",
    fillOpacity: 0.027
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M58 27h-1v-1h1z",
    fill: "#555",
    fillOpacity: 0.059
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M59 27h-1v-1h1z",
    fill: "#33322f",
    fillOpacity: 0.867
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M60 27h-1v-1h1z",
    fill: "#484742"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M62 27h-1v-1h1z",
    fill: "#090100"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M62 27v-1h1v1z",
    fill: "#170203"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M64 26v1h-1v-1z",
    fill: "#230405"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M65 27h-1v-1h1z",
    fill: "#1f0404"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M66 26v1h-1v-1z",
    fill: "#150605"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M66 27v-1h1v1z",
    fill: "#2a2623"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M69 26v1h-1v-1z",
    fill: "#868480"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M70 27h-1v-1h1z",
    fill: "#403c39",
    fillOpacity: 0.922
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M70 26h1v1h-1z",
    fill: "#383838",
    fillOpacity: 0.106
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M58 27v1h-1v-1z",
    fill: "#2d2d28",
    fillOpacity: 0.196
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M58 28v-1h1v1z",
    fill: "#363530",
    fillOpacity: 0.976
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M62 28h-1v-1h1z",
    fill: "#050000"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M62 27h1v1h-1z",
    fill: "#0d0202"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M63 27h1v1h-1z",
    fill: "#140506"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M65 27v1h-1v-1z",
    fill: "#110304"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M65 27h1v1h-1z",
    fill: "#0c0302"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M67 28h-1v-1h1z",
    fill: "#221e1b"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M67 28v-1h1v1z",
    fill: "#757470"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M69 27v1h-1v-1z",
    fill: "#85827d"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M69 27h1v1h-1z",
    fill: "#494642",
    fillOpacity: 0.996
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M71 27v1h-1v-1z",
    fill: "#21211e",
    fillOpacity: 0.267
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M57 29v-1h1v1z",
    fill: "#26241f",
    fillOpacity: 0.471
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M61 29h-1v-1h1z",
    fill: "#191714"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M62 28h1v1h-1z",
    fill: "#070201"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M63 29v-1h1v1z",
    fill: "#0c0405"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M65 29h-1v-1h1z",
    fill: "#090202"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M65 29v-1h1v1z",
    fill: "#050100"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M68 28h1v1h-1z",
    fill: "#787772"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M70 28v1h-1v-1z",
    fill: "#575550"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M70 29v-1h1v1z",
    fill: "#1f1f1b",
    fillOpacity: 0.545
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M57 30h-1v-1h1z",
    fill: "#888",
    fillOpacity: 0.059
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M57 29h1v1h-1z",
    fill: "#1b1a17",
    fillOpacity: 0.835
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M58 30v-1h1v1z",
    fill: "#272623"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M63 30h-1v-1h1z",
    fill: "#050101"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M63 30v-1h1v1z",
    fill: "#090101"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M65 30h-1v-1h1z",
    fill: "#070001"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M68 30v-1h1v1z",
    fill: "#292a26"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M69 29h1v1h-1z",
    fill: "#343430"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M70 29h1v1h-1z",
    fill: "#191814",
    fillOpacity: 0.871
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M71 30v-1h1v1z",
    fill: "#686868",
    fillOpacity: 0.086
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M57 31h-1v-1h1z",
    fill: "#2b2b29",
    fillOpacity: 0.533
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M59 30v1h-1v-1z",
    fill: "#0e0d0b"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M69 30h1v1h-1z",
    fill: "#060605"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M72 30v1h-1v-1z",
    fill: "#262624",
    fillOpacity: 0.6
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M56 32h-1v-1h1z",
    fill: "#3d403a",
    fillOpacity: 0.31
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M57 31v1h-1v-1z",
    fill: "#141512",
    fillOpacity: 0.976
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M58 32h-1v-1h1z",
    fill: "#060603"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M69 31h1v1h-1z",
    fill: "#010103"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M71 32v-1h1v1z",
    fill: "#111110",
    fillOpacity: 0.996
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M73 31v1h-1v-1z",
    fill: "#383535",
    fillOpacity: 0.373
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M55 32v1h-1v-1z",
    fill: "#505050",
    fillOpacity: 0.137
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M56 33h-1v-1h1z",
    fill: "#1f201c",
    fillOpacity: 0.89
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M57 33h-1v-1h1z",
    fill: "#050604"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M58 32v1h-1v-1z",
    fill: "#030301"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M60 32h1v1h-1z",
    fill: "#000001"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M73 32v1h-1v-1z",
    fill: "#1d1c1a",
    fillOpacity: 0.922
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M54 33h1v1h-1z",
    fill: "#292825",
    fillOpacity: 0.749
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M74 33v1h-1v-1z",
    fill: "#252421",
    fillOpacity: 0.8
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M74 33h1v1h-1z",
    fill: "#5d5d5d",
    fillOpacity: 0.075
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M53 35v-1h1v1z",
    fill: "#302e2c",
    fillOpacity: 0.58
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M55 35v-1h1v1z",
    fill: "#020200"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M74 35v-1h1v1z",
    fill: "#2c2a27",
    fillOpacity: 0.635
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M75 34h1v1h-1z",
    fill: "#bfbfbf",
    fillOpacity: 0.016
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M53 35v1h-1v-1z",
    fill: "#3a3532",
    fillOpacity: 0.396
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M53 35h1v1h-1z",
    fill: "#1b1a17",
    fillOpacity: 0.996
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M75 36h-1v-1h1z",
    fill: "#1b1716"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M75 36v-1h1v1z",
    fill: "#32302e",
    fillOpacity: 0.455
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M51 36h1v1h-1z",
    fill: "#484343",
    fillOpacity: 0.208
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M53 37h-1v-1h1z",
    fill: "#231e1b",
    fillOpacity: 0.937
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M54 37v-1h1v1z",
    fill: "#191816"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M56 37h-1v-1h1z",
    fill: "#181817"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M57 37h-1v-1h1z",
    fill: "#030203"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M73 37v-1h1v1z",
    fill: "#151312"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M75 37h-1v-1h1z",
    fill: "#0b0705"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M75 36h1v1h-1z",
    fill: "#201e1a",
    fillOpacity: 0.961
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M77 37h-1v-1h1z",
    fill: "#3d3d39",
    fillOpacity: 0.259
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M51 37h1v1h-1z",
    fill: "#292523",
    fillOpacity: 0.796
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M53 38h-1v-1h1z",
    fill: "#0e0d0a"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M53 38v-1h1v1z",
    fill: "#1e1b18"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M54 37h1v1h-1z",
    fill: "#363330"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M56 38h-1v-1h1z",
    fill: "#1a1817"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M73 37h1v1h-1z",
    fill: "#302e2b"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M75 38v-1h1v1z",
    fill: "#0c0a07"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M77 37v1h-1v-1z",
    fill: "#242321",
    fillOpacity: 0.843
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M77 37h1v1h-1z",
    fill: "#5c5c51",
    fillOpacity: 0.086
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M50 39v-1h1v1z",
    fill: "#33332f",
    fillOpacity: 0.522
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M51 38h1v1h-1z",
    fill: "#171411"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M52 39v-1h1v1z",
    fill: "#141410"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M54 39h-1v-1h1z",
    fill: "#423f3a"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M56 38v1h-1v-1z",
    fill: "#1b1a17"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M69 39v-1h1v1z",
    fill: "#020101"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M71 39h-1v-1h1z",
    fill: "#020303"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M74 39v-1h1v1z",
    fill: "#504c48"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M78 39h-1v-1h1z",
    fill: "#2f2e2c",
    fillOpacity: 0.584
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M50 39v1h-1v-1z",
    fill: "#42423d",
    fillOpacity: 0.196
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M51 39v1h-1v-1z",
    fill: "#1f1f1c",
    fillOpacity: 0.953
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M53 39v1h-1v-1z",
    fill: "#3c3a35"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M53 40v-1h1v1z",
    fill: "#46433d"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M65 39h1v1h-1z",
    fill: "#020102"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M71 40v-1h1v1z",
    fill: "#121110"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M74 40h-1v-1h1z",
    fill: "#4e4d4a"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M74 39h1v1h-1z",
    fill: "#65615d"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M76 39h1v1h-1z",
    fill: "#100f0d"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M77 40v-1h1v1z",
    fill: "#1b1b19",
    fillOpacity: 0.976
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M78 39h1v1h-1z",
    fill: "#40403c",
    fillOpacity: 0.247
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M48 40h1v1h-1z",
    fill: "#fff",
    fillOpacity: 0.008
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M49 40h1v1h-1z",
    fill: "#2e2b27",
    fillOpacity: 0.686
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M52 41h-1v-1h1z",
    fill: "#2c2c29"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M52 41v-1h1v1z",
    fill: "#4d4a45"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M53 41v-1h1v1z",
    fill: "#403d36"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M55 40h1v1h-1z",
    fill: "#23221d"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M74 40v1h-1v-1z",
    fill: "#615f5c"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M74 41v-1h1v1z",
    fill: "#6e6a66"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M78 40v1h-1v-1z",
    fill: "#0b0b08"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M78 40h1v1h-1z",
    fill: "#292925",
    fillOpacity: 0.749
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M49 42h-1v-1h1z",
    fill: "#413d39",
    fillOpacity: 0.259
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M49 41h1v1h-1z",
    fill: "#1b1b18",
    fillOpacity: 0.984
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M51 41v1h-1v-1z",
    fill: "#191813"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M52 41v1h-1v-1z",
    fill: "#4d4c46"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M53 42h-1v-1h1z",
    fill: "#4b4843"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M67 41h1v1h-1z",
    fill: "#030101"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M70 41h1v1h-1z",
    fill: "#0f0f0d"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M72 42h-1v-1h1z",
    fill: "#262624"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M73 41v1h-1v-1z",
    fill: "#504f4b"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M74 41v1h-1v-1z",
    fill: "#716f6b"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M78 42v-1h1v1z",
    fill: "#171715",
    fillOpacity: 0.996
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M79 41h1v1h-1z",
    fill: "#383835",
    fillOpacity: 0.318
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M48 43v-1h1v1z",
    fill: "#2a2a26",
    fillOpacity: 0.675
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M51 42v1h-1v-1z",
    fill: "#3a3934"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M51 43v-1h1v1z",
    fill: "#57564f"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M53 43h-1v-1h1z",
    fill: "#45423d"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M56 42v1h-1v-1z",
    fill: "#1f1e1b"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M70 42v1h-1v-1z",
    fill: "#0b0b0b"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M74 43h-1v-1h1z",
    fill: "#7a7975"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M75 43h-1v-1h1z",
    fill: "#7b7a76"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M75 43v-1h1v1z",
    fill: "#74716e"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M77 42v1h-1v-1z",
    fill: "#706c69"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M77 43v-1h1v1z",
    fill: "#4f4c49"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M79 43v-1h1v1z",
    fill: "#292826",
    fillOpacity: 0.749
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M80 42h1v1h-1z",
    fill: "#ccc",
    fillOpacity: 0.02
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M48 43v1h-1v-1z",
    fill: "#4f4f4f",
    fillOpacity: 0.176
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M48 43h1v1h-1z",
    fill: "#1e1d1b",
    fillOpacity: 0.957
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M49 43h1v1h-1z",
    fill: "#1c1b19"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M52 43v1h-1v-1z",
    fill: "#52514b"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M53 43h1v1h-1z",
    fill: "#332f2b"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M55 44h-1v-1h1z",
    fill: "#292623"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M57 43v1h-1v-1z",
    fill: "#060506"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M60 43h1v1h-1z",
    fill: "#040204"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M71 43h1v1h-1z",
    fill: "#393937"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M73 43v1h-1v-1z",
    fill: "#686763"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M73 44v-1h1v1z",
    fill: "#80807b"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M74 44v-1h1v1z",
    fill: "#868682"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M77 44h-1v-1h1z",
    fill: "#72706c"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M78 44h-1v-1h1z",
    fill: "#6c6865"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M80 44h-1v-1h1z",
    fill: "#191715",
    fillOpacity: 0.98
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M81 43v1h-1v-1z",
    fill: "#454541",
    fillOpacity: 0.243
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M47 44h1v1h-1z",
    fill: "#312f2b",
    fillOpacity: 0.51
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M50 45h-1v-1h1z",
    fill: "#373634"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M50 44h1v1h-1z",
    fill: "#5a5954"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M51 45v-1h1v1z",
    fill: "#4a4943"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M57 45h-1v-1h1z",
    fill: "#030202"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M58 44v1h-1v-1z",
    fill: "#010001"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M66 44v1h-1v-1z",
    fill: "#070402"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M69 44h1v1h-1z",
    fill: "#0f0f0f"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M71 44v1h-1v-1z",
    fill: "#151514"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M72 44v1h-1v-1z",
    fill: "#3a3a38"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M72 45v-1h1v1z",
    fill: "#6c6b67"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M73 44h1v1h-1z",
    fill: "#81817c"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M75 45h-1v-1h1z",
    fill: "#8e908b"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M76 45h-1v-1h1z",
    fill: "#898a85"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M77 45v-1h1v1z",
    fill: "#736e6b"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M78 45v-1h1v1z",
    fill: "#4b4745"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M80 44v1h-1v-1z",
    fill: "#0f0d0a"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M81 45h-1v-1h1z",
    fill: "#2b2b28",
    fillOpacity: 0.592
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M46 45h1v1h-1z",
    fill: "#7f7f7f",
    fillOpacity: 0.031
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M48 46h-1v-1h1z",
    fill: "#242322",
    fillOpacity: 0.812
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M50 45v1h-1v-1z",
    fill: "#4e4d49"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M50 46v-1h1v1z",
    fill: "#54544e"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M52 45h1v1h-1z",
    fill: "#36312e"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M54 46h-1v-1h1z",
    fill: "#2b2925"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M59 45h1v1h-1z",
    fill: "#050301"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M72 45v1h-1v-1z",
    fill: "#2f2f2c"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M72 45h1v1h-1z",
    fill: "#696764"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M73 45h1v1h-1z",
    fill: "#7e7e79"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M75 45v1h-1v-1z",
    fill: "#90908c"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M75 46v-1h1v1z",
    fill: "#92928e"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M79 45v1h-1v-1z",
    fill: "#676561"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M80 46h-1v-1h1z",
    fill: "#171613"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M81 45v1h-1v-1z",
    fill: "#21201c",
    fillOpacity: 0.871
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M81 45h1v1h-1z",
    fill: "#6f6f6f",
    fillOpacity: 0.063
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M46 46h1v1h-1z",
    fill: "#4c4c4c",
    fillOpacity: 0.196
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M47 46h1v1h-1z",
    fill: "#1a1918",
    fillOpacity: 0.976
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M52 47h-1v-1h1z",
    fill: "#3c3936"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M52 46h1v1h-1z",
    fill: "#322e2b"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M53 47v-1h1v1z",
    fill: "#272521"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M59 47h-1v-1h1z",
    fill: "#030300"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M63 47h-1v-1h1z",
    fill: "#0b0606"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M63 46h1v1h-1z",
    fill: "#0b0605"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M66 47v-1h1v1z",
    fill: "#060302"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M68 47v-1h1v1z",
    fill: "#0a0909"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M71 46v1h-1v-1z",
    fill: "#161614"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M71 47v-1h1v1z",
    fill: "#22221f"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M73 46v1h-1v-1z",
    fill: "#5c5b57"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M73 47v-1h1v1z",
    fill: "#787773"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M74 46h1v1h-1z",
    fill: "#8b8985"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M76 47h-1v-1h1z",
    fill: "#92918d"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M76 46h1v1h-1z",
    fill: "#888783"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M79 47h-1v-1h1z",
    fill: "#726f6b"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M80 47h-1v-1h1z",
    fill: "#33312e"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M81 47h-1v-1h1z",
    fill: "#151412",
    fillOpacity: 0.996
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M81 47v-1h1v1z",
    fill: "#484844",
    fillOpacity: 0.263
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M46 48v-1h1v1z",
    fill: "#383836",
    fillOpacity: 0.424
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M48 47h1v1h-1z",
    fill: "#363531"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M53 47v1h-1v-1z",
    fill: "#2f2b28"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M53 48v-1h1v1z",
    fill: "#23211e"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M66 48h-1v-1h1z",
    fill: "#090404"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M72 47h1v1h-1z",
    fill: "#4d4c48"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M73 47h1v1h-1z",
    fill: "#71706c"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M75 48v-1h1v1z",
    fill: "#8c8b87"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M76 48v-1h1v1z",
    fill: "#898884"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M78 47v1h-1v-1z",
    fill: "#7c7a76"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M78 47h1v1h-1z",
    fill: "#75716d"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M80 47v1h-1v-1z",
    fill: "#504c49"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M81 48h-1v-1h1z",
    fill: "#110f0d"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M82 47v1h-1v-1z",
    fill: "#343432",
    fillOpacity: 0.498
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M47 49h-1v-1h1z",
    fill: "#2c2a27",
    fillOpacity: 0.631
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M47 49v-1h1v1z",
    fill: "#15140f"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M52 48v1h-1v-1z",
    fill: "#34312d"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M53 49h-1v-1h1z",
    fill: "#2d2825"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M53 48h1v1h-1z",
    fill: "#1f1d1a"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M54 48h1v1h-1z",
    fill: "#0e0d0d"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M57 48v1h-1v-1z",
    fill: "#030100"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M62 48v1h-1v-1z",
    fill: "#0c0707"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M64 49v-1h1v1z",
    fill: "#0c0606"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M67 48v1h-1v-1z",
    fill: "#080303"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M68 48h1v1h-1z",
    fill: "#0c0809"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M69 48h1v1h-1z",
    fill: "#0f0d0d"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M74 48v1h-1v-1z",
    fill: "#6b6a66"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M76 49h-1v-1h1z",
    fill: "#84837f"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M76 48h1v1h-1z",
    fill: "#858480"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M78 49h-1v-1h1z",
    fill: "#7e7c78"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M80 48v1h-1v-1z",
    fill: "#645f5c"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M80 49v-1h1v1z",
    fill: "#161211"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M81 49v-1h1v1z",
    fill: "#282525",
    fillOpacity: 0.69
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M46 49v1h-1v-1z",
    fill: "#aaa",
    fillOpacity: 0.012
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M47 49v1h-1v-1z",
    fill: "#242320",
    fillOpacity: 0.792
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M48 49v1h-1v-1z",
    fill: "#181713"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M48 50v-1h1v1z",
    fill: "#494541"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M49 49h1v1h-1z",
    fill: "#47443f"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M53 50v-1h1v1z",
    fill: "#1b1b18"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M67 50h-1v-1h1z",
    fill: "#090403"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M69 49h1v1h-1z",
    fill: "#0e0d0c"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M73 49v1h-1v-1z",
    fill: "#302f2c"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M73 50v-1h1v1z",
    fill: "#656461"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M76 50h-1v-1h1z",
    fill: "#7d7c78"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M77 50v-1h1v1z",
    fill: "#7c7c77"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M81 49h1v1h-1z",
    fill: "#211d1b",
    fillOpacity: 0.847
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M83 49v1h-1v-1z",
    fill: "#717171",
    fillOpacity: 0.035
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M45 51v-1h1v1z",
    fill: "#5f5f5f",
    fillOpacity: 0.063
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M46 50h1v1h-1z",
    fill: "#1f1f1c",
    fillOpacity: 0.89
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M49 50v1h-1v-1z",
    fill: "#494642"
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M49 50h1v1h-1z",
    fill: "#433f3a"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M52 50v1h-1v-1z",
    fill: "#2f2c28"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M54 51h-1v-1h1z",
    fill: "#181815"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M54 50h1v1h-1z",
    fill: "#090907"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M58 51h-1v-1h1z",
    fill: "#050403"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M65 50h1v1h-1z",
    fill: "#0b0707"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "M75 51h-1v-1h1z",
    fill: "#6d6b67"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "M77 50h1v1h-1z",
    fill: "#7a7b76"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "M81 50v1h-1v-1z",
    fill: "#2d2926"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M81 50h1v1h-1z",
    fill: "#1d1816",
    fillOpacity: 0.929
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M82 51v-1h1v1z",
    fill: "#515148",
    fillOpacity: 0.11
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "M47 51v1h-1v-1z",
    fill: "#1c1c19",
    fillOpacity: 0.941
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M48 52h-1v-1h1z",
    fill: "#22201c"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M49 52h-1v-1h1z",
    fill: "#484441"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "M49 52v-1h1v1z",
    fill: "#3f3b36"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "M52 52h-1v-1h1z",
    fill: "#2d2a27"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "M73 52v-1h1v1z",
    fill: "#595754"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "M75 52h-1v-1h1z",
    fill: "#6a6663"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "M77 51h1v1h-1z",
    fill: "#7a7974"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "M80 52v-1h1v1z",
    fill: "#383432"
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "M82 52h-1v-1h1z",
    fill: "#181512",
    fillOpacity: 0.973
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "M83 51v1h-1v-1z",
    fill: "#444",
    fillOpacity: 0.176
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "M46 52v1h-1v-1z",
    fill: "#3a3a3a",
    fillOpacity: 0.153
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "M46 53v-1h1v1z",
    fill: "#1a1916",
    fillOpacity: 0.965
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "M48 52h1v1h-1z",
    fill: "#46423e"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "M49 52h1v1h-1z",
    fill: "#3c3834"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "M51 52h1v1h-1z",
    fill: "#2c2926"
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "M53 52h1v1h-1z",
    fill: "#151512"
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "M72 53h-1v-1h1z",
    fill: "#0e0e0c"
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "M73 52h1v1h-1z",
    fill: "#54524f"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "M74 53v-1h1v1z",
    fill: "#676360"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "M76 53v-1h1v1z",
    fill: "#767571"
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "M77 52h1v1h-1z",
    fill: "#787672"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "M81 53h-1v-1h1z",
    fill: "#403c39"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "M82 53h-1v-1h1z",
    fill: "#171310",
    fillOpacity: 0.996
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "M82 53v-1h1v1z",
    fill: "#454540",
    fillOpacity: 0.231
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "M46 54h-1v-1h1z",
    fill: "#3c3c3c",
    fillOpacity: 0.165
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "M47 53v1h-1v-1z",
    fill: "#191916",
    fillOpacity: 0.969
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "M49 54h-1v-1h1z",
    fill: "#45413d"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "M50 53v1h-1v-1z",
    fill: "#3b3732"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "M51 54v-1h1v1z",
    fill: "#2c2925"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "M54 54v-1h1v1z",
    fill: "#080707"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "M72 53h1v1h-1z",
    fill: "#151311"
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "M74 53h1v1h-1z",
    fill: "#65615e"
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "M76 53h1v1h-1z",
    fill: "#75726e"
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "M78 54v-1h1v1z",
    fill: "#77726f"
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "M81 53v1h-1v-1z",
    fill: "#413f3c"
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "M81 53h1v1h-1z",
    fill: "#161410"
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "M83 53v1h-1v-1z",
    fill: "#46423e",
    fillOpacity: 0.255
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "M46 54v1h-1v-1z",
    fill: "#3f3f3f",
    fillOpacity: 0.157
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "M47 55h-1v-1h1z",
    fill: "#191816",
    fillOpacity: 0.965
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "M48 54h1v1h-1z",
    fill: "#44403c"
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "M49 55v-1h1v1z",
    fill: "#393631"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "M62 55h-1v-1h1z",
    fill: "#100d0b"
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "M63 54v1h-1v-1z",
    fill: "#120e0d"
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "M67 55h-1v-1h1z",
    fill: "#0c0908"
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "M81 55v-1h1v1z",
    fill: "#151410"
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "M82 54h1v1h-1z",
    fill: "#444440",
    fillOpacity: 0.247
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "M45 56v-1h1v1z",
    fill: "#3f3f38",
    fillOpacity: 0.141
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "M47 56h-1v-1h1z",
    fill: "#1b1a16",
    fillOpacity: 0.957
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "M53 55h1v1h-1z",
    fill: "#151413"
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "M82 55v1h-1v-1z",
    fill: "#171612",
    fillOpacity: 0.996
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "M83 56h-1v-1h1z",
    fill: "#464641",
    fillOpacity: 0.227
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "M45 56h1v1h-1z",
    fill: "#414141",
    fillOpacity: 0.137
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "M46 56h1v1h-1z",
    fill: "#1c1b19",
    fillOpacity: 0.953
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "M47 56h1v1h-1z",
    fill: "#221f1c"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "M49 56v1h-1v-1z",
    fill: "#423f3b"
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "M54 56v1h-1v-1z",
    fill: "#161414"
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "M71 57v-1h1v1z",
    fill: "#080809"
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "M74 57h-1v-1h1z",
    fill: "#534f4b"
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "M81 57h-1v-1h1z",
    fill: "#3b3935"
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "M81 56h1v1h-1z",
    fill: "#171612",
    fillOpacity: 0.988
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "M83 56v1h-1v-1z",
    fill: "#434343",
    fillOpacity: 0.208
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "M47 58h-1v-1h1z",
    fill: "#1e1d1a",
    fillOpacity: 0.949
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "M47 58v-1h1v1z",
    fill: "#201d1a"
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "M72 57h1v1h-1z",
    fill: "#131210"
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "M74 57v1h-1v-1z",
    fill: "#53504c"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "M80 57h1v1h-1z",
    fill: "#383733"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "M81 58v-1h1v1z",
    fill: "#181713",
    fillOpacity: 0.976
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "M45 58h1v1h-1z",
    fill: "#5e5e5e",
    fillOpacity: 0.106
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "M47 58v1h-1v-1z",
    fill: "#1f1e1b",
    fillOpacity: 0.929
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "M51 59v-1h1v1z",
    fill: "#2b2825"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "M74 59h-1v-1h1z",
    fill: "#54514c"
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "M80 59h-1v-1h1z",
    fill: "#74716d"
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "M80 58h1v1h-1z",
    fill: "#353430"
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "M81 58h1v1h-1z",
    fill: "#181713",
    fillOpacity: 0.961
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "M83 58v1h-1v-1z",
    fill: "#43433c",
    fillOpacity: 0.149
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "M46 59h1v1h-1z",
    fill: "#1f1e1b",
    fillOpacity: 0.922
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "M48 60h-1v-1h1z",
    fill: "#1d1b18"
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "M49 60h-1v-1h1z",
    fill: "#423e3a"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "M73 59h1v1h-1z",
    fill: "#54514d"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "M80 59h1v1h-1z",
    fill: "#33322f"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "M83 59v1h-1v-1z",
    fill: "#434343",
    fillOpacity: 0.133
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "M46 60h1v1h-1z",
    fill: "#1f1e1b",
    fillOpacity: 0.918
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "M48 61h-1v-1h1z",
    fill: "#1c1a16"
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "M48 60h1v1h-1z",
    fill: "#3b3734"
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "M49 60h1v1h-1z",
    fill: "#322e29"
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "M50 61v-1h1v1z",
    fill: "#2b2723"
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "M52 61h-1v-1h1z",
    fill: "#24211d"
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "M54 61h-1v-1h1z",
    fill: "#0f0d0b"
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "M59 60h1v1h-1z",
    fill: "#070303"
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "M66 61h-1v-1h1z",
    fill: "#090303"
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "M67 60v1h-1v-1z",
    fill: "#070100"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "M67 61v-1h1v1z",
    fill: "#030000"
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "M71 60h1v1h-1z",
    fill: "#000101"
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "M74 60v1h-1v-1z",
    fill: "#4e4c47"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "M75 61h-1v-1h1z",
    fill: "#5f5a57"
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "M78 61h-1v-1h1z",
    fill: "#726e6b"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "M81 60v1h-1v-1z",
    fill: "#32312e"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "M83 61h-1v-1h1z",
    fill: "#454545",
    fillOpacity: 0.129
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "M47 62h-1v-1h1z",
    fill: "#1d1c1a",
    fillOpacity: 0.918
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "M47 61h1v1h-1z",
    fill: "#252420"
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "M49 62h-1v-1h1z",
    fill: "#8a8884"
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "M49 62v-1h1v1z",
    fill: "#82807c"
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "M50 61h1v1h-1z",
    fill: "#787571"
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "M52 62h-1v-1h1z",
    fill: "#6e6d68"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "M53 62h-1v-1h1z",
    fill: "#646460"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "M54 61v1h-1v-1z",
    fill: "#585854"
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "M54 62v-1h1v1z",
    fill: "#4c4c48"
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "M56 62h-1v-1h1z",
    fill: "#464643"
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "M56 62v-1h1v1z",
    fill: "#454542"
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "M57 61h1v1h-1z",
    fill: "#444441"
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "M58 61h1v1h-1z",
    fill: "#434340"
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "M60 62h-1v-1h1z",
    fill: "#43433f"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "M65 61h1v1h-1z",
    fill: "#43413f"
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "M70 62h-1v-1h1z",
    fill: "#444342"
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "M71 61v1h-1v-1z",
    fill: "#464544"
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "M71 62v-1h1v1z",
    fill: "#474746"
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "M73 61v1h-1v-1z",
    fill: "#525250"
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "M74 62h-1v-1h1z",
    fill: "#82807e"
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "M74 61h1v1h-1z",
    fill: "#8f8e8b"
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "M76 62h-1v-1h1z",
    fill: "#989794"
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "M76 61h1v1h-1z",
    fill: "#a19f9d"
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "M77 62v-1h1v1z",
    fill: "#a6a4a2"
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "M78 62v-1h1v1z",
    fill: "#aaa8a6"
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "M80 62h-1v-1h1z",
    fill: "#afadaa"
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "M81 61v1h-1v-1z",
    fill: "#3c3b38"
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "M82 62h-1v-1h1z",
    fill: "#181713",
    fillOpacity: 0.945
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "M82 62v-1h1v1z",
    fill: "#45453d",
    fillOpacity: 0.129
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "M46 62h1v1h-1z",
    fill: "#1c1b19",
    fillOpacity: 0.918
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "M48 62v1h-1v-1z",
    fill: "#2e2d29"
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "M49 63v-1h1v1z",
    fill: "#f2f1ed"
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "M50 63v-1h1v1z",
    fill: "#f0efeb"
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "M51 62h1v1h-1z",
    fill: "#efefea"
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "M60 62h1v1h-1z",
    fill: "#e8eae4"
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "M62 62v1h-1v-1z",
    fill: "#e8eae5"
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "M65 62h1v1h-1z",
    fill: "#eaebe7"
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "M75 63v-1h1v1z",
    fill: "#f5f6f4"
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "M76 63v-1h1v1z",
    fill: "#f7f7f5"
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "M78 63h-1v-1h1z",
    fill: "#f8f8f6"
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "M78 62h1v1h-1z",
    fill: "#fafaf8"
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "M79 63v-1h1v1z",
    fill: "#fcfbf9"
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "M81 63v-1h1v1z",
    fill: "#161510",
    fillOpacity: 0.945
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "M47 63v1h-1v-1z",
    fill: "#1c1b1a",
    fillOpacity: 0.914
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "M79 63h1v1h-1z",
    fill: "#f6f6f3"
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "M81 63v1h-1v-1z",
    fill: "#494844"
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "M81 64v-1h1v1z",
    fill: "#161511",
    fillOpacity: 0.945
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "M45 64h1v1h-1z",
    fill: "#68685c",
    fillOpacity: 0.086
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "M51 64h1v1h-1z",
    fill: "#ebebe7"
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "M66 64v1h-1v-1z",
    fill: "#e8e9e5"
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "M66 65v-1h1v1z",
    fill: "#ecebea"
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "M80 65h-1v-1h1z",
    fill: "#f6f5f3"
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "M81 64v1h-1v-1z",
    fill: "#474642"
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "M82 64v1h-1v-1z",
    fill: "#161511",
    fillOpacity: 0.941
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "M45 66v-1h1v1z",
    fill: "#5c5c5c",
    fillOpacity: 0.086
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "M50 65v1h-1v-1z",
    fill: "#ecebe7"
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "M50 66v-1h1v1z",
    fill: "#cdccc8"
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "M51 65h1v1h-1z",
    fill: "#c7c7c2"
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "M70 65v1h-1v-1z",
    fill: "#d0d0cf"
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "M71 65h1v1h-1z",
    fill: "#d1d1cf"
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "M75 66h-1v-1h1z",
    fill: "#d9d8d6"
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "M75 66v-1h1v1z",
    fill: "#dddddb"
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "M77 66h-1v-1h1z",
    fill: "#d6d5d3"
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "M80 65v1h-1v-1z",
    fill: "#f5f4f2"
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "M81 65h1v1h-1z",
    fill: "#171613",
    fillOpacity: 0.941
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "M49 67v-1h1v1z",
    fill: "#efeeea"
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "M50 66h1v1h-1z",
    fill: "#b1b0ac"
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "M51 66h1v1h-1z",
    fill: "#91918c"
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "M52 66h1v1h-1z",
    fill: "#adaea9"
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "M55 67v-1h1v1z",
    fill: "#a0a19c"
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "M57 67h-1v-1h1z",
    fill: "#a4a5a0"
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "M59 67v-1h1v1z",
    fill: "#92938e"
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "M62 66h1v1h-1z",
    fill: "#989994"
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "M64 67h-1v-1h1z",
    fill: "#a2a39e"
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "M65 67v-1h1v1z",
    fill: "#a7a8a3"
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "M66 67v-1h1v1z",
    fill: "#9d9e98"
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "M68 66v1h-1v-1z",
    fill: "#8f8f8d"
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "M68 67v-1h1v1z",
    fill: "#a0a09e"
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "M69 66h1v1h-1z",
    fill: "#878786"
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "M71 67h-1v-1h1z",
    fill: "#81817f"
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "M71 67v-1h1v1z",
    fill: "#bcbcba"
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "M73 66v1h-1v-1z",
    fill: "#999997"
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "M74 67h-1v-1h1z",
    fill: "#a6a6a4"
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "M76 67h-1v-1h1z",
    fill: "#cac9c7"
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "M77 66v1h-1v-1z",
    fill: "#b8b7b5"
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "M46 67h1v1h-1z",
    fill: "#1b1b19",
    fillOpacity: 0.91
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "M49 67h1v1h-1z",
    fill: "#edece8"
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "M50 68v-1h1v1z",
    fill: "#cbc9c6"
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "M51 67h1v1h-1z",
    fill: "#868681"
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "M53 68h-1v-1h1z",
    fill: "#8f908b"
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "M56 67v1h-1v-1z",
    fill: "#8a8b86"
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "M56 68v-1h1v1z",
    fill: "#70716c"
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "M58 68h-1v-1h1z",
    fill: "#e4e5e0"
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "M63 67v1h-1v-1z",
    fill: "#71726d"
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "M64 68v-1h1v1z",
    fill: "#9c9d98"
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "M65 68v-1h1v1z",
    fill: "#afb0ab"
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "M66 67h1v1h-1z",
    fill: "#8b8c87"
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "M68 67v1h-1v-1z",
    fill: "#939391"
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "M68 67h1v1h-1z",
    fill: "#b7b7b6"
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "M69 68v-1h1v1z",
    fill: "#8a8a89"
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "M71 68h-1v-1h1z",
    fill: "#828280"
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "M72 67h1v1h-1z",
    fill: "#767674"
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "M73 67h1v1h-1z",
    fill: "#81807e"
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "M75 68v-1h1v1z",
    fill: "#c5c4c2"
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "M77 67v1h-1v-1z",
    fill: "#acaba9"
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "M80 68h-1v-1h1z",
    fill: "#f4f5f3"
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "M52 69h-1v-1h1z",
    fill: "#a1a09c"
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "M56 69h-1v-1h1z",
    fill: "#959691"
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "M57 68v1h-1v-1z",
    fill: "#91928d"
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "M59 69v-1h1v1z",
    fill: "#858681"
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "M62 68h1v1h-1z",
    fill: "#868782"
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "M64 68v1h-1v-1z",
    fill: "#aaaba6"
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "M64 68h1v1h-1z",
    fill: "#9fa09b"
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "M68 69h-1v-1h1z",
    fill: "#848482"
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "M68 69v-1h1v1z",
    fill: "#afafad"
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "M69 69v-1h1v1z",
    fill: "#858584"
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "M71 68v1h-1v-1z",
    fill: "#7f7f7d"
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "M71 69v-1h1v1z",
    fill: "#c8c8c6"
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "M73 68v1h-1v-1z",
    fill: "#8e8e8c"
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "M73 69v-1h1v1z",
    fill: "#979694"
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "M74 69v-1h1v1z",
    fill: "#d1d0ce"
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "M76 69h-1v-1h1z",
    fill: "#a2a19f"
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "M77 69h-1v-1h1z",
    fill: "#bebdbb"
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "M81 68v1h-1v-1z",
    fill: "#474644"
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "M81 69v-1h1v1z",
    fill: "#161613",
    fillOpacity: 0.941
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "M50 70h-1v-1h1z",
    fill: "#e9e8e4"
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "M54 69h1v1h-1z",
    fill: "#c4c5c0"
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "M59 70v-1h1v1z",
    fill: "#bec0b8"
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "M60 70v-1h1v1z",
    fill: "#babcb6"
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    d: "M62 70h-1v-1h1z",
    fill: "#c7c8c3"
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    d: "M63 69v1h-1v-1z",
    fill: "#c4c5c2"
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    d: "M63 69h1v1h-1z",
    fill: "#b5b6b2"
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    d: "M64 69h1v1h-1z",
    fill: "#bdbdb9"
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    d: "M66 69v1h-1v-1z",
    fill: "#c0c2be"
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    d: "M67 69v1h-1v-1z",
    fill: "#bdbebb"
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    d: "M67 70v-1h1v1z",
    fill: "#c1c0bd"
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    d: "M69 70h-1v-1h1z",
    fill: "#b4b3b1"
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    d: "M69 69h1v1h-1z",
    fill: "#b4b4b5"
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    d: "M71 70h-1v-1h1z",
    fill: "#b4b5b6"
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    d: "M72 69v1h-1v-1z",
    fill: "#c1c2c0"
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    d: "M73 69h1v1h-1z",
    fill: "#dededb"
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    d: "M75 70v-1h1v1z",
    fill: "#dedddb"
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "M79 70h-1v-1h1z",
    fill: "#f4f4f3"
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "M49 71h-1v-1h1z",
    fill: "#dddcd7"
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "M51 71v-1h1v1z",
    fill: "#e7e7e2"
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "M57 70v1h-1v-1z",
    fill: "#e4e6e1"
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    d: "M58 71h-1v-1h1z",
    fill: "#e3e2da"
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    d: "M58 70h1v1h-1z",
    fill: "#e4e3da"
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    d: "M59 70h1v1h-1z",
    fill: "#e4e4dc"
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "M60 71v-1h1v1z",
    fill: "#e6e5dd"
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    d: "M62 70v1h-1v-1z",
    fill: "#e6e4db"
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    d: "M62 71v-1h1v1z",
    fill: "#e8e7e1"
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    d: "M64 70v1h-1v-1z",
    fill: "#e7e5de"
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    d: "M64 71v-1h1v1z",
    fill: "#e8e8de"
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    d: "M66 71h-1v-1h1z",
    fill: "#e8e7e0"
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    d: "M67 71h-1v-1h1z",
    fill: "#e7e6e0"
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "M67 71v-1h1v1z",
    fill: "#ebeae4"
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    d: "M69 70v1h-1v-1z",
    fill: "#ebe9e3"
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    d: "M69 71v-1h1v1z",
    fill: "#ece9e3"
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    d: "M70 70h1v1h-1z",
    fill: "#edeadf"
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    d: "M71 70h1v1h-1z",
    fill: "#f1eee7"
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    d: "M73 71h-1v-1h1z",
    fill: "#f1eeef"
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "M81 70v1h-1v-1z",
    fill: "#464542"
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    d: "M81 70h1v1h-1z",
    fill: "#171712",
    fillOpacity: 0.941
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    d: "M48 71v1h-1v-1z",
    fill: "#2a2925"
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    d: "M50 72h-1v-1h1z",
    fill: "#e5e4e0"
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    d: "M58 71v1h-1v-1z",
    fill: "#d2cab6"
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    d: "M58 71h1v1h-1z",
    fill: "#d7cbb3"
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    d: "M60 71v1h-1v-1z",
    fill: "#dbcfbe"
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    d: "M60 72v-1h1v1z",
    fill: "#d8cbb4"
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    d: "M62 72h-1v-1h1z",
    fill: "#d2c6ad"
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    d: "M63 71v1h-1v-1z",
    fill: "#dcd1c0"
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    d: "M63 71h1v1h-1z",
    fill: "#d6cbb7"
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    d: "M64 71h1v1h-1z",
    fill: "#d3c9b4"
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    d: "M65 72v-1h1v1z",
    fill: "#d2c3ae"
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    d: "M66 72v-1h1v1z",
    fill: "#cfc2ae"
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    d: "M68 72h-1v-1h1z",
    fill: "#dcd6c8"
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    d: "M69 72h-1v-1h1z",
    fill: "#d3caba"
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    d: "M70 72h-1v-1h1z",
    fill: "#d1c5b3"
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    d: "M71 72h-1v-1h1z",
    fill: "#d2c9b6"
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    d: "M71 72v-1h1v1z",
    fill: "#e7e2d6"
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    d: "M72 71h1v1h-1z",
    fill: "#efecec"
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    d: "M77 71h1v1h-1z",
    fill: "#efefee"
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    d: "M82 71h1v1h-1z",
    fill: "#474f47",
    fillOpacity: 0.125
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    d: "M47 73v-1h1v1z",
    fill: "#2a2926"
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    d: "M49 72v1h-1v-1z",
    fill: "#dad9d5"
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    d: "M57 73v-1h1v1z",
    fill: "#e1e1d8"
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    d: "M59 73h-1v-1h1z",
    fill: "#e1e1d7"
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    d: "M59 72h1v1h-1z",
    fill: "#e1e3dc"
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    d: "M60 72h1v1h-1z",
    fill: "#e0dfd6"
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    d: "M62 72v1h-1v-1z",
    fill: "#e0e0d5"
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    d: "M63 72v1h-1v-1z",
    fill: "#dfdfd9"
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    d: "M64 73v-1h1v1z",
    fill: "#dfe0d6"
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    d: "M65 72h1v1h-1z",
    fill: "#e2e0d8"
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    d: "M66 72h1v1h-1z",
    fill: "#e2e1d8"
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    d: "M67 73v-1h1v1z",
    fill: "#e3e5e1"
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    d: "M69 72v1h-1v-1z",
    fill: "#e5e6e0"
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    d: "M70 72v1h-1v-1z",
    fill: "#e9e6e2"
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    d: "M72 72v1h-1v-1z",
    fill: "#ebebe5"
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    d: "M72 73v-1h1v1z",
    fill: "#e9ebe8"
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    d: "M74 72v1h-1v-1z",
    fill: "#e9ece6"
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    d: "M83 73h-1v-1h1z",
    fill: "#4f4f47",
    fillOpacity: 0.125
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    d: "M47 73v1h-1v-1z",
    fill: "#1c1b1a",
    fillOpacity: 0.906
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    d: "M48 74h-1v-1h1z",
    fill: "#282723"
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    d: "M49 74v-1h1v1z",
    fill: "#e6e6e2"
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    d: "M51 74v-1h1v1z",
    fill: "#e2e2de"
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    d: "M57 73h1v1h-1z",
    fill: "#dee0de"
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    d: "M59 74h-1v-1h1z",
    fill: "#dde0de"
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    d: "M60 74h-1v-1h1z",
    fill: "#dee0db"
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    d: "M62 73v1h-1v-1z",
    fill: "#e0e2dd"
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    d: "M63 74h-1v-1h1z",
    fill: "#e3e3e0"
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    d: "M66 73v1h-1v-1z",
    fill: "#e1e5e1"
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    d: "M67 74h-1v-1h1z",
    fill: "#e3e5e3"
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    d: "M68 73h1v1h-1z",
    fill: "#e7e6e5"
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    d: "M71 74v-1h1v1z",
    fill: "#e8ebe8"
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    d: "M73 74h-1v-1h1z",
    fill: "#eaebeb"
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    d: "M77 74v-1h1v1z",
    fill: "#ededec"
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    d: "M78 74v-1h1v1z",
    fill: "#f0f0ef"
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    d: "M80 74v-1h1v1z",
    fill: "#454440"
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    d: "M48 74v1h-1v-1z",
    fill: "#292824"
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    d: "M53 74h1v1h-1z",
    fill: "#e3e5e0"
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    d: "M56 74v1h-1v-1z",
    fill: "#dfe3de"
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    d: "M57 75h-1v-1h1z",
    fill: "#dee1db"
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    d: "M60 75h-1v-1h1z",
    fill: "#dfdfda"
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    d: "M60 75v-1h1v1z",
    fill: "#e0e2dc"
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    d: "M62 75h-1v-1h1z",
    fill: "#dfe1dd"
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    d: "M63 75h-1v-1h1z",
    fill: "#e2dedc"
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    d: "M63 75v-1h1v1z",
    fill: "#e1e0db"
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    d: "M64 74h1v1h-1z",
    fill: "#dfe4dc"
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    d: "M65 74h1v1h-1z",
    fill: "#e3e4de"
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    d: "M69 75h-1v-1h1z",
    fill: "#e6e7e4"
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    d: "M70 74v1h-1v-1z",
    fill: "#e6e8e4"
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    d: "M71 74v1h-1v-1z",
    fill: "#e5e6e3"
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    d: "M73 75h-1v-1h1z",
    fill: "#e3e5e2"
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    d: "M78 74h1v1h-1z",
    fill: "#eeefed"
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    d: "M48 75v1h-1v-1z",
    fill: "#292724"
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    d: "M53 76v-1h1v1z",
    fill: "#d9ded6"
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    d: "M55 76h-1v-1h1z",
    fill: "#dfe3dc"
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    d: "M56 75v1h-1v-1z",
    fill: "#e4e6e4"
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    d: "M56 75h1v1h-1z",
    fill: "#dce0db"
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    d: "M59 75v1h-1v-1z",
    fill: "#d7dbd4"
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    d: "M60 75h1v1h-1z",
    fill: "#e4e3e3"
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    d: "M62 76v-1h1v1z",
    fill: "#e4e6e2"
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    d: "M64 76v-1h1v1z",
    fill: "#e0e5e1"
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    d: "M66 76h-1v-1h1z",
    fill: "#e5e7e6"
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    d: "M67 75v1h-1v-1z",
    fill: "#dee0dd"
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    d: "M67 76v-1h1v1z",
    fill: "#daddd7"
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    d: "M71 76h-1v-1h1z",
    fill: "#eae8e4"
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    d: "M72 76h-1v-1h1z",
    fill: "#e7e8e4"
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    d: "M73 76h-1v-1h1z",
    fill: "#eaece9"
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    d: "M46 77v-1h1v1z",
    fill: "#1e1b1a",
    fillOpacity: 0.906
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    d: "M52 76h1v1h-1z",
    fill: "#d8dad5"
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    d: "M53 77v-1h1v1z",
    fill: "#d7c6c3"
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    d: "M54 77v-1h1v1z",
    fill: "#d2a79f"
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    d: "M56 76v1h-1v-1z",
    fill: "#e0bbb8"
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    d: "M56 77v-1h1v1z",
    fill: "#d5b8b9"
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    d: "M58 76v1h-1v-1z",
    fill: "#ceb1af"
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    d: "M58 76h1v1h-1z",
    fill: "#cfbcb6"
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    d: "M59 77v-1h1v1z",
    fill: "#cfcbcb"
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    d: "M61 76v1h-1v-1z",
    fill: "#d0c4c4"
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    d: "M62 77h-1v-1h1z",
    fill: "#d6bab6"
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    d: "M63 77h-1v-1h1z",
    fill: "#d3b4b4"
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    d: "M64 77h-1v-1h1z",
    fill: "#dac7c5"
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    d: "M64 76h1v1h-1z",
    fill: "#dbcfcd"
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    d: "M65 77v-1h1v1z",
    fill: "#cdbfc0"
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    d: "M67 77h-1v-1h1z",
    fill: "#dcd7d6"
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    d: "M68 76v1h-1v-1z",
    fill: "#dedbd9"
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    d: "M69 77h-1v-1h1z",
    fill: "#d1bdc1"
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    d: "M70 77h-1v-1h1z",
    fill: "#d3b1b6"
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    d: "M70 77v-1h1v1z",
    fill: "#ddb7bb"
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    d: "M71 76h1v1h-1z",
    fill: "#dccaca"
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    d: "M72 77v-1h1v1z",
    fill: "#dec2c7"
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    d: "M74 77h-1v-1h1z",
    fill: "#e3dedd"
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    d: "M75 77h-1v-1h1z",
    fill: "#e5e6e4"
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    d: "M47 77v1h-1v-1z",
    fill: "#1e1c1b",
    fillOpacity: 0.906
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    d: "M48 77v1h-1v-1z",
    fill: "#282623"
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    d: "M52 78v-1h1v1z",
    fill: "#d5dad4"
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    d: "M53 77h1v1h-1z",
    fill: "#d1bab4"
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    d: "M55 77v1h-1v-1z",
    fill: "#b21c20"
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    d: "M55 78v-1h1v1z",
    fill: "#c12220"
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    d: "M57 77v1h-1v-1z",
    fill: "#c13535"
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    d: "M58 78h-1v-1h1z",
    fill: "#c03434"
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    d: "M59 78h-1v-1h1z",
    fill: "#b74546"
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    d: "M59 78v-1h1v1z",
    fill: "#d5c5c2"
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    d: "M61 78h-1v-1h1z",
    fill: "#a3898a"
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    d: "M62 78h-1v-1h1z",
    fill: "#8f2c33"
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    d: "M62 78v-1h1v1z",
    fill: "#953037"
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    d: "M64 77v1h-1v-1z",
    fill: "#913c42"
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    d: "M64 78v-1h1v1z",
    fill: "#924a4e"
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    d: "M66 78h-1v-1h1z",
    fill: "#8c353d"
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    d: "M67 77v1h-1v-1z",
    fill: "#be9997"
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    d: "M67 78v-1h1v1z",
    fill: "#d7cbca"
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    d: "M68 77h1v1h-1z",
    fill: "#a45364"
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    d: "M69 78v-1h1v1z",
    fill: "#a74553"
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    d: "M70 77h1v1h-1z",
    fill: "#b64c5d"
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    d: "M72 78h-1v-1h1z",
    fill: "#b45364"
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    d: "M72 77h1v1h-1z",
    fill: "#bb576b"
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    d: "M74 77v1h-1v-1z",
    fill: "#dabebd"
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    d: "M74 78v-1h1v1z",
    fill: "#e6e9e6"
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    d: "M45 78h1v1h-1z",
    fill: "#726666",
    fillOpacity: 0.078
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    d: "M47 78h1v1h-1z",
    fill: "#272622"
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    d: "M52 79h-1v-1h1z",
    fill: "#d2d4cf"
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    d: "M53 79h-1v-1h1z",
    fill: "#d3d6d1"
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    d: "M54 78v1h-1v-1z",
    fill: "#d8d8d1"
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    d: "M54 79v-1h1v1z",
    fill: "#bd4a4e"
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    d: "M56 79h-1v-1h1z",
    fill: "#b71917"
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    d: "M56 79v-1h1v1z",
    fill: "#b62d2e"
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    d: "M58 79h-1v-1h1z",
    fill: "#b93433"
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    d: "M58 78h1v1h-1z",
    fill: "#a42f2f"
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    d: "M59 78h1v1h-1z",
    fill: "#bf8989"
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    d: "M61 78v1h-1v-1z",
    fill: "#c6b9b6"
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    d: "M61 79v-1h1v1z",
    fill: "#88383f"
  })), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    d: "M62 79v-1h1v1z",
    fill: "#913134"
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    d: "M64 78h1v1h-1z",
    fill: "#87343a"
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    d: "M66 79h-1v-1h1z",
    fill: "#952e35"
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    d: "M66 79v-1h1v1z",
    fill: "#884648"
  })), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    d: "M68 78v1h-1v-1z",
    fill: "#d1c9c7"
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    d: "M68 79v-1h1v1z",
    fill: "#ad6e7c"
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    d: "M70 79h-1v-1h1z",
    fill: "#a24350"
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    d: "M71 79h-1v-1h1z",
    fill: "#ad4a5a"
  })), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    d: "M71 79v-1h1v1z",
    fill: "#af4d5e"
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    d: "M73 79h-1v-1h1z",
    fill: "#b15062"
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    d: "M74 79h-1v-1h1z",
    fill: "#ca9199"
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    d: "M75 78v1h-1v-1z",
    fill: "#e4e9e5"
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    d: "M76 78h1v1h-1z",
    fill: "#e5e4e4"
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    d: "M79 79h-1v-1h1z",
    fill: "#e9e9e9"
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    d: "M80 78v1h-1v-1z",
    fill: "#e4e3e2"
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    d: "M54 80h-1v-1h1z",
    fill: "#d9dfd8"
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    d: "M54 79h1v1h-1z",
    fill: "#c68c8a"
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    d: "M56 79v1h-1v-1z",
    fill: "#a41d1e"
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    d: "M57 80h-1v-1h1z",
    fill: "#ad3030"
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    d: "M58 79v1h-1v-1z",
    fill: "#ad3736"
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    d: "M58 79h1v1h-1z",
    fill: "#9a3430"
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    d: "M60 79v1h-1v-1z",
    fill: "#a55050"
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    d: "M60 80v-1h1v1z",
    fill: "#cfc6c2"
  })), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    d: "M62 80h-1v-1h1z",
    fill: "#985d64"
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    d: "M63 79v1h-1v-1z",
    fill: "#922e34"
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    d: "M63 80v-1h1v1z",
    fill: "#8a343a"
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    d: "M64 80v-1h1v1z",
    fill: "#7e3339"
  })), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    d: "M65 79h1v1h-1z",
    fill: "#8b3139"
  })), _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    d: "M67 80h-1v-1h1z",
    fill: "#7b2830"
  })), _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    d: "M68 79v1h-1v-1z",
    fill: "#baa6a6"
  })), _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    d: "M69 80h-1v-1h1z",
    fill: "#bea2a6"
  })), _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    d: "M70 80h-1v-1h1z",
    fill: "#a84859"
  })), _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    d: "M71 80h-1v-1h1z",
    fill: "#ad4a5b"
  })), _path1450 || (_path1450 = /*#__PURE__*/React.createElement("path", {
    d: "M72 79v1h-1v-1z",
    fill: "#ab4a5b"
  })), _path1451 || (_path1451 = /*#__PURE__*/React.createElement("path", {
    d: "M73 79v1h-1v-1z",
    fill: "#ad5262"
  })), _path1452 || (_path1452 = /*#__PURE__*/React.createElement("path", {
    d: "M74 79v1h-1v-1z",
    fill: "#b5737e"
  })), _path1453 || (_path1453 = /*#__PURE__*/React.createElement("path", {
    d: "M74 80v-1h1v1z",
    fill: "#e2dad9"
  })), _path1454 || (_path1454 = /*#__PURE__*/React.createElement("path", {
    d: "M75 79h1v1h-1z",
    fill: "#e0e3e0"
  })), _path1455 || (_path1455 = /*#__PURE__*/React.createElement("path", {
    d: "M76 79h1v1h-1z",
    fill: "#e5e5e5"
  })), _path1456 || (_path1456 = /*#__PURE__*/React.createElement("path", {
    d: "M77 80v-1h1v1z",
    fill: "#e4e5e5"
  })), _path1457 || (_path1457 = /*#__PURE__*/React.createElement("path", {
    d: "M79 80v-1h1v1z",
    fill: "#e0e0df"
  })), _path1458 || (_path1458 = /*#__PURE__*/React.createElement("path", {
    d: "M54 81h-1v-1h1z",
    fill: "#d6d9d4"
  })), _path1459 || (_path1459 = /*#__PURE__*/React.createElement("path", {
    d: "M54 80h1v1h-1z",
    fill: "#cab6b5"
  })), _path1460 || (_path1460 = /*#__PURE__*/React.createElement("path", {
    d: "M56 81h-1v-1h1z",
    fill: "#942b2c"
  })), _path1461 || (_path1461 = /*#__PURE__*/React.createElement("path", {
    d: "M57 80v1h-1v-1z",
    fill: "#a82e2f"
  })), _path1462 || (_path1462 = /*#__PURE__*/React.createElement("path", {
    d: "M57 81v-1h1v1z",
    fill: "#ac3635"
  })), _path1463 || (_path1463 = /*#__PURE__*/React.createElement("path", {
    d: "M58 80h1v1h-1z",
    fill: "#ad3336"
  })), _path1464 || (_path1464 = /*#__PURE__*/React.createElement("path", {
    d: "M60 81h-1v-1h1z",
    fill: "#9f3030"
  })), _path1465 || (_path1465 = /*#__PURE__*/React.createElement("path", {
    d: "M60 80h1v1h-1z",
    fill: "#c9aaa5"
  })), _path1466 || (_path1466 = /*#__PURE__*/React.createElement("path", {
    d: "M62 80v1h-1v-1z",
    fill: "#bba3a3"
  })), _path1467 || (_path1467 = /*#__PURE__*/React.createElement("path", {
    d: "M63 80h1v1h-1z",
    fill: "#8a3237"
  })), _path1468 || (_path1468 = /*#__PURE__*/React.createElement("path", {
    d: "M65 81h-1v-1h1z",
    fill: "#7e3439"
  })), _path1469 || (_path1469 = /*#__PURE__*/React.createElement("path", {
    d: "M65 80h1v1h-1z",
    fill: "#863239"
  })), _path1470 || (_path1470 = /*#__PURE__*/React.createElement("path", {
    d: "M67 80v1h-1v-1z",
    fill: "#7d232b"
  })), _path1471 || (_path1471 = /*#__PURE__*/React.createElement("path", {
    d: "M67 81v-1h1v1z",
    fill: "#9a666a"
  })), _path1472 || (_path1472 = /*#__PURE__*/React.createElement("path", {
    d: "M69 81h-1v-1h1z",
    fill: "#dacecd"
  })), _path1473 || (_path1473 = /*#__PURE__*/React.createElement("path", {
    d: "M69 80h1v1h-1z",
    fill: "#9c5562"
  })), _path1474 || (_path1474 = /*#__PURE__*/React.createElement("path", {
    d: "M70 80h1v1h-1z",
    fill: "#ae4b5c"
  })), _path1475 || (_path1475 = /*#__PURE__*/React.createElement("path", {
    d: "M71 80h1v1h-1z",
    fill: "#b35061"
  })), _path1476 || (_path1476 = /*#__PURE__*/React.createElement("path", {
    d: "M72 80h1v1h-1z",
    fill: "#b35567"
  })), _path1477 || (_path1477 = /*#__PURE__*/React.createElement("path", {
    d: "M74 80v1h-1v-1z",
    fill: "#b66171"
  })), _path1478 || (_path1478 = /*#__PURE__*/React.createElement("path", {
    d: "M74 80h1v1h-1z",
    fill: "#d0b5b7"
  })), _path1479 || (_path1479 = /*#__PURE__*/React.createElement("path", {
    d: "M76 80v1h-1v-1z",
    fill: "#dadddb"
  })), _path1480 || (_path1480 = /*#__PURE__*/React.createElement("path", {
    d: "M76 81v-1h1v1z",
    fill: "#e0e0e0"
  })), _path1481 || (_path1481 = /*#__PURE__*/React.createElement("path", {
    d: "M81 80v1h-1v-1z",
    fill: "#434240"
  })), _path1482 || (_path1482 = /*#__PURE__*/React.createElement("path", {
    d: "M46 82v-1h1v1z",
    fill: "#1f1c1a",
    fillOpacity: 0.902
  })), _path1483 || (_path1483 = /*#__PURE__*/React.createElement("path", {
    d: "M48 81h1v1h-1z",
    fill: "#c6c8c3"
  })), _path1484 || (_path1484 = /*#__PURE__*/React.createElement("path", {
    d: "M54 81v1h-1v-1z",
    fill: "#d3d4d0"
  })), _path1485 || (_path1485 = /*#__PURE__*/React.createElement("path", {
    d: "M54 82v-1h1v1z",
    fill: "#d0caca"
  })), _path1486 || (_path1486 = /*#__PURE__*/React.createElement("path", {
    d: "M56 81v1h-1v-1z",
    fill: "#954a48"
  })), _path1487 || (_path1487 = /*#__PURE__*/React.createElement("path", {
    d: "M57 82h-1v-1h1z",
    fill: "#a52d2c"
  })), _path1488 || (_path1488 = /*#__PURE__*/React.createElement("path", {
    d: "M58 81v1h-1v-1z",
    fill: "#ac3636"
  })), _path1489 || (_path1489 = /*#__PURE__*/React.createElement("path", {
    d: "M58 82v-1h1v1z",
    fill: "#a33636"
  })), _path1490 || (_path1490 = /*#__PURE__*/React.createElement("path", {
    d: "M59 82v-1h1v1z",
    fill: "#a12628"
  })), _path1491 || (_path1491 = /*#__PURE__*/React.createElement("path", {
    d: "M60 82v-1h1v1z",
    fill: "#b06a67"
  })), _path1492 || (_path1492 = /*#__PURE__*/React.createElement("path", {
    d: "M62 82h-1v-1h1z",
    fill: "#d2cec8"
  })), _path1493 || (_path1493 = /*#__PURE__*/React.createElement("path", {
    d: "M63 82h-1v-1h1z",
    fill: "#975056"
  })), _path1494 || (_path1494 = /*#__PURE__*/React.createElement("path", {
    d: "M64 82h-1v-1h1z",
    fill: "#8b3036"
  })), _path1495 || (_path1495 = /*#__PURE__*/React.createElement("path", {
    d: "M65 81v1h-1v-1z",
    fill: "#833338"
  })), _path1496 || (_path1496 = /*#__PURE__*/React.createElement("path", {
    d: "M66 81v1h-1v-1z",
    fill: "#873237"
  })), _path1497 || (_path1497 = /*#__PURE__*/React.createElement("path", {
    d: "M67 82h-1v-1h1z",
    fill: "#82292d"
  })), _path1498 || (_path1498 = /*#__PURE__*/React.createElement("path", {
    d: "M67 81h1v1h-1z",
    fill: "#843139"
  })), _path1499 || (_path1499 = /*#__PURE__*/React.createElement("path", {
    d: "M68 82v-1h1v1z",
    fill: "#dbc9c8"
  })), _path1500 || (_path1500 = /*#__PURE__*/React.createElement("path", {
    d: "M70 82h-1v-1h1z",
    fill: "#b4898e"
  })), _path1501 || (_path1501 = /*#__PURE__*/React.createElement("path", {
    d: "M70 82v-1h1v1z",
    fill: "#a44453"
  })), _path1502 || (_path1502 = /*#__PURE__*/React.createElement("path", {
    d: "M72 81v1h-1v-1z",
    fill: "#a94758"
  })), _path1503 || (_path1503 = /*#__PURE__*/React.createElement("path", {
    d: "M73 81v1h-1v-1z",
    fill: "#a85060"
  })), _path1504 || (_path1504 = /*#__PURE__*/React.createElement("path", {
    d: "M74 82h-1v-1h1z",
    fill: "#b86070"
  })), _path1505 || (_path1505 = /*#__PURE__*/React.createElement("path", {
    d: "M75 81v1h-1v-1z",
    fill: "#cda5aa"
  })), _path1506 || (_path1506 = /*#__PURE__*/React.createElement("path", {
    d: "M75 82v-1h1v1z",
    fill: "#e7e8e6"
  })), _path1507 || (_path1507 = /*#__PURE__*/React.createElement("path", {
    d: "M77 81v1h-1v-1z",
    fill: "#e3e2e3"
  })), _path1508 || (_path1508 = /*#__PURE__*/React.createElement("path", {
    d: "M79 82h-1v-1h1z",
    fill: "#e6e6e6"
  })), _path1509 || (_path1509 = /*#__PURE__*/React.createElement("path", {
    d: "M47 83h-1v-1h1z",
    fill: "#1d1c1a",
    fillOpacity: 0.902
  })), _path1510 || (_path1510 = /*#__PURE__*/React.createElement("path", {
    d: "M52 83v-1h1v1z",
    fill: "#d0d2cd"
  })), _path1511 || (_path1511 = /*#__PURE__*/React.createElement("path", {
    d: "M53 83v-1h1v1z",
    fill: "#d4d5d1"
  })), _path1512 || (_path1512 = /*#__PURE__*/React.createElement("path", {
    d: "M54 82h1v1h-1z",
    fill: "#d3d2cd"
  })), _path1513 || (_path1513 = /*#__PURE__*/React.createElement("path", {
    d: "M55 82h1v1h-1z",
    fill: "#b9807d"
  })), _path1514 || (_path1514 = /*#__PURE__*/React.createElement("path", {
    d: "M56 82h1v1h-1z",
    fill: "#a62a29"
  })), _path1515 || (_path1515 = /*#__PURE__*/React.createElement("path", {
    d: "M58 83h-1v-1h1z",
    fill: "#963737"
  })), _path1516 || (_path1516 = /*#__PURE__*/React.createElement("path", {
    d: "M58 82h1v1h-1z",
    fill: "#a33534"
  })), _path1517 || (_path1517 = /*#__PURE__*/React.createElement("path", {
    d: "M60 82v1h-1v-1z",
    fill: "#ab292c"
  })), _path1518 || (_path1518 = /*#__PURE__*/React.createElement("path", {
    d: "M60 82h1v1h-1z",
    fill: "#aa3636"
  })), _path1519 || (_path1519 = /*#__PURE__*/React.createElement("path", {
    d: "M61 82h1v1h-1z",
    fill: "#d5c1bf"
  })), _path1520 || (_path1520 = /*#__PURE__*/React.createElement("path", {
    d: "M62 82h1v1h-1z",
    fill: "#b08d8d"
  })), _path1521 || (_path1521 = /*#__PURE__*/React.createElement("path", {
    d: "M63 83v-1h1v1z",
    fill: "#8a2c35"
  })), _path1522 || (_path1522 = /*#__PURE__*/React.createElement("path", {
    d: "M64 83v-1h1v1z",
    fill: "#8b363a"
  })), _path1523 || (_path1523 = /*#__PURE__*/React.createElement("path", {
    d: "M66 83h-1v-1h1z",
    fill: "#933136"
  })), _path1524 || (_path1524 = /*#__PURE__*/React.createElement("path", {
    d: "M66 82h1v1h-1z",
    fill: "#902d33"
  })), _path1525 || (_path1525 = /*#__PURE__*/React.createElement("path", {
    d: "M67 82h1v1h-1z",
    fill: "#831f25"
  })), _path1526 || (_path1526 = /*#__PURE__*/React.createElement("path", {
    d: "M69 82v1h-1v-1z",
    fill: "#bf9092"
  })), _path1527 || (_path1527 = /*#__PURE__*/React.createElement("path", {
    d: "M69 83v-1h1v1z",
    fill: "#d3b9bb"
  })), _path1528 || (_path1528 = /*#__PURE__*/React.createElement("path", {
    d: "M70 83v-1h1v1z",
    fill: "#9c4752"
  })), _path1529 || (_path1529 = /*#__PURE__*/React.createElement("path", {
    d: "M72 83h-1v-1h1z",
    fill: "#a74b5a"
  })), _path1530 || (_path1530 = /*#__PURE__*/React.createElement("path", {
    d: "M72 82h1v1h-1z",
    fill: "#ac5161"
  })), _path1531 || (_path1531 = /*#__PURE__*/React.createElement("path", {
    d: "M73 82h1v1h-1z",
    fill: "#a75b68"
  })), _path1532 || (_path1532 = /*#__PURE__*/React.createElement("path", {
    d: "M74 83v-1h1v1z",
    fill: "#cfb4b6"
  })), _path1533 || (_path1533 = /*#__PURE__*/React.createElement("path", {
    d: "M75 82h1v1h-1z",
    fill: "#e4e6e5"
  })), _path1534 || (_path1534 = /*#__PURE__*/React.createElement("path", {
    d: "M76 82h1v1h-1z",
    fill: "#e3e3e3"
  })), _path1535 || (_path1535 = /*#__PURE__*/React.createElement("path", {
    d: "M45 83h1v1h-1z",
    fill: "#716363",
    fillOpacity: 0.071
  })), _path1536 || (_path1536 = /*#__PURE__*/React.createElement("path", {
    d: "M53 84v-1h1v1z",
    fill: "#d6d7d4"
  })), _path1537 || (_path1537 = /*#__PURE__*/React.createElement("path", {
    d: "M55 83v1h-1v-1z",
    fill: "#d5d7d3"
  })), _path1538 || (_path1538 = /*#__PURE__*/React.createElement("path", {
    d: "M55 84v-1h1v1z",
    fill: "#cbb7b1"
  })), _path1539 || (_path1539 = /*#__PURE__*/React.createElement("path", {
    d: "M56 84v-1h1v1z",
    fill: "#a13839"
  })), _path1540 || (_path1540 = /*#__PURE__*/React.createElement("path", {
    d: "M58 83v1h-1v-1z",
    fill: "#a03533"
  })), _path1541 || (_path1541 = /*#__PURE__*/React.createElement("path", {
    d: "M59 83v1h-1v-1z",
    fill: "#a23734"
  })), _path1542 || (_path1542 = /*#__PURE__*/React.createElement("path", {
    d: "M59 83h1v1h-1z",
    fill: "#982e2b"
  })), _path1543 || (_path1543 = /*#__PURE__*/React.createElement("path", {
    d: "M60 84v-1h1v1z",
    fill: "#9d2020"
  })), _path1544 || (_path1544 = /*#__PURE__*/React.createElement("path", {
    d: "M62 84h-1v-1h1z",
    fill: "#b78889"
  })), _path1545 || (_path1545 = /*#__PURE__*/React.createElement("path", {
    d: "M62 83h1v1h-1z",
    fill: "#c9c4bd"
  })), _path1546 || (_path1546 = /*#__PURE__*/React.createElement("path", {
    d: "M63 83h1v1h-1z",
    fill: "#8f3f46"
  })), _path1547 || (_path1547 = /*#__PURE__*/React.createElement("path", {
    d: "M65 84h-1v-1h1z",
    fill: "#8a3338"
  })), _path1548 || (_path1548 = /*#__PURE__*/React.createElement("path", {
    d: "M66 83v1h-1v-1z",
    fill: "#92333b"
  })), _path1549 || (_path1549 = /*#__PURE__*/React.createElement("path", {
    d: "M66 84v-1h1v1z",
    fill: "#902c35"
  })), _path1550 || (_path1550 = /*#__PURE__*/React.createElement("path", {
    d: "M68 83v1h-1v-1z",
    fill: "#861b25"
  })), _path1551 || (_path1551 = /*#__PURE__*/React.createElement("path", {
    d: "M69 84h-1v-1h1z",
    fill: "#964a52"
  })), _path1552 || (_path1552 = /*#__PURE__*/React.createElement("path", {
    d: "M69 83h1v1h-1z",
    fill: "#ddd1ce"
  })), _path1553 || (_path1553 = /*#__PURE__*/React.createElement("path", {
    d: "M71 83v1h-1v-1z",
    fill: "#a75e6a"
  })), _path1554 || (_path1554 = /*#__PURE__*/React.createElement("path", {
    d: "M71 84v-1h1v1z",
    fill: "#b54e61"
  })), _path1555 || (_path1555 = /*#__PURE__*/React.createElement("path", {
    d: "M72 84v-1h1v1z",
    fill: "#b75464"
  })), _path1556 || (_path1556 = /*#__PURE__*/React.createElement("path", {
    d: "M73 84v-1h1v1z",
    fill: "#c2848d"
  })), _path1557 || (_path1557 = /*#__PURE__*/React.createElement("path", {
    d: "M74 83h1v1h-1z",
    fill: "#ded7d6"
  })), _path1558 || (_path1558 = /*#__PURE__*/React.createElement("path", {
    d: "M76 83v1h-1v-1z",
    fill: "#d9dbdb"
  })), _path1559 || (_path1559 = /*#__PURE__*/React.createElement("path", {
    d: "M76 84v-1h1v1z",
    fill: "#e2e0e2"
  })), _path1560 || (_path1560 = /*#__PURE__*/React.createElement("path", {
    d: "M77 84v-1h1v1z",
    fill: "#e1e4e2"
  })), _path1561 || (_path1561 = /*#__PURE__*/React.createElement("path", {
    d: "M79 84h-1v-1h1z",
    fill: "#dfdfdf"
  })), _path1562 || (_path1562 = /*#__PURE__*/React.createElement("path", {
    d: "M80 84v-1h1v1z",
    fill: "#42413e"
  })), _path1563 || (_path1563 = /*#__PURE__*/React.createElement("path", {
    d: "M46 85h-1v-1h1z",
    fill: "#636363",
    fillOpacity: 0.071
  })), _path1564 || (_path1564 = /*#__PURE__*/React.createElement("path", {
    d: "M48 85v-1h1v1z",
    fill: "#d0cfcb"
  })), _path1565 || (_path1565 = /*#__PURE__*/React.createElement("path", {
    d: "M53 85h-1v-1h1z",
    fill: "#d9d9d4"
  })), _path1566 || (_path1566 = /*#__PURE__*/React.createElement("path", {
    d: "M53 84h1v1h-1z",
    fill: "#d6d7d3"
  })), _path1567 || (_path1567 = /*#__PURE__*/React.createElement("path", {
    d: "M54 85v-1h1v1z",
    fill: "#d5d9d6"
  })), _path1568 || (_path1568 = /*#__PURE__*/React.createElement("path", {
    d: "M55 84h1v1h-1z",
    fill: "#ced2ca"
  })), _path1569 || (_path1569 = /*#__PURE__*/React.createElement("path", {
    d: "M56 84h1v1h-1z",
    fill: "#a95d5e"
  })), _path1570 || (_path1570 = /*#__PURE__*/React.createElement("path", {
    d: "M58 84v1h-1v-1z",
    fill: "#a2302f"
  })), _path1571 || (_path1571 = /*#__PURE__*/React.createElement("path", {
    d: "M59 85h-1v-1h1z",
    fill: "#a63337"
  })), _path1572 || (_path1572 = /*#__PURE__*/React.createElement("path", {
    d: "M60 85h-1v-1h1z",
    fill: "#ab2a2f"
  })), _path1573 || (_path1573 = /*#__PURE__*/React.createElement("path", {
    d: "M61 85h-1v-1h1z",
    fill: "#a01f21"
  })), _path1574 || (_path1574 = /*#__PURE__*/React.createElement("path", {
    d: "M62 84v1h-1v-1z",
    fill: "#ac464c"
  })), _path1575 || (_path1575 = /*#__PURE__*/React.createElement("path", {
    d: "M62 85v-1h1v1z",
    fill: "#e0dbd3"
  })), _path1576 || (_path1576 = /*#__PURE__*/React.createElement("path", {
    d: "M63 85v-1h1v1z",
    fill: "#a07275"
  })), _path1577 || (_path1577 = /*#__PURE__*/React.createElement("path", {
    d: "M64 85v-1h1v1z",
    fill: "#7f2c32"
  })), _path1578 || (_path1578 = /*#__PURE__*/React.createElement("path", {
    d: "M66 85h-1v-1h1z",
    fill: "#782f34"
  })), _path1579 || (_path1579 = /*#__PURE__*/React.createElement("path", {
    d: "M66 84h1v1h-1z",
    fill: "#6e2a31"
  })), _path1580 || (_path1580 = /*#__PURE__*/React.createElement("path", {
    d: "M67 85v-1h1v1z",
    fill: "#702027"
  })), _path1581 || (_path1581 = /*#__PURE__*/React.createElement("path", {
    d: "M68 84h1v1h-1z",
    fill: "#691d25"
  })), _path1582 || (_path1582 = /*#__PURE__*/React.createElement("path", {
    d: "M69 85v-1h1v1z",
    fill: "#c5acae"
  })), _path1583 || (_path1583 = /*#__PURE__*/React.createElement("path", {
    d: "M71 85h-1v-1h1z",
    fill: "#b18f95"
  })), _path1584 || (_path1584 = /*#__PURE__*/React.createElement("path", {
    d: "M71 84h1v1h-1z",
    fill: "#8b3a49"
  })), _path1585 || (_path1585 = /*#__PURE__*/React.createElement("path", {
    d: "M72 85v-1h1v1z",
    fill: "#954653"
  })), _path1586 || (_path1586 = /*#__PURE__*/React.createElement("path", {
    d: "M73 84h1v1h-1z",
    fill: "#c1a1a4"
  })), _path1587 || (_path1587 = /*#__PURE__*/React.createElement("path", {
    d: "M75 85v-1h1v1z",
    fill: "#e6e8e6"
  })), _path1588 || (_path1588 = /*#__PURE__*/React.createElement("path", {
    d: "M77 84v1h-1v-1z",
    fill: "#e3dfdf"
  })), _path1589 || (_path1589 = /*#__PURE__*/React.createElement("path", {
    d: "M77 85v-1h1v1z",
    fill: "#dbdedc"
  })), _path1590 || (_path1590 = /*#__PURE__*/React.createElement("path", {
    d: "M79 84v1h-1v-1z",
    fill: "#e4e4e4"
  })), _path1591 || (_path1591 = /*#__PURE__*/React.createElement("path", {
    d: "M81 85v-1h1v1z",
    fill: "#181715",
    fillOpacity: 0.933
  })), _path1592 || (_path1592 = /*#__PURE__*/React.createElement("path", {
    d: "M47 86h-1v-1h1z",
    fill: "#1e1d1a",
    fillOpacity: 0.894
  })), _path1593 || (_path1593 = /*#__PURE__*/React.createElement("path", {
    d: "M48 85h1v1h-1z",
    fill: "#cacac5"
  })), _path1594 || (_path1594 = /*#__PURE__*/React.createElement("path", {
    d: "M50 85v1h-1v-1z",
    fill: "#d7d7d3"
  })), _path1595 || (_path1595 = /*#__PURE__*/React.createElement("path", {
    d: "M54 86h-1v-1h1z",
    fill: "#d8d9d3"
  })), _path1596 || (_path1596 = /*#__PURE__*/React.createElement("path", {
    d: "M54 85h1v1h-1z",
    fill: "#dadad7"
  })), _path1597 || (_path1597 = /*#__PURE__*/React.createElement("path", {
    d: "M55 85h1v1h-1z",
    fill: "#dadbd5"
  })), _path1598 || (_path1598 = /*#__PURE__*/React.createElement("path", {
    d: "M57 85v1h-1v-1z",
    fill: "#bf8b8b"
  })), _path1599 || (_path1599 = /*#__PURE__*/React.createElement("path", {
    d: "M57 86v-1h1v1z",
    fill: "#a9302e"
  })), _path1600 || (_path1600 = /*#__PURE__*/React.createElement("path", {
    d: "M58 85h1v1h-1z",
    fill: "#ac3436"
  })), _path1601 || (_path1601 = /*#__PURE__*/React.createElement("path", {
    d: "M59 86v-1h1v1z",
    fill: "#c3282a"
  })), _path1602 || (_path1602 = /*#__PURE__*/React.createElement("path", {
    d: "M61 86h-1v-1h1z",
    fill: "#bf1f24"
  })), _path1603 || (_path1603 = /*#__PURE__*/React.createElement("path", {
    d: "M62 86h-1v-1h1z",
    fill: "#b12024"
  })), _path1604 || (_path1604 = /*#__PURE__*/React.createElement("path", {
    d: "M62 85h1v1h-1z",
    fill: "#c6a9a3"
  })), _path1605 || (_path1605 = /*#__PURE__*/React.createElement("path", {
    d: "M64 85v1h-1v-1z",
    fill: "#a49798"
  })), _path1606 || (_path1606 = /*#__PURE__*/React.createElement("path", {
    d: "M65 86h-1v-1h1z",
    fill: "#7d3136"
  })), _path1607 || (_path1607 = /*#__PURE__*/React.createElement("path", {
    d: "M66 86h-1v-1h1z",
    fill: "#873339"
  })), _path1608 || (_path1608 = /*#__PURE__*/React.createElement("path", {
    d: "M67 85v1h-1v-1z",
    fill: "#732a30"
  })), _path1609 || (_path1609 = /*#__PURE__*/React.createElement("path", {
    d: "M67 85h1v1h-1z",
    fill: "#88242f"
  })), _path1610 || (_path1610 = /*#__PURE__*/React.createElement("path", {
    d: "M69 85v1h-1v-1z",
    fill: "#6a1317"
  })), _path1611 || (_path1611 = /*#__PURE__*/React.createElement("path", {
    d: "M69 85h1v1h-1z",
    fill: "#946469"
  })), _path1612 || (_path1612 = /*#__PURE__*/React.createElement("path", {
    d: "M70 85h1v1h-1z",
    fill: "#cfc6c7"
  })), _path1613 || (_path1613 = /*#__PURE__*/React.createElement("path", {
    d: "M71 86v-1h1v1z",
    fill: "#75454c"
  })), _path1614 || (_path1614 = /*#__PURE__*/React.createElement("path", {
    d: "M73 85v1h-1v-1z",
    fill: "#7e4852"
  })), _path1615 || (_path1615 = /*#__PURE__*/React.createElement("path", {
    d: "M73 86v-1h1v1z",
    fill: "#cbc4c4"
  })), _path1616 || (_path1616 = /*#__PURE__*/React.createElement("path", {
    d: "M74 85h1v1h-1z",
    fill: "#edeae8"
  })), _path1617 || (_path1617 = /*#__PURE__*/React.createElement("path", {
    d: "M75 85h1v1h-1z",
    fill: "#e9ebe6"
  })), _path1618 || (_path1618 = /*#__PURE__*/React.createElement("path", {
    d: "M78 86h-1v-1h1z",
    fill: "#ecece9"
  })), _path1619 || (_path1619 = /*#__PURE__*/React.createElement("path", {
    d: "M79 85v1h-1v-1z",
    fill: "#e7e8e8"
  })), _path1620 || (_path1620 = /*#__PURE__*/React.createElement("path", {
    d: "M79 85h1v1h-1z",
    fill: "#e5e5e4"
  })), _path1621 || (_path1621 = /*#__PURE__*/React.createElement("path", {
    d: "M80 85h1v1h-1z",
    fill: "#42423f"
  })), _path1622 || (_path1622 = /*#__PURE__*/React.createElement("path", {
    d: "M83 86h-1v-1h1z",
    fill: "#515b51",
    fillOpacity: 0.11
  })), _path1623 || (_path1623 = /*#__PURE__*/React.createElement("path", {
    d: "M46 87v-1h1v1z",
    fill: "#1f1c1b",
    fillOpacity: 0.898
  })), _path1624 || (_path1624 = /*#__PURE__*/React.createElement("path", {
    d: "M48 86v1h-1v-1z",
    fill: "#272421"
  })), _path1625 || (_path1625 = /*#__PURE__*/React.createElement("path", {
    d: "M52 86h1v1h-1z",
    fill: "#d1d3ce"
  })), _path1626 || (_path1626 = /*#__PURE__*/React.createElement("path", {
    d: "M54 86v1h-1v-1z",
    fill: "#d3d4d1"
  })), _path1627 || (_path1627 = /*#__PURE__*/React.createElement("path", {
    d: "M55 86v1h-1v-1z",
    fill: "#d8d9d1"
  })), _path1628 || (_path1628 = /*#__PURE__*/React.createElement("path", {
    d: "M55 87v-1h1v1z",
    fill: "#dedbda"
  })), _path1629 || (_path1629 = /*#__PURE__*/React.createElement("path", {
    d: "M57 87h-1v-1h1z",
    fill: "#d7c2bb"
  })), _path1630 || (_path1630 = /*#__PURE__*/React.createElement("path", {
    d: "M58 86v1h-1v-1z",
    fill: "#a83c3e"
  })), _path1631 || (_path1631 = /*#__PURE__*/React.createElement("path", {
    d: "M58 86h1v1h-1z",
    fill: "#b0322d"
  })), _path1632 || (_path1632 = /*#__PURE__*/React.createElement("path", {
    d: "M59 87v-1h1v1z",
    fill: "#b62b2c"
  })), _path1633 || (_path1633 = /*#__PURE__*/React.createElement("path", {
    d: "M60 87v-1h1v1z",
    fill: "#992427"
  })), _path1634 || (_path1634 = /*#__PURE__*/React.createElement("path", {
    d: "M62 87h-1v-1h1z",
    fill: "#871719"
  })), _path1635 || (_path1635 = /*#__PURE__*/React.createElement("path", {
    d: "M63 86v1h-1v-1z",
    fill: "#c07875"
  })), _path1636 || (_path1636 = /*#__PURE__*/React.createElement("path", {
    d: "M63 87v-1h1v1z",
    fill: "#cac9c6"
  })), _path1637 || (_path1637 = /*#__PURE__*/React.createElement("path", {
    d: "M65 86v1h-1v-1z",
    fill: "#874246"
  })), _path1638 || (_path1638 = /*#__PURE__*/React.createElement("path", {
    d: "M65 87v-1h1v1z",
    fill: "#922f38"
  })), _path1639 || (_path1639 = /*#__PURE__*/React.createElement("path", {
    d: "M67 87h-1v-1h1z",
    fill: "#8c2b33"
  })), _path1640 || (_path1640 = /*#__PURE__*/React.createElement("path", {
    d: "M68 86v1h-1v-1z",
    fill: "#75222b"
  })), _path1641 || (_path1641 = /*#__PURE__*/React.createElement("path", {
    d: "M68 87v-1h1v1z",
    fill: "#5b1215"
  })), _path1642 || (_path1642 = /*#__PURE__*/React.createElement("path", {
    d: "M70 86v1h-1v-1z",
    fill: "#87383f"
  })), _path1643 || (_path1643 = /*#__PURE__*/React.createElement("path", {
    d: "M71 86v1h-1v-1z",
    fill: "#c7c6c4"
  })), _path1644 || (_path1644 = /*#__PURE__*/React.createElement("path", {
    d: "M72 86v1h-1v-1z",
    fill: "#9c757d"
  })), _path1645 || (_path1645 = /*#__PURE__*/React.createElement("path", {
    d: "M73 86v1h-1v-1z",
    fill: "#aa8a8f"
  })), _path1646 || (_path1646 = /*#__PURE__*/React.createElement("path", {
    d: "M74 87h-1v-1h1z",
    fill: "#e0e2e0"
  })), _path1647 || (_path1647 = /*#__PURE__*/React.createElement("path", {
    d: "M75 87h-1v-1h1z",
    fill: "#dfdedc"
  })), _path1648 || (_path1648 = /*#__PURE__*/React.createElement("path", {
    d: "M75 87v-1h1v1z",
    fill: "#e2e2df"
  })), _path1649 || (_path1649 = /*#__PURE__*/React.createElement("path", {
    d: "M76 87v-1h1v1z",
    fill: "#e5e5e2"
  })), _path1650 || (_path1650 = /*#__PURE__*/React.createElement("path", {
    d: "M79 87h-1v-1h1z",
    fill: "#e9e9e8"
  })), _path1651 || (_path1651 = /*#__PURE__*/React.createElement("path", {
    d: "M80 86h1v1h-1z",
    fill: "#3f3e3b"
  })), _path1652 || (_path1652 = /*#__PURE__*/React.createElement("path", {
    d: "M83 87h-1v-1h1z",
    fill: "#515151",
    fillOpacity: 0.11
  })), _path1653 || (_path1653 = /*#__PURE__*/React.createElement("path", {
    d: "M47 88h-1v-1h1z",
    fill: "#1f1d1a",
    fillOpacity: 0.894
  })), _path1654 || (_path1654 = /*#__PURE__*/React.createElement("path", {
    d: "M49 88h-1v-1h1z",
    fill: "#c5c5c0"
  })), _path1655 || (_path1655 = /*#__PURE__*/React.createElement("path", {
    d: "M50 87v1h-1v-1z",
    fill: "#d2d4ce"
  })), _path1656 || (_path1656 = /*#__PURE__*/React.createElement("path", {
    d: "M55 88h-1v-1h1z",
    fill: "#cdd0c9"
  })), _path1657 || (_path1657 = /*#__PURE__*/React.createElement("path", {
    d: "M55 87h1v1h-1z",
    fill: "#ccd1cf"
  })), _path1658 || (_path1658 = /*#__PURE__*/React.createElement("path", {
    d: "M57 87v1h-1v-1z",
    fill: "#d5d5ce"
  })), _path1659 || (_path1659 = /*#__PURE__*/React.createElement("path", {
    d: "M57 88v-1h1v1z",
    fill: "#a95e5b"
  })), _path1660 || (_path1660 = /*#__PURE__*/React.createElement("path", {
    d: "M59 88h-1v-1h1z",
    fill: "#a42e32"
  })), _path1661 || (_path1661 = /*#__PURE__*/React.createElement("path", {
    d: "M59 87h1v1h-1z",
    fill: "#9c2c28"
  })), _path1662 || (_path1662 = /*#__PURE__*/React.createElement("path", {
    d: "M60 88v-1h1v1z",
    fill: "#7d2825"
  })), _path1663 || (_path1663 = /*#__PURE__*/React.createElement("path", {
    d: "M61 87h1v1h-1z",
    fill: "#821d1d"
  })), _path1664 || (_path1664 = /*#__PURE__*/React.createElement("path", {
    d: "M62 88v-1h1v1z",
    fill: "#c03940"
  })), _path1665 || (_path1665 = /*#__PURE__*/React.createElement("path", {
    d: "M64 87v1h-1v-1z",
    fill: "#d8ccc8"
  })), _path1666 || (_path1666 = /*#__PURE__*/React.createElement("path", {
    d: "M64 88v-1h1v1z",
    fill: "#a07676"
  })), _path1667 || (_path1667 = /*#__PURE__*/React.createElement("path", {
    d: "M65 88v-1h1v1z",
    fill: "#8e2936"
  })), _path1668 || (_path1668 = /*#__PURE__*/React.createElement("path", {
    d: "M67 87v1h-1v-1z",
    fill: "#782a2f"
  })), _path1669 || (_path1669 = /*#__PURE__*/React.createElement("path", {
    d: "M67 87h1v1h-1z",
    fill: "#742229"
  })), _path1670 || (_path1670 = /*#__PURE__*/React.createElement("path", {
    d: "M69 87v1h-1v-1z",
    fill: "#5c141c"
  })), _path1671 || (_path1671 = /*#__PURE__*/React.createElement("path", {
    d: "M69 87h1v1h-1z",
    fill: "#59121a"
  })), _path1672 || (_path1672 = /*#__PURE__*/React.createElement("path", {
    d: "M71 87v1h-1v-1z",
    fill: "#c6b0af"
  })), _path1673 || (_path1673 = /*#__PURE__*/React.createElement("path", {
    d: "M71 87h1v1h-1z",
    fill: "#d8c3c5"
  })), _path1674 || (_path1674 = /*#__PURE__*/React.createElement("path", {
    d: "M72 87h1v1h-1z",
    fill: "#d2cac8"
  })), _path1675 || (_path1675 = /*#__PURE__*/React.createElement("path", {
    d: "M74 87v1h-1v-1z",
    fill: "#dfe0de"
  })), _path1676 || (_path1676 = /*#__PURE__*/React.createElement("path", {
    d: "M45 88h1v1h-1z",
    fill: "#6f6f5f",
    fillOpacity: 0.063
  })), _path1677 || (_path1677 = /*#__PURE__*/React.createElement("path", {
    d: "M47 88v1h-1v-1z",
    fill: "#1e1c19",
    fillOpacity: 0.89
  })), _path1678 || (_path1678 = /*#__PURE__*/React.createElement("path", {
    d: "M53 89v-1h1v1z",
    fill: "#ced0cc"
  })), _path1679 || (_path1679 = /*#__PURE__*/React.createElement("path", {
    d: "M55 89h-1v-1h1z",
    fill: "#cbcfca"
  })), _path1680 || (_path1680 = /*#__PURE__*/React.createElement("path", {
    d: "M56 89v-1h1v1z",
    fill: "#d7d5d3"
  })), _path1681 || (_path1681 = /*#__PURE__*/React.createElement("path", {
    d: "M58 89h-1v-1h1z",
    fill: "#b58f8b"
  })), _path1682 || (_path1682 = /*#__PURE__*/React.createElement("path", {
    d: "M59 88v1h-1v-1z",
    fill: "#893132"
  })), _path1683 || (_path1683 = /*#__PURE__*/React.createElement("path", {
    d: "M59 89v-1h1v1z",
    fill: "#ab292a"
  })), _path1684 || (_path1684 = /*#__PURE__*/React.createElement("path", {
    d: "M60 89v-1h1v1z",
    fill: "#a02228"
  })), _path1685 || (_path1685 = /*#__PURE__*/React.createElement("path", {
    d: "M62 89h-1v-1h1z",
    fill: "#86201d"
  })), _path1686 || (_path1686 = /*#__PURE__*/React.createElement("path", {
    d: "M63 89h-1v-1h1z",
    fill: "#af191d"
  })), _path1687 || (_path1687 = /*#__PURE__*/React.createElement("path", {
    d: "M63 88h1v1h-1z",
    fill: "#d9a7a4"
  })), _path1688 || (_path1688 = /*#__PURE__*/React.createElement("path", {
    d: "M65 88v1h-1v-1z",
    fill: "#c8b7b5"
  })), _path1689 || (_path1689 = /*#__PURE__*/React.createElement("path", {
    d: "M66 88v1h-1v-1z",
    fill: "#693032"
  })), _path1690 || (_path1690 = /*#__PURE__*/React.createElement("path", {
    d: "M67 89h-1v-1h1z",
    fill: "#5b2826"
  })), _path1691 || (_path1691 = /*#__PURE__*/React.createElement("path", {
    d: "M68 88v1h-1v-1z",
    fill: "#832630"
  })), _path1692 || (_path1692 = /*#__PURE__*/React.createElement("path", {
    d: "M69 89h-1v-1h1z",
    fill: "#511518"
  })), _path1693 || (_path1693 = /*#__PURE__*/React.createElement("path", {
    d: "M70 89h-1v-1h1z",
    fill: "#7c0c1c"
  })), _path1694 || (_path1694 = /*#__PURE__*/React.createElement("path", {
    d: "M70 89v-1h1v1z",
    fill: "#bf747e"
  })), _path1695 || (_path1695 = /*#__PURE__*/React.createElement("path", {
    d: "M71 88h1v1h-1z",
    fill: "#dee4de"
  })), _path1696 || (_path1696 = /*#__PURE__*/React.createElement("path", {
    d: "M73 88v1h-1v-1z",
    fill: "#d9dad7"
  })), _path1697 || (_path1697 = /*#__PURE__*/React.createElement("path", {
    d: "M74 89h-1v-1h1z",
    fill: "#e1e1e0"
  })), _path1698 || (_path1698 = /*#__PURE__*/React.createElement("path", {
    d: "M77 89v-1h1v1z",
    fill: "#dddddc"
  })), _path1699 || (_path1699 = /*#__PURE__*/React.createElement("path", {
    d: "M78 89v-1h1v1z",
    fill: "#e2e2e1"
  })), _path1700 || (_path1700 = /*#__PURE__*/React.createElement("path", {
    d: "M81 88h1v1h-1z",
    fill: "#181814",
    fillOpacity: 0.925
  })), _path1701 || (_path1701 = /*#__PURE__*/React.createElement("path", {
    d: "M47 89v1h-1v-1z",
    fill: "#1f1d1a",
    fillOpacity: 0.89
  })), _path1702 || (_path1702 = /*#__PURE__*/React.createElement("path", {
    d: "M53 89h1v1h-1z",
    fill: "#d2d2cf"
  })), _path1703 || (_path1703 = /*#__PURE__*/React.createElement("path", {
    d: "M55 89v1h-1v-1z",
    fill: "#ced0cd"
  })), _path1704 || (_path1704 = /*#__PURE__*/React.createElement("path", {
    d: "M55 90v-1h1v1z",
    fill: "#d1cfca"
  })), _path1705 || (_path1705 = /*#__PURE__*/React.createElement("path", {
    d: "M56 89h1v1h-1z",
    fill: "#c9cbc7"
  })), _path1706 || (_path1706 = /*#__PURE__*/React.createElement("path", {
    d: "M58 89v1h-1v-1z",
    fill: "#a5a3a1"
  })), _path1707 || (_path1707 = /*#__PURE__*/React.createElement("path", {
    d: "M59 89v1h-1v-1z",
    fill: "#923837"
  })), _path1708 || (_path1708 = /*#__PURE__*/React.createElement("path", {
    d: "M60 89v1h-1v-1z",
    fill: "#bf2628"
  })), _path1709 || (_path1709 = /*#__PURE__*/React.createElement("path", {
    d: "M60 90v-1h1v1z",
    fill: "#a82123"
  })), _path1710 || (_path1710 = /*#__PURE__*/React.createElement("path", {
    d: "M61 89h1v1h-1z",
    fill: "#9e1c1f"
  })), _path1711 || (_path1711 = /*#__PURE__*/React.createElement("path", {
    d: "M63 90h-1v-1h1z",
    fill: "#af1619"
  })), _path1712 || (_path1712 = /*#__PURE__*/React.createElement("path", {
    d: "M63 90v-1h1v1z",
    fill: "#bd625f"
  })), _path1713 || (_path1713 = /*#__PURE__*/React.createElement("path", {
    d: "M65 89v1h-1v-1z",
    fill: "#cac5c4"
  })), _path1714 || (_path1714 = /*#__PURE__*/React.createElement("path", {
    d: "M66 89v1h-1v-1z",
    fill: "#844a4f"
  })), _path1715 || (_path1715 = /*#__PURE__*/React.createElement("path", {
    d: "M66 89h1v1h-1z",
    fill: "#5f2628"
  })), _path1716 || (_path1716 = /*#__PURE__*/React.createElement("path", {
    d: "M67 90v-1h1v1z",
    fill: "#581f23"
  })), _path1717 || (_path1717 = /*#__PURE__*/React.createElement("path", {
    d: "M69 90h-1v-1h1z",
    fill: "#7a1823"
  })), _path1718 || (_path1718 = /*#__PURE__*/React.createElement("path", {
    d: "M69 90v-1h1v1z",
    fill: "#9a1020"
  })), _path1719 || (_path1719 = /*#__PURE__*/React.createElement("path", {
    d: "M70 89h1v1h-1z",
    fill: "#93333f"
  })), _path1720 || (_path1720 = /*#__PURE__*/React.createElement("path", {
    d: "M71 89h1v1h-1z",
    fill: "#dcd5d3"
  })), _path1721 || (_path1721 = /*#__PURE__*/React.createElement("path", {
    d: "M72 90v-1h1v1z",
    fill: "#e0dfdf"
  })), _path1722 || (_path1722 = /*#__PURE__*/React.createElement("path", {
    d: "M73 89h1v1h-1z",
    fill: "#e6e7e6"
  })), _path1723 || (_path1723 = /*#__PURE__*/React.createElement("path", {
    d: "M77 90v-1h1v1z",
    fill: "#e2e2e0"
  })), _path1724 || (_path1724 = /*#__PURE__*/React.createElement("path", {
    d: "M82 90h-1v-1h1z",
    fill: "#181714",
    fillOpacity: 0.925
  })), _path1725 || (_path1725 = /*#__PURE__*/React.createElement("path", {
    d: "M83 90h-1v-1h1z",
    fill: "#58584e",
    fillOpacity: 0.102
  })), _path1726 || (_path1726 = /*#__PURE__*/React.createElement("path", {
    d: "M47 90v1h-1v-1z",
    fill: "#1e1c19",
    fillOpacity: 0.886
  })), _path1727 || (_path1727 = /*#__PURE__*/React.createElement("path", {
    d: "M53 90v1h-1v-1z",
    fill: "#cacbc6"
  })), _path1728 || (_path1728 = /*#__PURE__*/React.createElement("path", {
    d: "M56 91h-1v-1h1z",
    fill: "#c6c7c2"
  })), _path1729 || (_path1729 = /*#__PURE__*/React.createElement("path", {
    d: "M57 90v1h-1v-1z",
    fill: "#bcbfb9"
  })), _path1730 || (_path1730 = /*#__PURE__*/React.createElement("path", {
    d: "M58 91h-1v-1h1z",
    fill: "#bec3be"
  })), _path1731 || (_path1731 = /*#__PURE__*/React.createElement("path", {
    d: "M58 91v-1h1v1z",
    fill: "#ad5456"
  })), _path1732 || (_path1732 = /*#__PURE__*/React.createElement("path", {
    d: "M59 90h1v1h-1z",
    fill: "#b82123"
  })), _path1733 || (_path1733 = /*#__PURE__*/React.createElement("path", {
    d: "M60 90h1v1h-1z",
    fill: "#b0201e"
  })), _path1734 || (_path1734 = /*#__PURE__*/React.createElement("path", {
    d: "M62 90v1h-1v-1z",
    fill: "#be1821"
  })), _path1735 || (_path1735 = /*#__PURE__*/React.createElement("path", {
    d: "M63 90v1h-1v-1z",
    fill: "#ba191a"
  })), _path1736 || (_path1736 = /*#__PURE__*/React.createElement("path", {
    d: "M64 91h-1v-1h1z",
    fill: "#8c2b2a"
  })), _path1737 || (_path1737 = /*#__PURE__*/React.createElement("path", {
    d: "M65 91h-1v-1h1z",
    fill: "#c0b6b5"
  })), _path1738 || (_path1738 = /*#__PURE__*/React.createElement("path", {
    d: "M65 91v-1h1v1z",
    fill: "#b88f90"
  })), _path1739 || (_path1739 = /*#__PURE__*/React.createElement("path", {
    d: "M66 90h1v1h-1z",
    fill: "#571f26"
  })), _path1740 || (_path1740 = /*#__PURE__*/React.createElement("path", {
    d: "M67 90h1v1h-1z",
    fill: "#77212a"
  })), _path1741 || (_path1741 = /*#__PURE__*/React.createElement("path", {
    d: "M69 90v1h-1v-1z",
    fill: "#a21c25"
  })), _path1742 || (_path1742 = /*#__PURE__*/React.createElement("path", {
    d: "M69 90h1v1h-1z",
    fill: "#9d1224"
  })), _path1743 || (_path1743 = /*#__PURE__*/React.createElement("path", {
    d: "M71 90v1h-1v-1z",
    fill: "#8d101d"
  })), _path1744 || (_path1744 = /*#__PURE__*/React.createElement("path", {
    d: "M71 91v-1h1v1z",
    fill: "#caa2a0"
  })), _path1745 || (_path1745 = /*#__PURE__*/React.createElement("path", {
    d: "M72 91v-1h1v1z",
    fill: "#e9e9eb"
  })), _path1746 || (_path1746 = /*#__PURE__*/React.createElement("path", {
    d: "M81 90h1v1h-1z",
    fill: "#181715",
    fillOpacity: 0.925
  })), _path1747 || (_path1747 = /*#__PURE__*/React.createElement("path", {
    d: "M46 92v-1h1v1z",
    fill: "#1e1b19",
    fillOpacity: 0.886
  })), _path1748 || (_path1748 = /*#__PURE__*/React.createElement("path", {
    d: "M53 92v-1h1v1z",
    fill: "#ced0ca"
  })), _path1749 || (_path1749 = /*#__PURE__*/React.createElement("path", {
    d: "M56 91v1h-1v-1z",
    fill: "#bbbcb7"
  })), _path1750 || (_path1750 = /*#__PURE__*/React.createElement("path", {
    d: "M58 91v1h-1v-1z",
    fill: "#c7cfc9"
  })), _path1751 || (_path1751 = /*#__PURE__*/React.createElement("path", {
    d: "M58 92v-1h1v1z",
    fill: "#b38a84"
  })), _path1752 || (_path1752 = /*#__PURE__*/React.createElement("path", {
    d: "M60 91v1h-1v-1z",
    fill: "#b22326"
  })), _path1753 || (_path1753 = /*#__PURE__*/React.createElement("path", {
    d: "M60 91h1v1h-1z",
    fill: "#bd1f1f"
  })), _path1754 || (_path1754 = /*#__PURE__*/React.createElement("path", {
    d: "M61 92v-1h1v1z",
    fill: "#bc191d"
  })), _path1755 || (_path1755 = /*#__PURE__*/React.createElement("path", {
    d: "M63 92h-1v-1h1z",
    fill: "#9f1d20"
  })), _path1756 || (_path1756 = /*#__PURE__*/React.createElement("path", {
    d: "M63 92v-1h1v1z",
    fill: "#641f22"
  })), _path1757 || (_path1757 = /*#__PURE__*/React.createElement("path", {
    d: "M65 91v1h-1v-1z",
    fill: "#a6888a"
  })), _path1758 || (_path1758 = /*#__PURE__*/React.createElement("path", {
    d: "M66 91v1h-1v-1z",
    fill: "#bdb6b3"
  })), _path1759 || (_path1759 = /*#__PURE__*/React.createElement("path", {
    d: "M67 92h-1v-1h1z",
    fill: "#5f2729"
  })), _path1760 || (_path1760 = /*#__PURE__*/React.createElement("path", {
    d: "M67 91h1v1h-1z",
    fill: "#a0232e"
  })), _path1761 || (_path1761 = /*#__PURE__*/React.createElement("path", {
    d: "M69 92h-1v-1h1z",
    fill: "#941d26"
  })), _path1762 || (_path1762 = /*#__PURE__*/React.createElement("path", {
    d: "M70 92h-1v-1h1z",
    fill: "#89131f"
  })), _path1763 || (_path1763 = /*#__PURE__*/React.createElement("path", {
    d: "M71 91v1h-1v-1z",
    fill: "#8b0c18"
  })), _path1764 || (_path1764 = /*#__PURE__*/React.createElement("path", {
    d: "M72 91v1h-1v-1z",
    fill: "#b27679"
  })), _path1765 || (_path1765 = /*#__PURE__*/React.createElement("path", {
    d: "M72 92v-1h1v1z",
    fill: "#ebecec"
  })), _path1766 || (_path1766 = /*#__PURE__*/React.createElement("path", {
    d: "M73 91h1v1h-1z",
    fill: "#ece9e7"
  })), _path1767 || (_path1767 = /*#__PURE__*/React.createElement("path", {
    d: "M82 91v1h-1v-1z",
    fill: "#181716",
    fillOpacity: 0.925
  })), _path1768 || (_path1768 = /*#__PURE__*/React.createElement("path", {
    d: "M45 92h1v1h-1z",
    fill: "#6d6d6d",
    fillOpacity: 0.055
  })), _path1769 || (_path1769 = /*#__PURE__*/React.createElement("path", {
    d: "M47 93h-1v-1h1z",
    fill: "#1d1b1a",
    fillOpacity: 0.882
  })), _path1770 || (_path1770 = /*#__PURE__*/React.createElement("path", {
    d: "M48 93h-1v-1h1z",
    fill: "#24211e"
  })), _path1771 || (_path1771 = /*#__PURE__*/React.createElement("path", {
    d: "M49 93h-1v-1h1z",
    fill: "#bfc0bb"
  })), _path1772 || (_path1772 = /*#__PURE__*/React.createElement("path", {
    d: "M58 93h-1v-1h1z",
    fill: "#cfd1ce"
  })), _path1773 || (_path1773 = /*#__PURE__*/React.createElement("path", {
    d: "M58 92h1v1h-1z",
    fill: "#c8c1ba"
  })), _path1774 || (_path1774 = /*#__PURE__*/React.createElement("path", {
    d: "M59 92h1v1h-1z",
    fill: "#ab383a"
  })), _path1775 || (_path1775 = /*#__PURE__*/React.createElement("path", {
    d: "M61 92v1h-1v-1z",
    fill: "#b71b1d"
  })), _path1776 || (_path1776 = /*#__PURE__*/React.createElement("path", {
    d: "M62 93h-1v-1h1z",
    fill: "#a21c22"
  })), _path1777 || (_path1777 = /*#__PURE__*/React.createElement("path", {
    d: "M62 93v-1h1v1z",
    fill: "#842120"
  })), _path1778 || (_path1778 = /*#__PURE__*/React.createElement("path", {
    d: "M64 92v1h-1v-1z",
    fill: "#8d1f1e"
  })), _path1779 || (_path1779 = /*#__PURE__*/React.createElement("path", {
    d: "M65 93h-1v-1h1z",
    fill: "#8b4948"
  })), _path1780 || (_path1780 = /*#__PURE__*/React.createElement("path", {
    d: "M65 92h1v1h-1z",
    fill: "#bbb8ba"
  })), _path1781 || (_path1781 = /*#__PURE__*/React.createElement("path", {
    d: "M66 92h1v1h-1z",
    fill: "#9b555b"
  })), _path1782 || (_path1782 = /*#__PURE__*/React.createElement("path", {
    d: "M67 93v-1h1v1z",
    fill: "#991d24"
  })), _path1783 || (_path1783 = /*#__PURE__*/React.createElement("path", {
    d: "M69 92v1h-1v-1z",
    fill: "#891724"
  })), _path1784 || (_path1784 = /*#__PURE__*/React.createElement("path", {
    d: "M69 92h1v1h-1z",
    fill: "#8e1320"
  })), _path1785 || (_path1785 = /*#__PURE__*/React.createElement("path", {
    d: "M70 92h1v1h-1z",
    fill: "#890a1b"
  })), _path1786 || (_path1786 = /*#__PURE__*/React.createElement("path", {
    d: "M71 92h1v1h-1z",
    fill: "#bc8c90"
  })), _path1787 || (_path1787 = /*#__PURE__*/React.createElement("path", {
    d: "M73 92v1h-1v-1z",
    fill: "#eae5e5"
  })), _path1788 || (_path1788 = /*#__PURE__*/React.createElement("path", {
    d: "M81 92h1v1h-1z",
    fill: "#181716",
    fillOpacity: 0.922
  })), _path1789 || (_path1789 = /*#__PURE__*/React.createElement("path", {
    d: "M49 93v1h-1v-1z",
    fill: "#d2d2cd"
  })), _path1790 || (_path1790 = /*#__PURE__*/React.createElement("path", {
    d: "M55 94h-1v-1h1z",
    fill: "#babbb6"
  })), _path1791 || (_path1791 = /*#__PURE__*/React.createElement("path", {
    d: "M58 93v1h-1v-1z",
    fill: "#d2d3cf"
  })), _path1792 || (_path1792 = /*#__PURE__*/React.createElement("path", {
    d: "M60 94h-1v-1h1z",
    fill: "#c16e6c"
  })), _path1793 || (_path1793 = /*#__PURE__*/React.createElement("path", {
    d: "M60 93h1v1h-1z",
    fill: "#ac181b"
  })), _path1794 || (_path1794 = /*#__PURE__*/React.createElement("path", {
    d: "M61 93h1v1h-1z",
    fill: "#921c1c"
  })), _path1795 || (_path1795 = /*#__PURE__*/React.createElement("path", {
    d: "M62 93h1v1h-1z",
    fill: "#ae1c1e"
  })), _path1796 || (_path1796 = /*#__PURE__*/React.createElement("path", {
    d: "M64 93v1h-1v-1z",
    fill: "#a42a2d"
  })), _path1797 || (_path1797 = /*#__PURE__*/React.createElement("path", {
    d: "M65 93v1h-1v-1z",
    fill: "#9d817f"
  })), _path1798 || (_path1798 = /*#__PURE__*/React.createElement("path", {
    d: "M65 94v-1h1v1z",
    fill: "#d1d2d0"
  })), _path1799 || (_path1799 = /*#__PURE__*/React.createElement("path", {
    d: "M67 94h-1v-1h1z",
    fill: "#cfa6a8"
  })), _path1800 || (_path1800 = /*#__PURE__*/React.createElement("path", {
    d: "M68 94h-1v-1h1z",
    fill: "#9c1c2a"
  })), _path1801 || (_path1801 = /*#__PURE__*/React.createElement("path", {
    d: "M68 94v-1h1v1z",
    fill: "#9e1b28"
  })), _path1802 || (_path1802 = /*#__PURE__*/React.createElement("path", {
    d: "M70 93v1h-1v-1z",
    fill: "#951121"
  })), _path1803 || (_path1803 = /*#__PURE__*/React.createElement("path", {
    d: "M71 93v1h-1v-1z",
    fill: "#9c3945"
  })), _path1804 || (_path1804 = /*#__PURE__*/React.createElement("path", {
    d: "M72 93v1h-1v-1z",
    fill: "#dcd2cf"
  })), _path1805 || (_path1805 = /*#__PURE__*/React.createElement("path", {
    d: "M74 94h-1v-1h1z",
    fill: "#edeaeb"
  })), _path1806 || (_path1806 = /*#__PURE__*/React.createElement("path", {
    d: "M81 94v-1h1v1z",
    fill: "#171715",
    fillOpacity: 0.922
  })), _path1807 || (_path1807 = /*#__PURE__*/React.createElement("path", {
    d: "M48 95v-1h1v1z",
    fill: "#d3d3ce"
  })), _path1808 || (_path1808 = /*#__PURE__*/React.createElement("path", {
    d: "M49 94h1v1h-1z",
    fill: "#e3e3df"
  })), _path1809 || (_path1809 = /*#__PURE__*/React.createElement("path", {
    d: "M53 95v-1h1v1z",
    fill: "#d7d7d2"
  })), _path1810 || (_path1810 = /*#__PURE__*/React.createElement("path", {
    d: "M59 95h-1v-1h1z",
    fill: "#dadeda"
  })), _path1811 || (_path1811 = /*#__PURE__*/React.createElement("path", {
    d: "M60 94v1h-1v-1z",
    fill: "#d7b2af"
  })), _path1812 || (_path1812 = /*#__PURE__*/React.createElement("path", {
    d: "M60 95v-1h1v1z",
    fill: "#ac2023"
  })), _path1813 || (_path1813 = /*#__PURE__*/React.createElement("path", {
    d: "M61 94h1v1h-1z",
    fill: "#b11717"
  })), _path1814 || (_path1814 = /*#__PURE__*/React.createElement("path", {
    d: "M63 94v1h-1v-1z",
    fill: "#c0131b"
  })), _path1815 || (_path1815 = /*#__PURE__*/React.createElement("path", {
    d: "M63 95v-1h1v1z",
    fill: "#cf9a9b"
  })), _path1816 || (_path1816 = /*#__PURE__*/React.createElement("path", {
    d: "M64 94h1v1h-1z",
    fill: "#cbd1cf"
  })), _path1817 || (_path1817 = /*#__PURE__*/React.createElement("path", {
    d: "M66 94v1h-1v-1z",
    fill: "#dcded8"
  })), _path1818 || (_path1818 = /*#__PURE__*/React.createElement("path", {
    d: "M67 94v1h-1v-1z",
    fill: "#e0dbd6"
  })), _path1819 || (_path1819 = /*#__PURE__*/React.createElement("path", {
    d: "M67 95v-1h1v1z",
    fill: "#a7424d"
  })), _path1820 || (_path1820 = /*#__PURE__*/React.createElement("path", {
    d: "M68 94h1v1h-1z",
    fill: "#9f1320"
  })), _path1821 || (_path1821 = /*#__PURE__*/React.createElement("path", {
    d: "M69 94h1v1h-1z",
    fill: "#a0182b"
  })), _path1822 || (_path1822 = /*#__PURE__*/React.createElement("path", {
    d: "M71 95h-1v-1h1z",
    fill: "#dec0bd"
  })), _path1823 || (_path1823 = /*#__PURE__*/React.createElement("path", {
    d: "M71 94h1v1h-1z",
    fill: "#e9eae7"
  })), _path1824 || (_path1824 = /*#__PURE__*/React.createElement("path", {
    d: "M72 94h1v1h-1z",
    fill: "#e9e7e7"
  })), _path1825 || (_path1825 = /*#__PURE__*/React.createElement("path", {
    d: "M74 94v1h-1v-1z",
    fill: "#ebeae9"
  })), _path1826 || (_path1826 = /*#__PURE__*/React.createElement("path", {
    d: "M47 96v-1h1v1z",
    fill: "#242420"
  })), _path1827 || (_path1827 = /*#__PURE__*/React.createElement("path", {
    d: "M58 95h1v1h-1z",
    fill: "#d8ded8"
  })), _path1828 || (_path1828 = /*#__PURE__*/React.createElement("path", {
    d: "M59 95h1v1h-1z",
    fill: "#daddd5"
  })), _path1829 || (_path1829 = /*#__PURE__*/React.createElement("path", {
    d: "M61 96h-1v-1h1z",
    fill: "#c25c60"
  })), _path1830 || (_path1830 = /*#__PURE__*/React.createElement("path", {
    d: "M62 95v1h-1v-1z",
    fill: "#be0a0c"
  })), _path1831 || (_path1831 = /*#__PURE__*/React.createElement("path", {
    d: "M62 95h1v1h-1z",
    fill: "#c75657"
  })), _path1832 || (_path1832 = /*#__PURE__*/React.createElement("path", {
    d: "M64 96h-1v-1h1z",
    fill: "#dbd1c9"
  })), _path1833 || (_path1833 = /*#__PURE__*/React.createElement("path", {
    d: "M66 96h-1v-1h1z",
    fill: "#dee0df"
  })), _path1834 || (_path1834 = /*#__PURE__*/React.createElement("path", {
    d: "M66 96v-1h1v1z",
    fill: "#e5e8e2"
  })), _path1835 || (_path1835 = /*#__PURE__*/React.createElement("path", {
    d: "M68 96h-1v-1h1z",
    fill: "#cc9193"
  })), _path1836 || (_path1836 = /*#__PURE__*/React.createElement("path", {
    d: "M68 96v-1h1v1z",
    fill: "#940e1f"
  })), _path1837 || (_path1837 = /*#__PURE__*/React.createElement("path", {
    d: "M69 95h1v1h-1z",
    fill: "#be7179"
  })), _path1838 || (_path1838 = /*#__PURE__*/React.createElement("path", {
    d: "M71 95v1h-1v-1z",
    fill: "#e6e9e3"
  })), _path1839 || (_path1839 = /*#__PURE__*/React.createElement("path", {
    d: "M71 96v-1h1v1z",
    fill: "#e7e8e7"
  })), _path1840 || (_path1840 = /*#__PURE__*/React.createElement("path", {
    d: "M73 96h-1v-1h1z",
    fill: "#eae8e8"
  })), _path1841 || (_path1841 = /*#__PURE__*/React.createElement("path", {
    d: "M81 95h1v1h-1z",
    fill: "#181713",
    fillOpacity: 0.922
  })), _path1842 || (_path1842 = /*#__PURE__*/React.createElement("path", {
    d: "M60 96v1h-1v-1z",
    fill: "#dbdddb"
  })), _path1843 || (_path1843 = /*#__PURE__*/React.createElement("path", {
    d: "M60 97v-1h1v1z",
    fill: "#d7aead"
  })), _path1844 || (_path1844 = /*#__PURE__*/React.createElement("path", {
    d: "M61 96h1v1h-1z",
    fill: "#c97670"
  })), _path1845 || (_path1845 = /*#__PURE__*/React.createElement("path", {
    d: "M63 96v1h-1v-1z",
    fill: "#dedad5"
  })), _path1846 || (_path1846 = /*#__PURE__*/React.createElement("path", {
    d: "M63 97v-1h1v1z",
    fill: "#dae2db"
  })), _path1847 || (_path1847 = /*#__PURE__*/React.createElement("path", {
    d: "M65 96v1h-1v-1z",
    fill: "#e1ded8"
  })), _path1848 || (_path1848 = /*#__PURE__*/React.createElement("path", {
    d: "M65 97v-1h1v1z",
    fill: "#e0dede"
  })), _path1849 || (_path1849 = /*#__PURE__*/React.createElement("path", {
    d: "M66 96h1v1h-1z",
    fill: "#e1e3df"
  })), _path1850 || (_path1850 = /*#__PURE__*/React.createElement("path", {
    d: "M67 96h1v1h-1z",
    fill: "#ddcdc8"
  })), _path1851 || (_path1851 = /*#__PURE__*/React.createElement("path", {
    d: "M69 97h-1v-1h1z",
    fill: "#af5d69"
  })), _path1852 || (_path1852 = /*#__PURE__*/React.createElement("path", {
    d: "M70 96v1h-1v-1z",
    fill: "#ded9d3"
  })), _path1853 || (_path1853 = /*#__PURE__*/React.createElement("path", {
    d: "M70 97v-1h1v1z",
    fill: "#e8e8e8"
  })), _path1854 || (_path1854 = /*#__PURE__*/React.createElement("path", {
    d: "M72 96v1h-1v-1z",
    fill: "#ebe5e7"
  })), _path1855 || (_path1855 = /*#__PURE__*/React.createElement("path", {
    d: "M73 96h1v1h-1z",
    fill: "#e9eae6"
  })), _path1856 || (_path1856 = /*#__PURE__*/React.createElement("path", {
    d: "M80 97v-1h1v1z",
    fill: "#41403b"
  })), _path1857 || (_path1857 = /*#__PURE__*/React.createElement("path", {
    d: "M59 97v1h-1v-1z",
    fill: "#dddad6"
  })), _path1858 || (_path1858 = /*#__PURE__*/React.createElement("path", {
    d: "M60 98h-1v-1h1z",
    fill: "#dbdbd9"
  })), _path1859 || (_path1859 = /*#__PURE__*/React.createElement("path", {
    d: "M61 98h-1v-1h1z",
    fill: "#dbd9d1"
  })), _path1860 || (_path1860 = /*#__PURE__*/React.createElement("path", {
    d: "M62 97v1h-1v-1z",
    fill: "#dbd5d3"
  })), _path1861 || (_path1861 = /*#__PURE__*/React.createElement("path", {
    d: "M63 98h-1v-1h1z",
    fill: "#deddda"
  })), _path1862 || (_path1862 = /*#__PURE__*/React.createElement("path", {
    d: "M63 98v-1h1v1z",
    fill: "#dbdeda"
  })), _path1863 || (_path1863 = /*#__PURE__*/React.createElement("path", {
    d: "M65 98h-1v-1h1z",
    fill: "#dfdddc"
  })), _path1864 || (_path1864 = /*#__PURE__*/React.createElement("path", {
    d: "M67 97v1h-1v-1z",
    fill: "#e4dedf"
  })), _path1865 || (_path1865 = /*#__PURE__*/React.createElement("path", {
    d: "M69 97v1h-1v-1z",
    fill: "#e1dbd7"
  })), _path1866 || (_path1866 = /*#__PURE__*/React.createElement("path", {
    d: "M70 98h-1v-1h1z",
    fill: "#e5e1e0"
  })), _path1867 || (_path1867 = /*#__PURE__*/React.createElement("path", {
    d: "M70 97h1v1h-1z",
    fill: "#e8e4e4"
  })), _path1868 || (_path1868 = /*#__PURE__*/React.createElement("path", {
    d: "M71 97h1v1h-1z",
    fill: "#ebe5e5"
  })), _path1869 || (_path1869 = /*#__PURE__*/React.createElement("path", {
    d: "M73 98h-1v-1h1z",
    fill: "#e9e9e4"
  })), _path1870 || (_path1870 = /*#__PURE__*/React.createElement("path", {
    d: "M81 98v-1h1v1z",
    fill: "#181814",
    fillOpacity: 0.922
  })), _path1871 || (_path1871 = /*#__PURE__*/React.createElement("path", {
    d: "M82 97h1v1h-1z",
    fill: "#5f5f55",
    fillOpacity: 0.094
  })), _path1872 || (_path1872 = /*#__PURE__*/React.createElement("path", {
    d: "M48 98h1v1h-1z",
    fill: "#d2d1cd"
  })), _path1873 || (_path1873 = /*#__PURE__*/React.createElement("path", {
    d: "M50 99h-1v-1h1z",
    fill: "#e1e2dc"
  })), _path1874 || (_path1874 = /*#__PURE__*/React.createElement("path", {
    d: "M51 99v-1h1v1z",
    fill: "#e1ddda"
  })), _path1875 || (_path1875 = /*#__PURE__*/React.createElement("path", {
    d: "M54 99v-1h1v1z",
    fill: "#dddad9"
  })), _path1876 || (_path1876 = /*#__PURE__*/React.createElement("path", {
    d: "M55 99v-1h1v1z",
    fill: "#dddad8"
  })), _path1877 || (_path1877 = /*#__PURE__*/React.createElement("path", {
    d: "M58 98h1v1h-1z",
    fill: "#dddbd6"
  })), _path1878 || (_path1878 = /*#__PURE__*/React.createElement("path", {
    d: "M59 99v-1h1v1z",
    fill: "#dadcd7"
  })), _path1879 || (_path1879 = /*#__PURE__*/React.createElement("path", {
    d: "M61 99v-1h1v1z",
    fill: "#dadddc"
  })), _path1880 || (_path1880 = /*#__PURE__*/React.createElement("path", {
    d: "M63 98v1h-1v-1z",
    fill: "#dbded5"
  })), _path1881 || (_path1881 = /*#__PURE__*/React.createElement("path", {
    d: "M64 99h-1v-1h1z",
    fill: "#dddeda"
  })), _path1882 || (_path1882 = /*#__PURE__*/React.createElement("path", {
    d: "M65 98v1h-1v-1z",
    fill: "#dfdede"
  })), _path1883 || (_path1883 = /*#__PURE__*/React.createElement("path", {
    d: "M66 98v1h-1v-1z",
    fill: "#dee1dc"
  })), _path1884 || (_path1884 = /*#__PURE__*/React.createElement("path", {
    d: "M67 99h-1v-1h1z",
    fill: "#e3e1e0"
  })), _path1885 || (_path1885 = /*#__PURE__*/React.createElement("path", {
    d: "M70 98h1v1h-1z",
    fill: "#e4e5e3"
  })), _path1886 || (_path1886 = /*#__PURE__*/React.createElement("path", {
    d: "M72 98v1h-1v-1z",
    fill: "#e8e7e4"
  })), _path1887 || (_path1887 = /*#__PURE__*/React.createElement("path", {
    d: "M74 99h-1v-1h1z",
    fill: "#ebe9e7"
  })), _path1888 || (_path1888 = /*#__PURE__*/React.createElement("path", {
    d: "M75 99h-1v-1h1z",
    fill: "#ebecea"
  })), _path1889 || (_path1889 = /*#__PURE__*/React.createElement("path", {
    d: "M75 99v-1h1v1z",
    fill: "#efeced"
  })), _path1890 || (_path1890 = /*#__PURE__*/React.createElement("path", {
    d: "M77 98v1h-1v-1z",
    fill: "#efedee"
  })), _path1891 || (_path1891 = /*#__PURE__*/React.createElement("path", {
    d: "M50 99v1h-1v-1z",
    fill: "#e2e0db"
  })), _path1892 || (_path1892 = /*#__PURE__*/React.createElement("path", {
    d: "M52 99v1h-1v-1z",
    fill: "#e0dddb"
  })), _path1893 || (_path1893 = /*#__PURE__*/React.createElement("path", {
    d: "M56 99h1v1h-1z",
    fill: "#dadbd4"
  })), _path1894 || (_path1894 = /*#__PURE__*/React.createElement("path", {
    d: "M58 100v-1h1v1z",
    fill: "#d3d4cc"
  })), _path1895 || (_path1895 = /*#__PURE__*/React.createElement("path", {
    d: "M60 99v1h-1v-1z",
    fill: "#d5d1c8"
  })), _path1896 || (_path1896 = /*#__PURE__*/React.createElement("path", {
    d: "M60 100v-1h1v1z",
    fill: "#d5d2c7"
  })), _path1897 || (_path1897 = /*#__PURE__*/React.createElement("path", {
    d: "M61 99h1v1h-1z",
    fill: "#d9d7ce"
  })), _path1898 || (_path1898 = /*#__PURE__*/React.createElement("path", {
    d: "M63 99v1h-1v-1z",
    fill: "#d4d2c7"
  })), _path1899 || (_path1899 = /*#__PURE__*/React.createElement("path", {
    d: "M63 100v-1h1v1z",
    fill: "#d4d1c7"
  })), _path1900 || (_path1900 = /*#__PURE__*/React.createElement("path", {
    d: "M65 99v1h-1v-1z",
    fill: "#d7d2c8"
  })), _path1901 || (_path1901 = /*#__PURE__*/React.createElement("path", {
    d: "M66 99v1h-1v-1z",
    fill: "#d5d1c2"
  })), _path1902 || (_path1902 = /*#__PURE__*/React.createElement("path", {
    d: "M66 99h1v1h-1z",
    fill: "#d5d2c4"
  })), _path1903 || (_path1903 = /*#__PURE__*/React.createElement("path", {
    d: "M67 99h1v1h-1z",
    fill: "#d9d5ca"
  })), _path1904 || (_path1904 = /*#__PURE__*/React.createElement("path", {
    d: "M69 99v1h-1v-1z",
    fill: "#d8d5cd"
  })), _path1905 || (_path1905 = /*#__PURE__*/React.createElement("path", {
    d: "M69 100v-1h1v1z",
    fill: "#e3dfda"
  })), _path1906 || (_path1906 = /*#__PURE__*/React.createElement("path", {
    d: "M71 99h1v1h-1z",
    fill: "#e8e6e4"
  })), _path1907 || (_path1907 = /*#__PURE__*/React.createElement("path", {
    d: "M74 100v-1h1v1z",
    fill: "#ecece7"
  })), _path1908 || (_path1908 = /*#__PURE__*/React.createElement("path", {
    d: "M75 100v-1h1v1z",
    fill: "#eeecea"
  })), _path1909 || (_path1909 = /*#__PURE__*/React.createElement("path", {
    d: "M76 100v-1h1v1z",
    fill: "#f0eeeb"
  })), _path1910 || (_path1910 = /*#__PURE__*/React.createElement("path", {
    d: "M77 99h1v1h-1z",
    fill: "#f2f0ec"
  })), _path1911 || (_path1911 = /*#__PURE__*/React.createElement("path", {
    d: "M48 100h1v1h-1z",
    fill: "#d2d1cc"
  })), _path1912 || (_path1912 = /*#__PURE__*/React.createElement("path", {
    d: "M51 100v1h-1v-1z",
    fill: "#dfdfdb"
  })), _path1913 || (_path1913 = /*#__PURE__*/React.createElement("path", {
    d: "M53 101h-1v-1h1z",
    fill: "#dcded9"
  })), _path1914 || (_path1914 = /*#__PURE__*/React.createElement("path", {
    d: "M54 101h-1v-1h1z",
    fill: "#dfdcd9"
  })), _path1915 || (_path1915 = /*#__PURE__*/React.createElement("path", {
    d: "M55 101h-1v-1h1z",
    fill: "#dcdad8"
  })), _path1916 || (_path1916 = /*#__PURE__*/React.createElement("path", {
    d: "M56 100v1h-1v-1z",
    fill: "#dbdad8"
  })), _path1917 || (_path1917 = /*#__PURE__*/React.createElement("path", {
    d: "M58 101h-1v-1h1z",
    fill: "#dcdad2"
  })), _path1918 || (_path1918 = /*#__PURE__*/React.createElement("path", {
    d: "M59 101h-1v-1h1z",
    fill: "#d1cbbd"
  })), _path1919 || (_path1919 = /*#__PURE__*/React.createElement("path", {
    d: "M59 101v-1h1v1z",
    fill: "#cfc4b3"
  })), _path1920 || (_path1920 = /*#__PURE__*/React.createElement("path", {
    d: "M61 100v1h-1v-1z",
    fill: "#cbbfaa"
  })), _path1921 || (_path1921 = /*#__PURE__*/React.createElement("path", {
    d: "M61 101v-1h1v1z",
    fill: "#d0c6b3"
  })), _path1922 || (_path1922 = /*#__PURE__*/React.createElement("path", {
    d: "M62 101v-1h1v1z",
    fill: "#cbc1ac"
  })), _path1923 || (_path1923 = /*#__PURE__*/React.createElement("path", {
    d: "M64 101h-1v-1h1z",
    fill: "#cfc2ad"
  })), _path1924 || (_path1924 = /*#__PURE__*/React.createElement("path", {
    d: "M64 100h1v1h-1z",
    fill: "#c9bba6"
  })), _path1925 || (_path1925 = /*#__PURE__*/React.createElement("path", {
    d: "M66 101h-1v-1h1z",
    fill: "#c5b7a0"
  })), _path1926 || (_path1926 = /*#__PURE__*/React.createElement("path", {
    d: "M66 101v-1h1v1z",
    fill: "#c5b8a4"
  })), _path1927 || (_path1927 = /*#__PURE__*/React.createElement("path", {
    d: "M68 100v1h-1v-1z",
    fill: "#cabdac"
  })), _path1928 || (_path1928 = /*#__PURE__*/React.createElement("path", {
    d: "M69 101h-1v-1h1z",
    fill: "#c7bcae"
  })), _path1929 || (_path1929 = /*#__PURE__*/React.createElement("path", {
    d: "M69 100h1v1h-1z",
    fill: "#ddd6cd"
  })), _path1930 || (_path1930 = /*#__PURE__*/React.createElement("path", {
    d: "M70 100h1v1h-1z",
    fill: "#e6e7e3"
  })), _path1931 || (_path1931 = /*#__PURE__*/React.createElement("path", {
    d: "M71 100h1v1h-1z",
    fill: "#e7e7e3"
  })), _path1932 || (_path1932 = /*#__PURE__*/React.createElement("path", {
    d: "M73 101v-1h1v1z",
    fill: "#eaeae7"
  })), _path1933 || (_path1933 = /*#__PURE__*/React.createElement("path", {
    d: "M74 101v-1h1v1z",
    fill: "#eeebea"
  })), _path1934 || (_path1934 = /*#__PURE__*/React.createElement("path", {
    d: "M77 100h1v1h-1z",
    fill: "#f1f0ef"
  })), _path1935 || (_path1935 = /*#__PURE__*/React.createElement("path", {
    d: "M50 101h1v1h-1z",
    fill: "#dcd2ce"
  })), _path1936 || (_path1936 = /*#__PURE__*/React.createElement("path", {
    d: "M51 101h1v1h-1z",
    fill: "#d9cac7"
  })), _path1937 || (_path1937 = /*#__PURE__*/React.createElement("path", {
    d: "M53 101v1h-1v-1z",
    fill: "#e0d5d3"
  })), _path1938 || (_path1938 = /*#__PURE__*/React.createElement("path", {
    d: "M54 101v1h-1v-1z",
    fill: "#dcd5d0"
  })), _path1939 || (_path1939 = /*#__PURE__*/React.createElement("path", {
    d: "M55 101v1h-1v-1z",
    fill: "#ded6d1"
  })), _path1940 || (_path1940 = /*#__PURE__*/React.createElement("path", {
    d: "M55 102v-1h1v1z",
    fill: "#d8d7d1"
  })), _path1941 || (_path1941 = /*#__PURE__*/React.createElement("path", {
    d: "M57 102h-1v-1h1z",
    fill: "#d9dad4"
  })), _path1942 || (_path1942 = /*#__PURE__*/React.createElement("path", {
    d: "M58 102h-1v-1h1z",
    fill: "#d8dcd8"
  })), _path1943 || (_path1943 = /*#__PURE__*/React.createElement("path", {
    d: "M59 101v1h-1v-1z",
    fill: "#daddd8"
  })), _path1944 || (_path1944 = /*#__PURE__*/React.createElement("path", {
    d: "M63 102v-1h1v1z",
    fill: "#ddded7"
  })), _path1945 || (_path1945 = /*#__PURE__*/React.createElement("path", {
    d: "M65 101v1h-1v-1z",
    fill: "#deded8"
  })), _path1946 || (_path1946 = /*#__PURE__*/React.createElement("path", {
    d: "M71 102h-1v-1h1z",
    fill: "#e8e5e2"
  })), _path1947 || (_path1947 = /*#__PURE__*/React.createElement("path", {
    d: "M72 101v1h-1v-1z",
    fill: "#eae5e2"
  })), _path1948 || (_path1948 = /*#__PURE__*/React.createElement("path", {
    d: "M72 101h1v1h-1z",
    fill: "#ece5e3"
  })), _path1949 || (_path1949 = /*#__PURE__*/React.createElement("path", {
    d: "M74 102h-1v-1h1z",
    fill: "#eee7e5"
  })), _path1950 || (_path1950 = /*#__PURE__*/React.createElement("path", {
    d: "M75 101v1h-1v-1z",
    fill: "#e9e7e3"
  })), _path1951 || (_path1951 = /*#__PURE__*/React.createElement("path", {
    d: "M75 102v-1h1v1z",
    fill: "#eddddc"
  })), _path1952 || (_path1952 = /*#__PURE__*/React.createElement("path", {
    d: "M77 102h-1v-1h1z",
    fill: "#e8dfdc"
  })), _path1953 || (_path1953 = /*#__PURE__*/React.createElement("path", {
    d: "M79 101v1h-1v-1z",
    fill: "#f2f3f1"
  })), _path1954 || (_path1954 = /*#__PURE__*/React.createElement("path", {
    d: "M49 102v1h-1v-1z",
    fill: "#d1cfcc"
  })), _path1955 || (_path1955 = /*#__PURE__*/React.createElement("path", {
    d: "M51 103h-1v-1h1z",
    fill: "#d0bdba"
  })), _path1956 || (_path1956 = /*#__PURE__*/React.createElement("path", {
    d: "M52 103h-1v-1h1z",
    fill: "#ceb2af"
  })), _path1957 || (_path1957 = /*#__PURE__*/React.createElement("path", {
    d: "M53 103h-1v-1h1z",
    fill: "#bc9999"
  })), _path1958 || (_path1958 = /*#__PURE__*/React.createElement("path", {
    d: "M53 102h1v1h-1z",
    fill: "#bf9292"
  })), _path1959 || (_path1959 = /*#__PURE__*/React.createElement("path", {
    d: "M54 102h1v1h-1z",
    fill: "#c09696"
  })), _path1960 || (_path1960 = /*#__PURE__*/React.createElement("path", {
    d: "M56 103h-1v-1h1z",
    fill: "#c3a19f"
  })), _path1961 || (_path1961 = /*#__PURE__*/React.createElement("path", {
    d: "M56 103v-1h1v1z",
    fill: "#bd9995"
  })), _path1962 || (_path1962 = /*#__PURE__*/React.createElement("path", {
    d: "M57 103v-1h1v1z",
    fill: "#c6a5a3"
  })), _path1963 || (_path1963 = /*#__PURE__*/React.createElement("path", {
    d: "M59 103h-1v-1h1z",
    fill: "#c2a5a3"
  })), _path1964 || (_path1964 = /*#__PURE__*/React.createElement("path", {
    d: "M60 103h-1v-1h1z",
    fill: "#cbaca9"
  })), _path1965 || (_path1965 = /*#__PURE__*/React.createElement("path", {
    d: "M60 102h1v1h-1z",
    fill: "#c8acae"
  })), _path1966 || (_path1966 = /*#__PURE__*/React.createElement("path", {
    d: "M62 102v1h-1v-1z",
    fill: "#c6a9a9"
  })), _path1967 || (_path1967 = /*#__PURE__*/React.createElement("path", {
    d: "M63 102v1h-1v-1z",
    fill: "#d3c7c5"
  })), _path1968 || (_path1968 = /*#__PURE__*/React.createElement("path", {
    d: "M64 102v1h-1v-1z",
    fill: "#d4c7c6"
  })), _path1969 || (_path1969 = /*#__PURE__*/React.createElement("path", {
    d: "M65 103h-1v-1h1z",
    fill: "#cdb6b4"
  })), _path1970 || (_path1970 = /*#__PURE__*/React.createElement("path", {
    d: "M66 103h-1v-1h1z",
    fill: "#d5c1be"
  })), _path1971 || (_path1971 = /*#__PURE__*/React.createElement("path", {
    d: "M66 103v-1h1v1z",
    fill: "#d5c1bd"
  })), _path1972 || (_path1972 = /*#__PURE__*/React.createElement("path", {
    d: "M68 103h-1v-1h1z",
    fill: "#d8c3c3"
  })), _path1973 || (_path1973 = /*#__PURE__*/React.createElement("path", {
    d: "M69 102v1h-1v-1z",
    fill: "#d5bdbb"
  })), _path1974 || (_path1974 = /*#__PURE__*/React.createElement("path", {
    d: "M69 102h1v1h-1z",
    fill: "#d4b8b7"
  })), _path1975 || (_path1975 = /*#__PURE__*/React.createElement("path", {
    d: "M70 102h1v1h-1z",
    fill: "#dabdbf"
  })), _path1976 || (_path1976 = /*#__PURE__*/React.createElement("path", {
    d: "M71 103v-1h1v1z",
    fill: "#cdb4b3"
  })), _path1977 || (_path1977 = /*#__PURE__*/React.createElement("path", {
    d: "M73 102v1h-1v-1z",
    fill: "#d5b3b5"
  })), _path1978 || (_path1978 = /*#__PURE__*/React.createElement("path", {
    d: "M74 102v1h-1v-1z",
    fill: "#cb9aa1"
  })), _path1979 || (_path1979 = /*#__PURE__*/React.createElement("path", {
    d: "M74 102h1v1h-1z",
    fill: "#d2afae"
  })), _path1980 || (_path1980 = /*#__PURE__*/React.createElement("path", {
    d: "M76 103h-1v-1h1z",
    fill: "#d3aaab"
  })), _path1981 || (_path1981 = /*#__PURE__*/React.createElement("path", {
    d: "M77 103h-1v-1h1z",
    fill: "#c7979d"
  })), _path1982 || (_path1982 = /*#__PURE__*/React.createElement("path", {
    d: "M78 103h-1v-1h1z",
    fill: "#ebd5d7"
  })), _path1983 || (_path1983 = /*#__PURE__*/React.createElement("path", {
    d: "M78 103v-1h1v1z",
    fill: "#f4f5f2"
  })), _path1984 || (_path1984 = /*#__PURE__*/React.createElement("path", {
    d: "M80 103v-1h1v1z",
    fill: "#413f3b"
  })), _path1985 || (_path1985 = /*#__PURE__*/React.createElement("path", {
    d: "M81 102h1v1h-1z",
    fill: "#1b1715",
    fillOpacity: 0.925
  })), _path1986 || (_path1986 = /*#__PURE__*/React.createElement("path", {
    d: "M49 104h-1v-1h1z",
    fill: "#c8c6c3"
  })), _path1987 || (_path1987 = /*#__PURE__*/React.createElement("path", {
    d: "M51 104h-1v-1h1z",
    fill: "#dfd5d4"
  })), _path1988 || (_path1988 = /*#__PURE__*/React.createElement("path", {
    d: "M52 104h-1v-1h1z",
    fill: "#d7c8c6"
  })), _path1989 || (_path1989 = /*#__PURE__*/React.createElement("path", {
    d: "M52 103h1v1h-1z",
    fill: "#d5c4c3"
  })), _path1990 || (_path1990 = /*#__PURE__*/React.createElement("path", {
    d: "M54 103v1h-1v-1z",
    fill: "#cbb0ad"
  })), _path1991 || (_path1991 = /*#__PURE__*/React.createElement("path", {
    d: "M54 104v-1h1v1z",
    fill: "#c7adac"
  })), _path1992 || (_path1992 = /*#__PURE__*/React.createElement("path", {
    d: "M55 104v-1h1v1z",
    fill: "#c5aaab"
  })), _path1993 || (_path1993 = /*#__PURE__*/React.createElement("path", {
    d: "M56 104v-1h1v1z",
    fill: "#c3a4a3"
  })), _path1994 || (_path1994 = /*#__PURE__*/React.createElement("path", {
    d: "M58 103v1h-1v-1z",
    fill: "#caa8a8"
  })), _path1995 || (_path1995 = /*#__PURE__*/React.createElement("path", {
    d: "M58 103h1v1h-1z",
    fill: "#bc9495"
  })), _path1996 || (_path1996 = /*#__PURE__*/React.createElement("path", {
    d: "M59 104v-1h1v1z",
    fill: "#c29596"
  })), _path1997 || (_path1997 = /*#__PURE__*/React.createElement("path", {
    d: "M60 104v-1h1v1z",
    fill: "#c6a0a3"
  })), _path1998 || (_path1998 = /*#__PURE__*/React.createElement("path", {
    d: "M62 104h-1v-1h1z",
    fill: "#cdb4af"
  })), _path1999 || (_path1999 = /*#__PURE__*/React.createElement("path", {
    d: "M62 103h1v1h-1z",
    fill: "#d8cecb"
  })), _path2000 || (_path2000 = /*#__PURE__*/React.createElement("path", {
    d: "M63 103h1v1h-1z",
    fill: "#d4bfbf"
  })), _path2001 || (_path2001 = /*#__PURE__*/React.createElement("path", {
    d: "M65 103v1h-1v-1z",
    fill: "#bf9595"
  })), _path2002 || (_path2002 = /*#__PURE__*/React.createElement("path", {
    d: "M65 104v-1h1v1z",
    fill: "#c39b9e"
  })), _path2003 || (_path2003 = /*#__PURE__*/React.createElement("path", {
    d: "M66 103h1v1h-1z",
    fill: "#c3a1a1"
  })), _path2004 || (_path2004 = /*#__PURE__*/React.createElement("path", {
    d: "M68 103v1h-1v-1z",
    fill: "#c79da2"
  })), _path2005 || (_path2005 = /*#__PURE__*/React.createElement("path", {
    d: "M68 103h1v1h-1z",
    fill: "#d2bab9"
  })), _path2006 || (_path2006 = /*#__PURE__*/React.createElement("path", {
    d: "M70 104h-1v-1h1z",
    fill: "#caa8aa"
  })), _path2007 || (_path2007 = /*#__PURE__*/React.createElement("path", {
    d: "M71 103v1h-1v-1z",
    fill: "#dac4c2"
  })), _path2008 || (_path2008 = /*#__PURE__*/React.createElement("path", {
    d: "M72 103v1h-1v-1z",
    fill: "#d4b0b0"
  })), _path2009 || (_path2009 = /*#__PURE__*/React.createElement("path", {
    d: "M72 103h1v1h-1z",
    fill: "#d5b3b2"
  })), _path2010 || (_path2010 = /*#__PURE__*/React.createElement("path", {
    d: "M73 103h1v1h-1z",
    fill: "#d9bfbd"
  })), _path2011 || (_path2011 = /*#__PURE__*/React.createElement("path", {
    d: "M75 104h-1v-1h1z",
    fill: "#e0c7c8"
  })), _path2012 || (_path2012 = /*#__PURE__*/React.createElement("path", {
    d: "M75 104v-1h1v1z",
    fill: "#e3cdce"
  })), _path2013 || (_path2013 = /*#__PURE__*/React.createElement("path", {
    d: "M77 103v1h-1v-1z",
    fill: "#eadfe0"
  })), _path2014 || (_path2014 = /*#__PURE__*/React.createElement("path", {
    d: "M77 104v-1h1v1z",
    fill: "#f0eaea"
  })), _path2015 || (_path2015 = /*#__PURE__*/React.createElement("path", {
    d: "M80 104v-1h1v1z",
    fill: "#413e3b"
  })), _path2016 || (_path2016 = /*#__PURE__*/React.createElement("path", {
    d: "M81 103h1v1h-1z",
    fill: "#1c1715",
    fillOpacity: 0.925
  })), _path2017 || (_path2017 = /*#__PURE__*/React.createElement("path", {
    d: "M83 104h-1v-1h1z",
    fill: "#625858",
    fillOpacity: 0.102
  })), _path2018 || (_path2018 = /*#__PURE__*/React.createElement("path", {
    d: "M49 105h-1v-1h1z",
    fill: "#c4c4bf"
  })), _path2019 || (_path2019 = /*#__PURE__*/React.createElement("path", {
    d: "M51 104h1v1h-1z",
    fill: "#e1ddd9"
  })), _path2020 || (_path2020 = /*#__PURE__*/React.createElement("path", {
    d: "M55 105h-1v-1h1z",
    fill: "#dcddd7"
  })), _path2021 || (_path2021 = /*#__PURE__*/React.createElement("path", {
    d: "M59 104h1v1h-1z",
    fill: "#d6d8d2"
  })), _path2022 || (_path2022 = /*#__PURE__*/React.createElement("path", {
    d: "M60 104h1v1h-1z",
    fill: "#d8d3cf"
  })), _path2023 || (_path2023 = /*#__PURE__*/React.createElement("path", {
    d: "M61 104h1v1h-1z",
    fill: "#d9d8d2"
  })), _path2024 || (_path2024 = /*#__PURE__*/React.createElement("path", {
    d: "M64 105h-1v-1h1z",
    fill: "#d9dad6"
  })), _path2025 || (_path2025 = /*#__PURE__*/React.createElement("path", {
    d: "M65 105h-1v-1h1z",
    fill: "#d8d6d0"
  })), _path2026 || (_path2026 = /*#__PURE__*/React.createElement("path", {
    d: "M65 104h1v1h-1z",
    fill: "#e1dbd9"
  })), _path2027 || (_path2027 = /*#__PURE__*/React.createElement("path", {
    d: "M66 104h1v1h-1z",
    fill: "#e3ddd9"
  })), _path2028 || (_path2028 = /*#__PURE__*/React.createElement("path", {
    d: "M68 105h-1v-1h1z",
    fill: "#e0dad6"
  })), _path2029 || (_path2029 = /*#__PURE__*/React.createElement("path", {
    d: "M68 104h1v1h-1z",
    fill: "#e4e1de"
  })), _path2030 || (_path2030 = /*#__PURE__*/React.createElement("path", {
    d: "M70 104v1h-1v-1z",
    fill: "#e5e3e4"
  })), _path2031 || (_path2031 = /*#__PURE__*/React.createElement("path", {
    d: "M71 104h1v1h-1z",
    fill: "#e9e7e4"
  })), _path2032 || (_path2032 = /*#__PURE__*/React.createElement("path", {
    d: "M73 104v1h-1v-1z",
    fill: "#eae9e6"
  })), _path2033 || (_path2033 = /*#__PURE__*/React.createElement("path", {
    d: "M75 105h-1v-1h1z",
    fill: "#edece6"
  })), _path2034 || (_path2034 = /*#__PURE__*/React.createElement("path", {
    d: "M77 104h1v1h-1z",
    fill: "#f2efee"
  })), _path2035 || (_path2035 = /*#__PURE__*/React.createElement("path", {
    d: "M80 105h-1v-1h1z",
    fill: "#eeeeeb"
  })), _path2036 || (_path2036 = /*#__PURE__*/React.createElement("path", {
    d: "M82 104v1h-1v-1z",
    fill: "#1b1815",
    fillOpacity: 0.922
  })), _path2037 || (_path2037 = /*#__PURE__*/React.createElement("path", {
    d: "M46 106h-1v-1h1z",
    fill: "#6a5555",
    fillOpacity: 0.047
  })), _path2038 || (_path2038 = /*#__PURE__*/React.createElement("path", {
    d: "M47 105v1h-1v-1z",
    fill: "#1c1c1a",
    fillOpacity: 0.875
  })), _path2039 || (_path2039 = /*#__PURE__*/React.createElement("path", {
    d: "M49 106h-1v-1h1z",
    fill: "#c4c4c0"
  })), _path2040 || (_path2040 = /*#__PURE__*/React.createElement("path", {
    d: "M52 105v1h-1v-1z",
    fill: "#dfdcd7"
  })), _path2041 || (_path2041 = /*#__PURE__*/React.createElement("path", {
    d: "M53 106h-1v-1h1z",
    fill: "#dbd7cf"
  })), _path2042 || (_path2042 = /*#__PURE__*/React.createElement("path", {
    d: "M54 105v1h-1v-1z",
    fill: "#d1c7bf"
  })), _path2043 || (_path2043 = /*#__PURE__*/React.createElement("path", {
    d: "M54 106v-1h1v1z",
    fill: "#d3cdc3"
  })), _path2044 || (_path2044 = /*#__PURE__*/React.createElement("path", {
    d: "M58 106h-1v-1h1z",
    fill: "#d2d1c5"
  })), _path2045 || (_path2045 = /*#__PURE__*/React.createElement("path", {
    d: "M59 105v1h-1v-1z",
    fill: "#d7d0c8"
  })), _path2046 || (_path2046 = /*#__PURE__*/React.createElement("path", {
    d: "M59 106v-1h1v1z",
    fill: "#d6d2cb"
  })), _path2047 || (_path2047 = /*#__PURE__*/React.createElement("path", {
    d: "M60 106v-1h1v1z",
    fill: "#d2cdc2"
  })), _path2048 || (_path2048 = /*#__PURE__*/React.createElement("path", {
    d: "M63 105v1h-1v-1z",
    fill: "#d1cbbe"
  })), _path2049 || (_path2049 = /*#__PURE__*/React.createElement("path", {
    d: "M63 105h1v1h-1z",
    fill: "#d0c8bc"
  })), _path2050 || (_path2050 = /*#__PURE__*/React.createElement("path", {
    d: "M64 105h1v1h-1z",
    fill: "#d5ccc2"
  })), _path2051 || (_path2051 = /*#__PURE__*/React.createElement("path", {
    d: "M65 106v-1h1v1z",
    fill: "#d2c9bf"
  })), _path2052 || (_path2052 = /*#__PURE__*/React.createElement("path", {
    d: "M67 105v1h-1v-1z",
    fill: "#d2cec6"
  })), _path2053 || (_path2053 = /*#__PURE__*/React.createElement("path", {
    d: "M67 105h1v1h-1z",
    fill: "#dad6cf"
  })), _path2054 || (_path2054 = /*#__PURE__*/React.createElement("path", {
    d: "M69 105v1h-1v-1z",
    fill: "#d0cac0"
  })), _path2055 || (_path2055 = /*#__PURE__*/React.createElement("path", {
    d: "M70 106h-1v-1h1z",
    fill: "#d6d0c4"
  })), _path2056 || (_path2056 = /*#__PURE__*/React.createElement("path", {
    d: "M70 105h1v1h-1z",
    fill: "#d7cfc2"
  })), _path2057 || (_path2057 = /*#__PURE__*/React.createElement("path", {
    d: "M71 106v-1h1v1z",
    fill: "#ddd3c4"
  })), _path2058 || (_path2058 = /*#__PURE__*/React.createElement("path", {
    d: "M72 105h1v1h-1z",
    fill: "#e1d7c8"
  })), _path2059 || (_path2059 = /*#__PURE__*/React.createElement("path", {
    d: "M73 106v-1h1v1z",
    fill: "#e4d8ca"
  })), _path2060 || (_path2060 = /*#__PURE__*/React.createElement("path", {
    d: "M75 105v1h-1v-1z",
    fill: "#e7ded2"
  })), _path2061 || (_path2061 = /*#__PURE__*/React.createElement("path", {
    d: "M76 106h-1v-1h1z",
    fill: "#ecebe5"
  })), _path2062 || (_path2062 = /*#__PURE__*/React.createElement("path", {
    d: "M77 106v-1h1v1z",
    fill: "#eef0ec"
  })), _path2063 || (_path2063 = /*#__PURE__*/React.createElement("path", {
    d: "M78 105h1v1h-1z",
    fill: "#f1f2f0"
  })), _path2064 || (_path2064 = /*#__PURE__*/React.createElement("path", {
    d: "M80 105v1h-1v-1z",
    fill: "#edeeeb"
  })), _path2065 || (_path2065 = /*#__PURE__*/React.createElement("path", {
    d: "M81 106h-1v-1h1z",
    fill: "#40403b"
  })), _path2066 || (_path2066 = /*#__PURE__*/React.createElement("path", {
    d: "M82 106h-1v-1h1z",
    fill: "#1a1815",
    fillOpacity: 0.922
  })), _path2067 || (_path2067 = /*#__PURE__*/React.createElement("path", {
    d: "M46 106h1v1h-1z",
    fill: "#1d1c1a",
    fillOpacity: 0.871
  })), _path2068 || (_path2068 = /*#__PURE__*/React.createElement("path", {
    d: "M48 107v-1h1v1z",
    fill: "#c8c5c1"
  })), _path2069 || (_path2069 = /*#__PURE__*/React.createElement("path", {
    d: "M49 106h1v1h-1z",
    fill: "#e1dddc"
  })), _path2070 || (_path2070 = /*#__PURE__*/React.createElement("path", {
    d: "M51 106v1h-1v-1z",
    fill: "#dddbda"
  })), _path2071 || (_path2071 = /*#__PURE__*/React.createElement("path", {
    d: "M52 106h1v1h-1z",
    fill: "#dbdad3"
  })), _path2072 || (_path2072 = /*#__PURE__*/React.createElement("path", {
    d: "M53 106h1v1h-1z",
    fill: "#d8d6ce"
  })), _path2073 || (_path2073 = /*#__PURE__*/React.createElement("path", {
    d: "M54 107v-1h1v1z",
    fill: "#d4d4cb"
  })), _path2074 || (_path2074 = /*#__PURE__*/React.createElement("path", {
    d: "M55 107v-1h1v1z",
    fill: "#d4d2c9"
  })), _path2075 || (_path2075 = /*#__PURE__*/React.createElement("path", {
    d: "M57 107h-1v-1h1z",
    fill: "#d4cec5"
  })), _path2076 || (_path2076 = /*#__PURE__*/React.createElement("path", {
    d: "M58 106v1h-1v-1z",
    fill: "#d4cec3"
  })), _path2077 || (_path2077 = /*#__PURE__*/React.createElement("path", {
    d: "M59 107h-1v-1h1z",
    fill: "#d2cdc3"
  })), _path2078 || (_path2078 = /*#__PURE__*/React.createElement("path", {
    d: "M60 106v1h-1v-1z",
    fill: "#d0d0c5"
  })), _path2079 || (_path2079 = /*#__PURE__*/React.createElement("path", {
    d: "M61 106h1v1h-1z",
    fill: "#cfc7b9"
  })), _path2080 || (_path2080 = /*#__PURE__*/React.createElement("path", {
    d: "M62 106h1v1h-1z",
    fill: "#cec9b9"
  })), _path2081 || (_path2081 = /*#__PURE__*/React.createElement("path", {
    d: "M64 107h-1v-1h1z",
    fill: "#cac5b5"
  })), _path2082 || (_path2082 = /*#__PURE__*/React.createElement("path", {
    d: "M65 106v1h-1v-1z",
    fill: "#cfcabc"
  })), _path2083 || (_path2083 = /*#__PURE__*/React.createElement("path", {
    d: "M65 107v-1h1v1z",
    fill: "#cfc6ba"
  })), _path2084 || (_path2084 = /*#__PURE__*/React.createElement("path", {
    d: "M66 106h1v1h-1z",
    fill: "#d2d1c7"
  })), _path2085 || (_path2085 = /*#__PURE__*/React.createElement("path", {
    d: "M68 106v1h-1v-1z",
    fill: "#d9d8d0"
  })), _path2086 || (_path2086 = /*#__PURE__*/React.createElement("path", {
    d: "M68 107v-1h1v1z",
    fill: "#d2c8c0"
  })), _path2087 || (_path2087 = /*#__PURE__*/React.createElement("path", {
    d: "M69 107v-1h1v1z",
    fill: "#d6d3c7"
  })), _path2088 || (_path2088 = /*#__PURE__*/React.createElement("path", {
    d: "M70 107v-1h1v1z",
    fill: "#dcd9d1"
  })), _path2089 || (_path2089 = /*#__PURE__*/React.createElement("path", {
    d: "M71 106h1v1h-1z",
    fill: "#dfdbd3"
  })), _path2090 || (_path2090 = /*#__PURE__*/React.createElement("path", {
    d: "M73 106v1h-1v-1z",
    fill: "#e5dfd6"
  })), _path2091 || (_path2091 = /*#__PURE__*/React.createElement("path", {
    d: "M74 107h-1v-1h1z",
    fill: "#eae3db"
  })), _path2092 || (_path2092 = /*#__PURE__*/React.createElement("path", {
    d: "M75 106v1h-1v-1z",
    fill: "#ebe8e0"
  })), _path2093 || (_path2093 = /*#__PURE__*/React.createElement("path", {
    d: "M77 106v1h-1v-1z",
    fill: "#eeeeed"
  })), _path2094 || (_path2094 = /*#__PURE__*/React.createElement("path", {
    d: "M77 107v-1h1v1z",
    fill: "#f0eeee"
  })), _path2095 || (_path2095 = /*#__PURE__*/React.createElement("path", {
    d: "M79 107h-1v-1h1z",
    fill: "#f1f2f1"
  })), _path2096 || (_path2096 = /*#__PURE__*/React.createElement("path", {
    d: "M80 106h1v1h-1z",
    fill: "#3f3f3b"
  })), _path2097 || (_path2097 = /*#__PURE__*/React.createElement("path", {
    d: "M47 107v1h-1v-1z",
    fill: "#1c1c1a",
    fillOpacity: 0.871
  })), _path2098 || (_path2098 = /*#__PURE__*/React.createElement("path", {
    d: "M49 107v1h-1v-1z",
    fill: "#cbc8c3"
  })), _path2099 || (_path2099 = /*#__PURE__*/React.createElement("path", {
    d: "M50 107v1h-1v-1z",
    fill: "#e3e2df"
  })), _path2100 || (_path2100 = /*#__PURE__*/React.createElement("path", {
    d: "M50 108v-1h1v1z",
    fill: "#e0e0dc"
  })), _path2101 || (_path2101 = /*#__PURE__*/React.createElement("path", {
    d: "M51 108v-1h1v1z",
    fill: "#deddd8"
  })), _path2102 || (_path2102 = /*#__PURE__*/React.createElement("path", {
    d: "M54 107h1v1h-1z",
    fill: "#d9d8d5"
  })), _path2103 || (_path2103 = /*#__PURE__*/React.createElement("path", {
    d: "M57 108v-1h1v1z",
    fill: "#d8d8d4"
  })), _path2104 || (_path2104 = /*#__PURE__*/React.createElement("path", {
    d: "M59 107h1v1h-1z",
    fill: "#d7d6d3"
  })), _path2105 || (_path2105 = /*#__PURE__*/React.createElement("path", {
    d: "M78 107v1h-1v-1z",
    fill: "#f3f2f0"
  })), _path2106 || (_path2106 = /*#__PURE__*/React.createElement("path", {
    d: "M79 107v1h-1v-1z",
    fill: "#f7f7f6"
  })), _path2107 || (_path2107 = /*#__PURE__*/React.createElement("path", {
    d: "M81 107h1v1h-1z",
    fill: "#1a1915",
    fillOpacity: 0.918
  })), _path2108 || (_path2108 = /*#__PURE__*/React.createElement("path", {
    d: "M46 109v-1h1v1z",
    fill: "#1e1e1b",
    fillOpacity: 0.867
  })), _path2109 || (_path2109 = /*#__PURE__*/React.createElement("path", {
    d: "M48 109h-1v-1h1z",
    fill: "#1b1916"
  })), _path2110 || (_path2110 = /*#__PURE__*/React.createElement("path", {
    d: "M49 108v1h-1v-1z",
    fill: "#83807b"
  })), _path2111 || (_path2111 = /*#__PURE__*/React.createElement("path", {
    d: "M50 109h-1v-1h1z",
    fill: "#aeaba7"
  })), _path2112 || (_path2112 = /*#__PURE__*/React.createElement("path", {
    d: "M51 109h-1v-1h1z",
    fill: "#b9b7b3"
  })), _path2113 || (_path2113 = /*#__PURE__*/React.createElement("path", {
    d: "M51 108h1v1h-1z",
    fill: "#ceccc9"
  })), _path2114 || (_path2114 = /*#__PURE__*/React.createElement("path", {
    d: "M53 109v-1h1v1z",
    fill: "#dedcd9"
  })), _path2115 || (_path2115 = /*#__PURE__*/React.createElement("path", {
    d: "M65 108h1v1h-1z",
    fill: "#e3e2dd"
  })), _path2116 || (_path2116 = /*#__PURE__*/React.createElement("path", {
    d: "M69 109h-1v-1h1z",
    fill: "#e5e4e3"
  })), _path2117 || (_path2117 = /*#__PURE__*/React.createElement("path", {
    d: "M73 109v-1h1v1z",
    fill: "#f0efec"
  })), _path2118 || (_path2118 = /*#__PURE__*/React.createElement("path", {
    d: "M74 108h1v1h-1z",
    fill: "#eeedea"
  })), _path2119 || (_path2119 = /*#__PURE__*/React.createElement("path", {
    d: "M76 109h-1v-1h1z",
    fill: "#e2e1de"
  })), _path2120 || (_path2120 = /*#__PURE__*/React.createElement("path", {
    d: "M77 109v-1h1v1z",
    fill: "#dbd9d6"
  })), _path2121 || (_path2121 = /*#__PURE__*/React.createElement("path", {
    d: "M78 108h1v1h-1z",
    fill: "#bebdb9"
  })), _path2122 || (_path2122 = /*#__PURE__*/React.createElement("path", {
    d: "M80 108v1h-1v-1z",
    fill: "#a5a4a0"
  })), _path2123 || (_path2123 = /*#__PURE__*/React.createElement("path", {
    d: "M81 109h-1v-1h1z",
    fill: "#34332e"
  })), _path2124 || (_path2124 = /*#__PURE__*/React.createElement("path", {
    d: "M81 108h1v1h-1z",
    fill: "#1c1b18",
    fillOpacity: 0.914
  })), _path2125 || (_path2125 = /*#__PURE__*/React.createElement("path", {
    d: "M49 109h1v1h-1z",
    fill: "#33302b"
  })), _path2126 || (_path2126 = /*#__PURE__*/React.createElement("path", {
    d: "M52 110h-1v-1h1z",
    fill: "#3c3835"
  })), _path2127 || (_path2127 = /*#__PURE__*/React.createElement("path", {
    d: "M52 110v-1h1v1z",
    fill: "#4d4947"
  })), _path2128 || (_path2128 = /*#__PURE__*/React.createElement("path", {
    d: "M54 110h-1v-1h1z",
    fill: "#4e4c4a"
  })), _path2129 || (_path2129 = /*#__PURE__*/React.createElement("path", {
    d: "M54 109h1v1h-1z",
    fill: "#71706e"
  })), _path2130 || (_path2130 = /*#__PURE__*/React.createElement("path", {
    d: "M55 109h1v1h-1z",
    fill: "#6e6c6b"
  })), _path2131 || (_path2131 = /*#__PURE__*/React.createElement("path", {
    d: "M56 109h1v1h-1z",
    fill: "#888785"
  })), _path2132 || (_path2132 = /*#__PURE__*/React.createElement("path", {
    d: "M57 110v-1h1v1z",
    fill: "#b1b0ad"
  })), _path2133 || (_path2133 = /*#__PURE__*/React.createElement("path", {
    d: "M59 109v1h-1v-1z",
    fill: "#b3b2b0"
  })), _path2134 || (_path2134 = /*#__PURE__*/React.createElement("path", {
    d: "M59 109h1v1h-1z",
    fill: "#9e9d9b"
  })), _path2135 || (_path2135 = /*#__PURE__*/React.createElement("path", {
    d: "M60 109h1v1h-1z",
    fill: "#737270"
  })), _path2136 || (_path2136 = /*#__PURE__*/React.createElement("path", {
    d: "M62 110h-1v-1h1z",
    fill: "#777673"
  })), _path2137 || (_path2137 = /*#__PURE__*/React.createElement("path", {
    d: "M62 109h1v1h-1z",
    fill: "#9c9b97"
  })), _path2138 || (_path2138 = /*#__PURE__*/React.createElement("path", {
    d: "M64 109v1h-1v-1z",
    fill: "#afaeaa"
  })), _path2139 || (_path2139 = /*#__PURE__*/React.createElement("path", {
    d: "M65 110h-1v-1h1z",
    fill: "#b3b2ae"
  })), _path2140 || (_path2140 = /*#__PURE__*/React.createElement("path", {
    d: "M65 109h1v1h-1z",
    fill: "#9e9d9a"
  })), _path2141 || (_path2141 = /*#__PURE__*/React.createElement("path", {
    d: "M66 109h1v1h-1z",
    fill: "#959492"
  })), _path2142 || (_path2142 = /*#__PURE__*/React.createElement("path", {
    d: "M67 110v-1h1v1z",
    fill: "#afaeac"
  })), _path2143 || (_path2143 = /*#__PURE__*/React.createElement("path", {
    d: "M69 109v1h-1v-1z",
    fill: "#b7b5b6"
  })), _path2144 || (_path2144 = /*#__PURE__*/React.createElement("path", {
    d: "M69 109h1v1h-1z",
    fill: "#999898"
  })), _path2145 || (_path2145 = /*#__PURE__*/React.createElement("path", {
    d: "M71 110h-1v-1h1z",
    fill: "#7b7a78"
  })), _path2146 || (_path2146 = /*#__PURE__*/React.createElement("path", {
    d: "M72 110h-1v-1h1z",
    fill: "#7c7b79"
  })), _path2147 || (_path2147 = /*#__PURE__*/React.createElement("path", {
    d: "M72 109h1v1h-1z",
    fill: "#807f7e"
  })), _path2148 || (_path2148 = /*#__PURE__*/React.createElement("path", {
    d: "M73 109h1v1h-1z",
    fill: "#9a9997"
  })), _path2149 || (_path2149 = /*#__PURE__*/React.createElement("path", {
    d: "M74 110v-1h1v1z",
    fill: "#959490"
  })), _path2150 || (_path2150 = /*#__PURE__*/React.createElement("path", {
    d: "M76 110v-1h1v1z",
    fill: "#807f7b"
  })), _path2151 || (_path2151 = /*#__PURE__*/React.createElement("path", {
    d: "M79 109v1h-1v-1z",
    fill: "#706c68"
  })), _path2152 || (_path2152 = /*#__PURE__*/React.createElement("path", {
    d: "M79 109h1v1h-1z",
    fill: "#6f6b67"
  })), _path2153 || (_path2153 = /*#__PURE__*/React.createElement("path", {
    d: "M81 109v1h-1v-1z",
    fill: "#31302c"
  })), _path2154 || (_path2154 = /*#__PURE__*/React.createElement("path", {
    d: "M81 109h1v1h-1z",
    fill: "#1c1c18",
    fillOpacity: 0.914
  })), _path2155 || (_path2155 = /*#__PURE__*/React.createElement("path", {
    d: "M51 110v1h-1v-1z",
    fill: "#302d29"
  })), _path2156 || (_path2156 = /*#__PURE__*/React.createElement("path", {
    d: "M54 110v1h-1v-1z",
    fill: "#100e0d"
  })), _path2157 || (_path2157 = /*#__PURE__*/React.createElement("path", {
    d: "M59 111h-1v-1h1z",
    fill: "#0b0a09"
  })), _path2158 || (_path2158 = /*#__PURE__*/React.createElement("path", {
    d: "M63 110v1h-1v-1z",
    fill: "#090606"
  })), _path2159 || (_path2159 = /*#__PURE__*/React.createElement("path", {
    d: "M63 110h1v1h-1z",
    fill: "#0e0b0b"
  })), _path2160 || (_path2160 = /*#__PURE__*/React.createElement("path", {
    d: "M65 111h-1v-1h1z",
    fill: "#0e0c0c"
  })), _path2161 || (_path2161 = /*#__PURE__*/React.createElement("path", {
    d: "M68 110v1h-1v-1z",
    fill: "#070505"
  })), _path2162 || (_path2162 = /*#__PURE__*/React.createElement("path", {
    d: "M74 111h-1v-1h1z",
    fill: "#4b4946"
  })), _path2163 || (_path2163 = /*#__PURE__*/React.createElement("path", {
    d: "M74 111v-1h1v1z",
    fill: "#5b5955"
  })), _path2164 || (_path2164 = /*#__PURE__*/React.createElement("path", {
    d: "M76 111h-1v-1h1z",
    fill: "#666561"
  })), _path2165 || (_path2165 = /*#__PURE__*/React.createElement("path", {
    d: "M76 110h1v1h-1z",
    fill: "#6d6c68"
  })), _path2166 || (_path2166 = /*#__PURE__*/React.createElement("path", {
    d: "M79 111h-1v-1h1z",
    fill: "#76716d"
  })), _path2167 || (_path2167 = /*#__PURE__*/React.createElement("path", {
    d: "M80 110v1h-1v-1z",
    fill: "#73706c"
  })), _path2168 || (_path2168 = /*#__PURE__*/React.createElement("path", {
    d: "M82 111h-1v-1h1z",
    fill: "#1d1c17",
    fillOpacity: 0.918
  })), _path2169 || (_path2169 = /*#__PURE__*/React.createElement("path", {
    d: "M81 112v-1h1v1z",
    fill: "#1e1b17",
    fillOpacity: 0.918
  })), _path2170 || (_path2170 = /*#__PURE__*/React.createElement("path", {
    d: "M46 112h1v1h-1z",
    fill: "#201f1c",
    fillOpacity: 0.871
  })), _path2171 || (_path2171 = /*#__PURE__*/React.createElement("path", {
    d: "M49 112v1h-1v-1z",
    fill: "#403d39"
  })), _path2172 || (_path2172 = /*#__PURE__*/React.createElement("path", {
    d: "M51 113v-1h1v1z",
    fill: "#2a2724"
  })), _path2173 || (_path2173 = /*#__PURE__*/React.createElement("path", {
    d: "M59 113v-1h1v1z",
    fill: "#0a0807"
  })), _path2174 || (_path2174 = /*#__PURE__*/React.createElement("path", {
    d: "M67 112h1v1h-1z",
    fill: "#080505"
  })), _path2175 || (_path2175 = /*#__PURE__*/React.createElement("path", {
    d: "M82 113h-1v-1h1z",
    fill: "#1e1b17",
    fillOpacity: 0.922
  })), _path2176 || (_path2176 = /*#__PURE__*/React.createElement("path", {
    d: "M83 112v1h-1v-1z",
    fill: "#5b665b",
    fillOpacity: 0.098
  })), _path2177 || (_path2177 = /*#__PURE__*/React.createElement("path", {
    d: "M46 113v1h-1v-1z",
    fill: "#69695a",
    fillOpacity: 0.067
  })), _path2178 || (_path2178 = /*#__PURE__*/React.createElement("path", {
    d: "M46 114v-1h1v1z",
    fill: "#201f1d",
    fillOpacity: 0.894
  })), _path2179 || (_path2179 = /*#__PURE__*/React.createElement("path", {
    d: "M47 113h1v1h-1z",
    fill: "#1d1916"
  })), _path2180 || (_path2180 = /*#__PURE__*/React.createElement("path", {
    d: "M80 114v-1h1v1z",
    fill: "#34302d"
  })), _path2181 || (_path2181 = /*#__PURE__*/React.createElement("path", {
    d: "M82 114h-1v-1h1z",
    fill: "#1d1a17",
    fillOpacity: 0.937
  })), _path2182 || (_path2182 = /*#__PURE__*/React.createElement("path", {
    d: "M83 114h-1v-1h1z",
    fill: "#555",
    fillOpacity: 0.118
  })), _path2183 || (_path2183 = /*#__PURE__*/React.createElement("path", {
    d: "M46 114h1v1h-1z",
    fill: "#1e1d1b",
    fillOpacity: 0.91
  })), _path2184 || (_path2184 = /*#__PURE__*/React.createElement("path", {
    d: "M47 115v-1h1v1z",
    fill: "#1e1a17"
  })), _path2185 || (_path2185 = /*#__PURE__*/React.createElement("path", {
    d: "M49 114h1v1h-1z",
    fill: "#383530"
  })), _path2186 || (_path2186 = /*#__PURE__*/React.createElement("path", {
    d: "M52 115v-1h1v1z",
    fill: "#23211d"
  })), _path2187 || (_path2187 = /*#__PURE__*/React.createElement("path", {
    d: "M80 114h1v1h-1z",
    fill: "#383331"
  })), _path2188 || (_path2188 = /*#__PURE__*/React.createElement("path", {
    d: "M81 115v-1h1v1z",
    fill: "#1d1a17",
    fillOpacity: 0.953
  })), _path2189 || (_path2189 = /*#__PURE__*/React.createElement("path", {
    d: "M83 115h-1v-1h1z",
    fill: "#484841",
    fillOpacity: 0.137
  })), _path2190 || (_path2190 = /*#__PURE__*/React.createElement("path", {
    d: "M46 115h1v1h-1z",
    fill: "#1e1d1a",
    fillOpacity: 0.929
  })), _path2191 || (_path2191 = /*#__PURE__*/React.createElement("path", {
    d: "M48 116h-1v-1h1z",
    fill: "#1f1c18"
  })), _path2192 || (_path2192 = /*#__PURE__*/React.createElement("path", {
    d: "M75 116h-1v-1h1z",
    fill: "#625d5b"
  })), _path2193 || (_path2193 = /*#__PURE__*/React.createElement("path", {
    d: "M81 116h-1v-1h1z",
    fill: "#3b3735"
  })), _path2194 || (_path2194 = /*#__PURE__*/React.createElement("path", {
    d: "M81 116v-1h1v1z",
    fill: "#1b1817",
    fillOpacity: 0.965
  })), _path2195 || (_path2195 = /*#__PURE__*/React.createElement("path", {
    d: "M82 116v-1h1v1z",
    fill: "#4a4444",
    fillOpacity: 0.161
  })), _path2196 || (_path2196 = /*#__PURE__*/React.createElement("path", {
    d: "M47 117h-1v-1h1z",
    fill: "#1d1c1a",
    fillOpacity: 0.945
  })), _path2197 || (_path2197 = /*#__PURE__*/React.createElement("path", {
    d: "M47 116h1v1h-1z",
    fill: "#211e1a"
  })), _path2198 || (_path2198 = /*#__PURE__*/React.createElement("path", {
    d: "M74 116v1h-1v-1z",
    fill: "#504e49"
  })), _path2199 || (_path2199 = /*#__PURE__*/React.createElement("path", {
    d: "M81 116v1h-1v-1z",
    fill: "#3d3938"
  })), _path2200 || (_path2200 = /*#__PURE__*/React.createElement("path", {
    d: "M82 117v-1h1v1z",
    fill: "#4a4a45",
    fillOpacity: 0.188
  })), _path2201 || (_path2201 = /*#__PURE__*/React.createElement("path", {
    d: "M45 118v-1h1v1z",
    fill: "#525252",
    fillOpacity: 0.122
  })), _path2202 || (_path2202 = /*#__PURE__*/React.createElement("path", {
    d: "M47 117v1h-1v-1z",
    fill: "#1d1c19",
    fillOpacity: 0.941
  })), _path2203 || (_path2203 = /*#__PURE__*/React.createElement("path", {
    d: "M69 118v-1h1v1z",
    fill: "#030403"
  })), _path2204 || (_path2204 = /*#__PURE__*/React.createElement("path", {
    d: "M78 118h-1v-1h1z",
    fill: "#74736f"
  })), _path2205 || (_path2205 = /*#__PURE__*/React.createElement("path", {
    d: "M81 118h-1v-1h1z",
    fill: "#3f3b3a"
  })), _path2206 || (_path2206 = /*#__PURE__*/React.createElement("path", {
    d: "M82 117h1v1h-1z",
    fill: "#4b4b46",
    fillOpacity: 0.184
  })), _path2207 || (_path2207 = /*#__PURE__*/React.createElement("path", {
    d: "M45 118h1v1h-1z",
    fill: "#595959",
    fillOpacity: 0.078
  })), _path2208 || (_path2208 = /*#__PURE__*/React.createElement("path", {
    d: "M47 118v1h-1v-1z",
    fill: "#1d1c1a",
    fillOpacity: 0.906
  })), _path2209 || (_path2209 = /*#__PURE__*/React.createElement("path", {
    d: "M49 119h-1v-1h1z",
    fill: "#423f39"
  })), _path2210 || (_path2210 = /*#__PURE__*/React.createElement("path", {
    d: "M50 119h-1v-1h1z",
    fill: "#37352f"
  })), _path2211 || (_path2211 = /*#__PURE__*/React.createElement("path", {
    d: "M62 119h-1v-1h1z",
    fill: "#0d0a0a"
  })), _path2212 || (_path2212 = /*#__PURE__*/React.createElement("path", {
    d: "M72 118v1h-1v-1z",
    fill: "#050605"
  })), _path2213 || (_path2213 = /*#__PURE__*/React.createElement("path", {
    d: "M72 119v-1h1v1z",
    fill: "#131310"
  })), _path2214 || (_path2214 = /*#__PURE__*/React.createElement("path", {
    d: "M77 119v-1h1v1z",
    fill: "#75736f"
  })), _path2215 || (_path2215 = /*#__PURE__*/React.createElement("path", {
    d: "M81 119h-1v-1h1z",
    fill: "#3e3a38"
  })), _path2216 || (_path2216 = /*#__PURE__*/React.createElement("path", {
    d: "M82 119h-1v-1h1z",
    fill: "#1c1918",
    fillOpacity: 0.953
  })), _path2217 || (_path2217 = /*#__PURE__*/React.createElement("path", {
    d: "M82 119v-1h1v1z",
    fill: "#484848",
    fillOpacity: 0.137
  })), _path2218 || (_path2218 = /*#__PURE__*/React.createElement("path", {
    d: "M46 119v1h-1v-1z",
    fill: "#996",
    fillOpacity: 0.02
  })), _path2219 || (_path2219 = /*#__PURE__*/React.createElement("path", {
    d: "M47 120h-1v-1h1z",
    fill: "#1e1d1c",
    fillOpacity: 0.82
  })), _path2220 || (_path2220 = /*#__PURE__*/React.createElement("path", {
    d: "M47 120v-1h1v1z",
    fill: "#1f1d19"
  })), _path2221 || (_path2221 = /*#__PURE__*/React.createElement("path", {
    d: "M50 119v1h-1v-1z",
    fill: "#3a3730"
  })), _path2222 || (_path2222 = /*#__PURE__*/React.createElement("path", {
    d: "M50 120v-1h1v1z",
    fill: "#322f29"
  })), _path2223 || (_path2223 = /*#__PURE__*/React.createElement("path", {
    d: "M52 119h1v1h-1z",
    fill: "#252120"
  })), _path2224 || (_path2224 = /*#__PURE__*/React.createElement("path", {
    d: "M62 119v1h-1v-1z",
    fill: "#0c0b0a"
  })), _path2225 || (_path2225 = /*#__PURE__*/React.createElement("path", {
    d: "M65 119h1v1h-1z",
    fill: "#0b0807"
  })), _path2226 || (_path2226 = /*#__PURE__*/React.createElement("path", {
    d: "M73 119v1h-1v-1z",
    fill: "#171612"
  })), _path2227 || (_path2227 = /*#__PURE__*/React.createElement("path", {
    d: "M74 119v1h-1v-1z",
    fill: "#4f4d49"
  })), _path2228 || (_path2228 = /*#__PURE__*/React.createElement("path", {
    d: "M76 120h-1v-1h1z",
    fill: "#6b6764"
  })), _path2229 || (_path2229 = /*#__PURE__*/React.createElement("path", {
    d: "M77 120h-1v-1h1z",
    fill: "#736f6b"
  })), _path2230 || (_path2230 = /*#__PURE__*/React.createElement("path", {
    d: "M79 119v1h-1v-1z",
    fill: "#767171"
  })), _path2231 || (_path2231 = /*#__PURE__*/React.createElement("path", {
    d: "M79 119h1v1h-1z",
    fill: "#736f6e"
  })), _path2232 || (_path2232 = /*#__PURE__*/React.createElement("path", {
    d: "M81 119v1h-1v-1z",
    fill: "#363231"
  })), _path2233 || (_path2233 = /*#__PURE__*/React.createElement("path", {
    d: "M81 120v-1h1v1z",
    fill: "#1d1b18",
    fillOpacity: 0.886
  })), _path2234 || (_path2234 = /*#__PURE__*/React.createElement("path", {
    d: "M46 121v-1h1v1z",
    fill: "#272725",
    fillOpacity: 0.608
  })), _path2235 || (_path2235 = /*#__PURE__*/React.createElement("path", {
    d: "M48 120v1h-1v-1z",
    fill: "#1a1814"
  })), _path2236 || (_path2236 = /*#__PURE__*/React.createElement("path", {
    d: "M49 121v-1h1v1z",
    fill: "#3d3a35"
  })), _path2237 || (_path2237 = /*#__PURE__*/React.createElement("path", {
    d: "M51 120v1h-1v-1z",
    fill: "#35312d"
  })), _path2238 || (_path2238 = /*#__PURE__*/React.createElement("path", {
    d: "M51 121v-1h1v1z",
    fill: "#2e2a27"
  })), _path2239 || (_path2239 = /*#__PURE__*/React.createElement("path", {
    d: "M52 120h1v1h-1z",
    fill: "#262220"
  })), _path2240 || (_path2240 = /*#__PURE__*/React.createElement("path", {
    d: "M72 121h-1v-1h1z",
    fill: "#0a0908"
  })), _path2241 || (_path2241 = /*#__PURE__*/React.createElement("path", {
    d: "M75 121h-1v-1h1z",
    fill: "#62605c"
  })), _path2242 || (_path2242 = /*#__PURE__*/React.createElement("path", {
    d: "M78 120v1h-1v-1z",
    fill: "#767471"
  })), _path2243 || (_path2243 = /*#__PURE__*/React.createElement("path", {
    d: "M78 121v-1h1v1z",
    fill: "#757170"
  })), _path2244 || (_path2244 = /*#__PURE__*/React.createElement("path", {
    d: "M80 120v1h-1v-1z",
    fill: "#696665"
  })), _path2245 || (_path2245 = /*#__PURE__*/React.createElement("path", {
    d: "M80 121v-1h1v1z",
    fill: "#252321"
  })), _path2246 || (_path2246 = /*#__PURE__*/React.createElement("path", {
    d: "M81 120h1v1h-1z",
    fill: "#22201f",
    fillOpacity: 0.675
  })), _path2247 || (_path2247 = /*#__PURE__*/React.createElement("path", {
    d: "M46 121h1v1h-1z",
    fill: "#484545",
    fillOpacity: 0.275
  })), _path2248 || (_path2248 = /*#__PURE__*/React.createElement("path", {
    d: "M48 121v1h-1v-1z",
    fill: "#1f1c19",
    fillOpacity: 0.992
  })), _path2249 || (_path2249 = /*#__PURE__*/React.createElement("path", {
    d: "M48 121h1v1h-1z",
    fill: "#2f2b27"
  })), _path2250 || (_path2250 = /*#__PURE__*/React.createElement("path", {
    d: "M51 122h-1v-1h1z",
    fill: "#373330"
  })), _path2251 || (_path2251 = /*#__PURE__*/React.createElement("path", {
    d: "M61 121h1v1h-1z",
    fill: "#0b0908"
  })), _path2252 || (_path2252 = /*#__PURE__*/React.createElement("path", {
    d: "M69 122h-1v-1h1z",
    fill: "#0a0504"
  })), _path2253 || (_path2253 = /*#__PURE__*/React.createElement("path", {
    d: "M70 121v1h-1v-1z",
    fill: "#0a0706"
  })), _path2254 || (_path2254 = /*#__PURE__*/React.createElement("path", {
    d: "M74 121v1h-1v-1z",
    fill: "#565551"
  })), _path2255 || (_path2255 = /*#__PURE__*/React.createElement("path", {
    d: "M75 122h-1v-1h1z",
    fill: "#646361"
  })), _path2256 || (_path2256 = /*#__PURE__*/React.createElement("path", {
    d: "M75 122v-1h1v1z",
    fill: "#6d6c6a"
  })), _path2257 || (_path2257 = /*#__PURE__*/React.createElement("path", {
    d: "M76 122v-1h1v1z",
    fill: "#72716e"
  })), _path2258 || (_path2258 = /*#__PURE__*/React.createElement("path", {
    d: "M77 121h1v1h-1z",
    fill: "#706e6c"
  })), _path2259 || (_path2259 = /*#__PURE__*/React.createElement("path", {
    d: "M79 121v1h-1v-1z",
    fill: "#6b6766"
  })), _path2260 || (_path2260 = /*#__PURE__*/React.createElement("path", {
    d: "M81 122v-1h1v1z",
    fill: "#3c3c39",
    fillOpacity: 0.333
  })), _path2261 || (_path2261 = /*#__PURE__*/React.createElement("path", {
    d: "M48 123h-1v-1h1z",
    fill: "#393733",
    fillOpacity: 0.753
  })), _path2262 || (_path2262 = /*#__PURE__*/React.createElement("path", {
    d: "M48 123v-1h1v1z",
    fill: "#28261f"
  })), _path2263 || (_path2263 = /*#__PURE__*/React.createElement("path", {
    d: "M50 122v1h-1v-1z",
    fill: "#3a3733"
  })), _path2264 || (_path2264 = /*#__PURE__*/React.createElement("path", {
    d: "M51 123v-1h1v1z",
    fill: "#393532"
  })), _path2265 || (_path2265 = /*#__PURE__*/React.createElement("path", {
    d: "M54 123h-1v-1h1z",
    fill: "#22201e"
  })), _path2266 || (_path2266 = /*#__PURE__*/React.createElement("path", {
    d: "M55 122v1h-1v-1z",
    fill: "#141311"
  })), _path2267 || (_path2267 = /*#__PURE__*/React.createElement("path", {
    d: "M55 122h1v1h-1z",
    fill: "#090808"
  })), _path2268 || (_path2268 = /*#__PURE__*/React.createElement("path", {
    d: "M61 122v1h-1v-1z",
    fill: "#070607"
  })), _path2269 || (_path2269 = /*#__PURE__*/React.createElement("path", {
    d: "M73 122v1h-1v-1z",
    fill: "#3b3a37"
  })), _path2270 || (_path2270 = /*#__PURE__*/React.createElement("path", {
    d: "M75 123h-1v-1h1z",
    fill: "#656563"
  })), _path2271 || (_path2271 = /*#__PURE__*/React.createElement("path", {
    d: "M75 122h1v1h-1z",
    fill: "#6d6d6b"
  })), _path2272 || (_path2272 = /*#__PURE__*/React.createElement("path", {
    d: "M76 122h1v1h-1z",
    fill: "#6c6c69"
  })), _path2273 || (_path2273 = /*#__PURE__*/React.createElement("path", {
    d: "M77 123v-1h1v1z",
    fill: "#656462"
  })), _path2274 || (_path2274 = /*#__PURE__*/React.createElement("path", {
    d: "M78 123v-1h1v1z",
    fill: "#514e4b"
  })), _path2275 || (_path2275 = /*#__PURE__*/React.createElement("path", {
    d: "M80 123h-1v-1h1z",
    fill: "#21201d"
  })), _path2276 || (_path2276 = /*#__PURE__*/React.createElement("path", {
    d: "M80 123v-1h1v1z",
    fill: "#282825",
    fillOpacity: 0.796
  })), _path2277 || (_path2277 = /*#__PURE__*/React.createElement("path", {
    d: "M48 124h-1v-1h1z",
    fill: "#51564c",
    fillOpacity: 0.196
  })), _path2278 || (_path2278 = /*#__PURE__*/React.createElement("path", {
    d: "M48 124v-1h1v1z",
    fill: "#38392f",
    fillOpacity: 0.882
  })), _path2279 || (_path2279 = /*#__PURE__*/React.createElement("path", {
    d: "M50 124h-1v-1h1z",
    fill: "#3a3932"
  })), _path2280 || (_path2280 = /*#__PURE__*/React.createElement("path", {
    d: "M51 124h-1v-1h1z",
    fill: "#494843"
  })), _path2281 || (_path2281 = /*#__PURE__*/React.createElement("path", {
    d: "M52 123h1v1h-1z",
    fill: "#34332f"
  })), _path2282 || (_path2282 = /*#__PURE__*/React.createElement("path", {
    d: "M53 124v-1h1v1z",
    fill: "#282725"
  })), _path2283 || (_path2283 = /*#__PURE__*/React.createElement("path", {
    d: "M55 124v-1h1v1z",
    fill: "#110f0f"
  })), _path2284 || (_path2284 = /*#__PURE__*/React.createElement("path", {
    d: "M69 124v-1h1v1z",
    fill: "#131313"
  })), _path2285 || (_path2285 = /*#__PURE__*/React.createElement("path", {
    d: "M72 124h-1v-1h1z",
    fill: "#30302e"
  })), _path2286 || (_path2286 = /*#__PURE__*/React.createElement("path", {
    d: "M73 124h-1v-1h1z",
    fill: "#484846"
  })), _path2287 || (_path2287 = /*#__PURE__*/React.createElement("path", {
    d: "M73 124v-1h1v1z",
    fill: "#5d5d5b"
  })), _path2288 || (_path2288 = /*#__PURE__*/React.createElement("path", {
    d: "M74 123h1v1h-1z",
    fill: "#686867"
  })), _path2289 || (_path2289 = /*#__PURE__*/React.createElement("path", {
    d: "M75 124v-1h1v1z",
    fill: "#666664"
  })), _path2290 || (_path2290 = /*#__PURE__*/React.createElement("path", {
    d: "M77 123v1h-1v-1z",
    fill: "#5e5e5a"
  })), _path2291 || (_path2291 = /*#__PURE__*/React.createElement("path", {
    d: "M77 123h1v1h-1z",
    fill: "#555550"
  })), _path2292 || (_path2292 = /*#__PURE__*/React.createElement("path", {
    d: "M79 123h1v1h-1z",
    fill: "#262420",
    fillOpacity: 0.902
  })), _path2293 || (_path2293 = /*#__PURE__*/React.createElement("path", {
    d: "M81 124h-1v-1h1z",
    fill: "#3e3e3e",
    fillOpacity: 0.224
  })), _path2294 || (_path2294 = /*#__PURE__*/React.createElement("path", {
    d: "M49 125h-1v-1h1z",
    fill: "#373e37",
    fillOpacity: 0.145
  })), _path2295 || (_path2295 = /*#__PURE__*/React.createElement("path", {
    d: "M50 124v1h-1v-1z",
    fill: "#303029",
    fillOpacity: 0.62
  })), _path2296 || (_path2296 = /*#__PURE__*/React.createElement("path", {
    d: "M51 125h-1v-1h1z",
    fill: "#383733",
    fillOpacity: 0.902
  })), _path2297 || (_path2297 = /*#__PURE__*/React.createElement("path", {
    d: "M52 125h-1v-1h1z",
    fill: "#403f3a"
  })), _path2298 || (_path2298 = /*#__PURE__*/React.createElement("path", {
    d: "M53 124h1v1h-1z",
    fill: "#2b2a27"
  })), _path2299 || (_path2299 = /*#__PURE__*/React.createElement("path", {
    d: "M56 125h-1v-1h1z",
    fill: "#141310"
  })), _path2300 || (_path2300 = /*#__PURE__*/React.createElement("path", {
    d: "M56 125v-1h1v1z",
    fill: "#0d0c08"
  })), _path2301 || (_path2301 = /*#__PURE__*/React.createElement("path", {
    d: "M71 125h-1v-1h1z",
    fill: "#222220"
  })), _path2302 || (_path2302 = /*#__PURE__*/React.createElement("path", {
    d: "M71 125v-1h1v1z",
    fill: "#343432"
  })), _path2303 || (_path2303 = /*#__PURE__*/React.createElement("path", {
    d: "M73 124v1h-1v-1z",
    fill: "#444442"
  })), _path2304 || (_path2304 = /*#__PURE__*/React.createElement("path", {
    d: "M73 124h1v1h-1z",
    fill: "#4f4f4d"
  })), _path2305 || (_path2305 = /*#__PURE__*/React.createElement("path", {
    d: "M74 124h1v1h-1z",
    fill: "#50504c"
  })), _path2306 || (_path2306 = /*#__PURE__*/React.createElement("path", {
    d: "M75 124h1v1h-1z",
    fill: "#4a4b46"
  })), _path2307 || (_path2307 = /*#__PURE__*/React.createElement("path", {
    d: "M76 125v-1h1v1z",
    fill: "#43443f"
  })), _path2308 || (_path2308 = /*#__PURE__*/React.createElement("path", {
    d: "M78 125h-1v-1h1z",
    fill: "#373732",
    fillOpacity: 0.914
  })), _path2309 || (_path2309 = /*#__PURE__*/React.createElement("path", {
    d: "M78 125v-1h1v1z",
    fill: "#2b2a25",
    fillOpacity: 0.639
  })), _path2310 || (_path2310 = /*#__PURE__*/React.createElement("path", {
    d: "M79 124h1v1h-1z",
    fill: "#352f2f",
    fillOpacity: 0.169
  })), _path2311 || (_path2311 = /*#__PURE__*/React.createElement("path", {
    d: "M50 125h1v1h-1z",
    fill: "#312727",
    fillOpacity: 0.102
  })), _path2312 || (_path2312 = /*#__PURE__*/React.createElement("path", {
    d: "M52 125v1h-1v-1z",
    fill: "#1e1e18",
    fillOpacity: 0.325
  })), _path2313 || (_path2313 = /*#__PURE__*/React.createElement("path", {
    d: "M53 125v1h-1v-1z",
    fill: "#272721",
    fillOpacity: 0.537
  })), _path2314 || (_path2314 = /*#__PURE__*/React.createElement("path", {
    d: "M54 125v1h-1v-1z",
    fill: "#23231f",
    fillOpacity: 0.737
  })), _path2315 || (_path2315 = /*#__PURE__*/React.createElement("path", {
    d: "M54 126v-1h1v1z",
    fill: "#1c1c18",
    fillOpacity: 0.851
  })), _path2316 || (_path2316 = /*#__PURE__*/React.createElement("path", {
    d: "M55 126v-1h1v1z",
    fill: "#171614",
    fillOpacity: 0.933
  })), _path2317 || (_path2317 = /*#__PURE__*/React.createElement("path", {
    d: "M57 126h-1v-1h1z",
    fill: "#12110e",
    fillOpacity: 0.984
  })), _path2318 || (_path2318 = /*#__PURE__*/React.createElement("path", {
    d: "M60 125h1v1h-1z",
    fill: "#090906"
  })), _path2319 || (_path2319 = /*#__PURE__*/React.createElement("path", {
    d: "M71 126v-1h1v1z",
    fill: "#242422",
    fillOpacity: 0.992
  })), _path2320 || (_path2320 = /*#__PURE__*/React.createElement("path", {
    d: "M72 125h1v1h-1z",
    fill: "#2d2d2b",
    fillOpacity: 0.933
  })), _path2321 || (_path2321 = /*#__PURE__*/React.createElement("path", {
    d: "M73 126v-1h1v1z",
    fill: "#2f2f2d",
    fillOpacity: 0.859
  })), _path2322 || (_path2322 = /*#__PURE__*/React.createElement("path", {
    d: "M75 126h-1v-1h1z",
    fill: "#2d2e29",
    fillOpacity: 0.749
  })), _path2323 || (_path2323 = /*#__PURE__*/React.createElement("path", {
    d: "M75 125h1v1h-1z",
    fill: "#2d2f2a",
    fillOpacity: 0.545
  })), _path2324 || (_path2324 = /*#__PURE__*/React.createElement("path", {
    d: "M76 125h1v1h-1z",
    fill: "#282b25",
    fillOpacity: 0.345
  })), _path2325 || (_path2325 = /*#__PURE__*/React.createElement("path", {
    d: "M78 126h-1v-1h1z",
    fill: "#3b3b33",
    fillOpacity: 0.118
  })), _path2326 || (_path2326 = /*#__PURE__*/React.createElement("path", {
    d: "M55 126v1h-1v-1z",
    fill: "#3a3a3a",
    fillOpacity: 0.051
  })), _path2327 || (_path2327 = /*#__PURE__*/React.createElement("path", {
    d: "M55 126h1v1h-1z",
    fill: "#313131",
    fillOpacity: 0.122
  })), _path2328 || (_path2328 = /*#__PURE__*/React.createElement("path", {
    d: "M56 126h1v1h-1z",
    fill: "#202020",
    fillOpacity: 0.216
  })), _path2329 || (_path2329 = /*#__PURE__*/React.createElement("path", {
    d: "M57 127v-1h1v1z",
    fill: "#1f1f1b",
    fillOpacity: 0.29
  })), _path2330 || (_path2330 = /*#__PURE__*/React.createElement("path", {
    d: "M58 126h1v1h-1z",
    fill: "#191916",
    fillOpacity: 0.349
  })), _path2331 || (_path2331 = /*#__PURE__*/React.createElement("path", {
    d: "M59 126h1v1h-1z",
    fill: "#121210",
    fillOpacity: 0.427
  })), _path2332 || (_path2332 = /*#__PURE__*/React.createElement("path", {
    d: "M61 126v1h-1v-1z",
    fill: "#10100e",
    fillOpacity: 0.478
  })), _path2333 || (_path2333 = /*#__PURE__*/React.createElement("path", {
    d: "M61 126h1v1h-1z",
    fill: "#0f0f0f",
    fillOpacity: 0.502
  })), _path2334 || (_path2334 = /*#__PURE__*/React.createElement("path", {
    d: "M62 127v-1h1v1z",
    fill: "#11110f",
    fillOpacity: 0.51
  })), _path2335 || (_path2335 = /*#__PURE__*/React.createElement("path", {
    d: "M64 126v1h-1v-1z",
    fill: "#0d0d0b",
    fillOpacity: 0.533
  })), _path2336 || (_path2336 = /*#__PURE__*/React.createElement("path", {
    d: "M65 126v1h-1v-1z",
    fill: "#0d0d0d",
    fillOpacity: 0.529
  })), _path2337 || (_path2337 = /*#__PURE__*/React.createElement("path", {
    d: "M65 126h1v1h-1z",
    fill: "#11110f",
    fillOpacity: 0.502
  })), _path2338 || (_path2338 = /*#__PURE__*/React.createElement("path", {
    d: "M66 126h1v1h-1z",
    fill: "#101010",
    fillOpacity: 0.494
  })), _path2339 || (_path2339 = /*#__PURE__*/React.createElement("path", {
    d: "M67 127v-1h1v1z",
    fill: "#0f0f0f",
    fillOpacity: 0.467
  })), _path2340 || (_path2340 = /*#__PURE__*/React.createElement("path", {
    d: "M68 126h1v1h-1z",
    fill: "#131313",
    fillOpacity: 0.416
  })), _path2341 || (_path2341 = /*#__PURE__*/React.createElement("path", {
    d: "M69 127v-1h1v1z",
    fill: "#1a1a17",
    fillOpacity: 0.337
  })), _path2342 || (_path2342 = /*#__PURE__*/React.createElement("path", {
    d: "M71 127h-1v-1h1z",
    fill: "#1e1e1b",
    fillOpacity: 0.294
  })), _path2343 || (_path2343 = /*#__PURE__*/React.createElement("path", {
    d: "M72 126v1h-1v-1z",
    fill: "#23231e",
    fillOpacity: 0.227
  })), _path2344 || (_path2344 = /*#__PURE__*/React.createElement("path", {
    d: "M72 127v-1h1v1z",
    fill: "#272727",
    fillOpacity: 0.125
  })), _path2345 || (_path2345 = /*#__PURE__*/React.createElement("path", {
    d: "M74 127h-1v-1h1z",
    fill: "#363636",
    fillOpacity: 0.055
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWineBottle);
export default __webpack_public_path__ + "static/media/wine-bottle.8255235c15c45c34d652d0deb4b761a9.svg";
export { ForwardRef as ReactComponent };